webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountType = exports.MaxTimeOut = exports.transferData = exports.getInviteTitle = undefined;

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getInviteTitle = exports.getInviteTitle = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(that) {
    var params, callback, res;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(inviteTitle === '' && inviteRedirectFlag)) {
              _context.next = 11;
              break;
            }

            // 埋点统计：打开页面
            (0, _UploadWebEvent2.default)('VIEW', {
              type: checkWX()
            });
            params = {
              invite_token: that.$route.query['token'],
              language: browserLanguage()
            };

            callback = function callback(msg, status) {
              if (status !== '0') {
                that.$router.push({ path: '/invite/inviteerror' });
              } else {
                openApp(that.$route.query['token']);
              }
            };

            _context.next = 6;
            return (0, _Axios.post)('/proxy-api/client/web/index/verify-share-token-new', params, callback);

          case 6:
            res = _context.sent;

            // if (res.data.payload.type === 0) {
            //   inviteTitle = translate('inviteTitle0', res.data.payload.inviter, res.data.payload.app_name)
            // } else if (res.data.payload.type === 1) {
            //   inviteTitle = translate('inviteTitle1', res.data.payload.inviter, res.data.payload.dept)
            // } else if (res.data.payload.type === 3) {
            //   inviteTitle = translate('inviteTitle3', res.data.payload.group)
            // } else if (res.data.payload.type === 4) {
            //   inviteTitle = translate('Welcome to Crait')
            // }
            if (res.data.payload.type === 0) {
              inviteTitle = (0, _Translate2.default)('newInviteTitle0', res.data.payload.inviter, res.data.payload.app_name);
            } else if (res.data.payload.type === 1) {
              inviteTitle = (0, _Translate2.default)('newInviteTitle1', res.data.payload.inviter, res.data.payload.dept);
              inviteType = 3;
            } else if (res.data.payload.type === 3) {
              inviteTitle = (0, _Translate2.default)('newInviteTitle3', res.data.payload.group);
              inviteType = 2;
            } else if (res.data.payload.type === 4) {
              inviteTitle = (0, _Translate2.default)('Welcome to Crait');
            }
            inviteName = res.data.payload.inviter;
            inviteGroup = res.data.payload.group;
            inviteTeam = res.data.payload.dept;

          case 11:
            return _context.abrupt('return', inviteTitle);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getInviteTitle(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.changeTitle = changeTitle;
exports.browserLanguage = browserLanguage;
exports.checkDevice = checkDevice;
exports.checkWX = checkWX;
exports.checkIsChrome = checkIsChrome;
exports.isTablet = isTablet;
exports.checkEmpty = checkEmpty;
exports.checkInputAccount = checkInputAccount;
exports.checkEmail = checkEmail;
exports.checkPhone = checkPhone;
exports.checkUsername = checkUsername;
exports.getLocationHash = getLocationHash;
exports.getPublicKey = getPublicKey;
exports.getMD5 = getMD5;
exports.savePwd = savePwd;
exports.inviteRedirect = inviteRedirect;
exports.getInviteName = getInviteName;
exports.getInviteGroup = getInviteGroup;
exports.getInviteType = getInviteType;
exports.getInviteTeam = getInviteTeam;
exports.addOldUserName = addOldUserName;
exports.getInviteTitle2 = getInviteTitle2;

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _Crypto = __webpack_require__(187);

var _Crypto2 = _interopRequireDefault(_Crypto);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Axios = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import AppInfo from '../../appInfo/index'

function changeTitle() {}
// 不同的页面要修改为不同内容
// document.title = translate('title')
// document.title = AppInfo.getfirstUpperCaseAppName() + ' ' + translate('Sign in')


// 浏览器语言
function browserLanguage() {
  var lang = (window.navigator.language || window.navigator.browserLanguage).toLowerCase();
  var language = 'en-US';
  if (lang === 'zh-cn') {
    language = 'zh-CN';
  } else if (lang === 'zh-hk' || lang === 'zh-mo' || lang === 'zh-tw') {
    language = 'zh-hant';
  } else if (lang === 'es') {
    language = 'es–ES';
  } else if (lang === 'ru') {
    language = 'ru–RU';
  }
  return language;
};

// 检测登录设备是pc还是手机
function checkDevice() {
  var ua = navigator.userAgent;
  var isWindowsPhone = /(?:Windows Phone)/.test(ua);
  var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  var isAndroid = /(?:Android)/.test(ua);
  var isFireFox = /(?:Firefox)/.test(ua);
  var isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua);
  var isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  var isPc = !isPhone && !isAndroid && !isSymbian;
  return isPc;
};

function checkWX() {
  return (/micromessenger/.test(navigator.userAgent.toLowerCase())
  );
};

function checkIsChrome() {
  var ua = navigator.userAgent;
  // check pc.
  if (checkDevice() && ua.indexOf('Chrome') > -1) return true;
  // check mobile device.
  // eslint-disable-next-line no-useless-escape
  var chromeReg = new RegExp('\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?', 'i');
  return chromeReg.test(ua);
};

function isTablet() {
  var ua = navigator.userAgent;
  var isAndroid = /(?:Android)/.test(ua);
  var isFireFox = /(?:Firefox)/.test(ua);
  return (/(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua)
  );
}

// 判断输入是否为空
function checkEmpty(data) {
  if (data === '') {
    return false;
  } else {
    return true;
  }
};

// 检测账号逻辑
function checkInputAccount(account, callback, type, status) {
  if (checkEmail(account)) {
    // 判断输入的是不是邮箱，是邮箱则直接到下一步
    if (_config2.default.type === 'newInvite') {
      // 埋点统计：首页_开始安全通信 邮箱
      (0, _UploadWebEvent2.default)('REGISTER', {
        type: 0,
        result: status
      });
    }
    return true;
  } else if (/^[0-9]*$/.test(account)) {
    // 不是邮箱的情况下，判断是不是纯数字，纯数字即认为是手机号
    if (checkPhone(account)) {
      if (_config2.default.type === 'newInvite') {
        // 埋点统计：首页_开始安全通信 手机号
        (0, _UploadWebEvent2.default)('REGISTER', {
          type: 1,
          result: status
        });
      }
      return true;
    } else {
      // 纯数字且长度不满足手机号规则的，错误提示
      if (_config2.default.isLogin) {
        // 埋点统计：首个页面输入框手机号不合法
        (0, _UploadWebEvent2.default)('INVALID_PHONE', {
          type: type
        });
      } else if (_config2.default.type === 'invite') {
        // 埋点统计：首个页面输入框手机号不合法
        (0, _UploadWebEvent2.default)('INVITE_INVALID_PHONE', {
          type: type
        });
      }
      if (_config2.default.type === 'newInvite') {
        // 埋点统计：首页_开始安全通信 输入框手机号不合法
        (0, _UploadWebEvent2.default)('START', {
          type: 2
        });
      }
      callback('INVALID_PHONE');
      return false;
    }
  } else {
    // 不是邮箱也不是纯数字的情况下，认为是账号
    if (checkUsername(account)) {
      if (_config2.default.type === 'newInvite') {
        // 埋点统计：首页_开始安全通信 用户名
        (0, _UploadWebEvent2.default)('REGISTER', {
          type: 2,
          result: status
        });
      }
      return true;
    } else {
      if (_config2.default.isLogin) {
        // 埋点统计：首个页面输入框用户名不合法
        (0, _UploadWebEvent2.default)('INVALID_USERNAME', {
          type: type
        });
      } else if (_config2.default.type === 'invite') {
        // 埋点统计：首个页面输入框用户名不合法
        (0, _UploadWebEvent2.default)('INVITE_INVALID_USERNAME', {
          type: type
        });
      }
      if (!/^[a-zA-Z0-9_-]+$/.test(account)) {
        if (_config2.default.type === 'newInvite') {
          // 埋点统计：首页_开始安全通信 用户名包含特殊字符
          (0, _UploadWebEvent2.default)('START', {
            type: 4
          });
        }
        callback('INVALID_USERNAME_2');
        return false;
      } else if (!/^[a-zA-Z]{6,20}$/.test(account)) {
        if (_config2.default.type === 'newInvite') {
          // 埋点统计：首页_开始安全通信 用户名不以字母开始
          (0, _UploadWebEvent2.default)('START', {
            type: 3
          });
        }
        callback('INVALID_USERNAME_1');
        return false;
      }
    }
  }
};

// 检测邮箱格式
function checkEmail(data) {
  var emailReg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((\\-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\.|\\-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/;
  if (emailReg.test(data)) {
    return true;
  } else {
    return false;
  }
}

// 检测手机格式
function checkPhone(data) {
  var phoneReg = /^([\d]{5,20})$/;
  if (phoneReg.test(data)) {
    return true;
  } else {
    return false;
  }
};

// 检测用户名格式
function checkUsername(data) {
  var accountReg = /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/;
  if (accountReg.test(data)) {
    return true;
  } else {
    return false;
  }
};

// 获取路由
function getLocationHash() {
  return location.hash;
};

// 获取publickey
function getPublicKey(account) {
  return localStorage.getItem(account + '_publickey') || '';
};

// 获取md5
function getMD5(value) {
  var crypto = new _Crypto2.default();
  return crypto.getMD5(value);
};

function savePwd(obj, password) {
  var crypto = new _Crypto2.default();
  var md5 = crypto.getMD5(obj['public_key']) || getPublicKey(obj['account']);
  var pwd = crypto.aesEncrypt(md5, password || obj['password']);
  localStorage.setItem('sipPwd', pwd);
}

// 邀请页重定向跳转
var inviteRedirectFlag = true;
function inviteRedirect(that) {
  if (location.href.indexOf('token=') > 0) {
    if (location.href.length - location.href.indexOf('#/') === 2) {
      inviteRedirectFlag = false;
      var href = location.href.substring(0, location.href.indexOf('#/'));
      var arr = href.split('?');
      href = arr[0] + '#/?' + arr[1];
      location.href = href;
    }
  } else {
    that.$router.push({ path: '/invite/inviteerror' });
  }
};

// 获取邀请页title
var inviteTitle = '';
var inviteName = '';
var inviteGroup = '';
var inviteTeam = '';
var inviteType = 1;
function getInviteName() {
  return inviteName;
}

function getInviteGroup() {
  return inviteGroup;
}

function getInviteType() {
  return inviteType;
}
function getInviteTeam() {
  return inviteTeam;
}

var oldUserName = '';
function addOldUserName(name) {
  oldUserName = name;
}

function getInviteTitle2() {
  return 'Crait用户“' + oldUserName + '”您好，请输入密码以接受邀请';
}

// 判断如果本地已经安装了app，则打开app
function openApp(token) {
  if (navigator.userAgent.indexOf('Android') > -1) {
    var url = 'batchatnew://?cmd=login&token=' + token;
    var iframe = document.createElement('iframe');
    var body = document.body;
    iframe.style.cssText = 'display:none;width=0;height=0';
    body.appendChild(iframe);
    iframe.src = url;
    if (navigator.userAgent.indexOf('Chrome') > -1) {
      location.href = url;
    }
  }
}

// 路由之间传递数据
var transferData = exports.transferData = {
  data: {},
  saveData: function saveData(data) {
    this.data = data;
  },
  getData: function getData() {
    return JSON.parse((0, _stringify2.default)(this.data));
  },
  deleteData: function deleteData() {
    this.data = {};
  }
};

// indify code get max time.
var MaxTimeOut = exports.MaxTimeOut = 59;

var accountType = exports.accountType = {
  PHONE_TYPE: 1,
  EMAIL_TYPE: 2
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  "data-v-b68de7c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  "data-v-6b6c66e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(61);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _Common = __webpack_require__(7);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translate = function () {
  function Translate() {
    (0, _classCallCheck3.default)(this, Translate);

    this.key = '';
    this.val = [];
  }

  (0, _createClass3.default)(Translate, [{
    key: 'translate',
    value: function translate(key) {
      for (var _len = arguments.length, val = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        val[_key - 1] = arguments[_key];
      }

      return language(key, val);
    }
  }]);
  return Translate;
}();
// let appName = AppInfo.getAppName()


var appNameFirstUppercase = _index2.default.getfirstUpperCaseAppName();
function language(key, val) {
  var EN_US = {
    'title': appNameFirstUppercase + ' Invitation',
    'inviteTitle0': 'Your friend ' + val[0] + ' invites you to join ' + val[1],
    'inviteTitle1': 'Your friend ' + val[0] + ' invites you to join ' + val[1],
    'inviteTitle3': 'You are invited to join group: ' + val[0],
    'newInviteTitle0': val[0] + ' is using crait, join now !',
    'newInviteTitle1': val[0] + ' is using crait, join now !',
    'newInviteTitle3': 'You have joined secure group chat "' + val[0] + '"',
    'newInviteTitle4': 'Dear Crait user "' + val[0] + '", please enter your password to accept invitation',
    'newInviteTitle5': 'You and \u201C' + val[0] + '\u201D have been connected',
    'newInviteTitle6': 'You have joined group chat "' + val[0] + '"',
    'newInviteTitle7': 'Dear Crait user "' + val[0] + '", please enter your password to register',
    'newInviteTitle8': 'You have joined the team \u201C' + val[0] + '\u201D',
    'Account registered. Welcome to Crait!': 'Account registered. Welcome to Crait!',
    'Welcome to Crait': 'Welcome to Crait, a secure and private messaging app',
    'Your email': 'Your email',
    'Your email, phone number or username': 'Your email, phone number or username',
    'Sign in': 'Sign in',
    'Name': 'Name',
    'Password': 'Password',
    'New password': 'New password',
    'Verification code': 'Verification code',
    'Continue': 'Continue',
    'Join': 'Join',
    'Next': 'Next',
    'Back': 'Back',
    'Done': 'Done',
    'Open Crait': 'Open Crait',
    'Open/Download Crait': 'Open/Download Crait',
    'Download Crait': 'Install Crait Now',
    'Go to sign up page': 'Go to sign up page',
    'You have joined Crait': 'You have joined Crait',
    'By registering, you agree to the ': 'By registering, you agree to the ',
    'User agreement': 'User agreement',
    'Send Code': 'Send Code',
    'Sorry, the password you inputted is empty.': 'Sorry, the password you inputted is empty.',
    'Sorry, the input is empty.': 'Sorry, the input is empty.',
    'Sorry, the name you inputted is empty.': 'Sorry, the name you inputted is empty.',
    'Sorry, the code you inputted is empty.': 'Sorry, the code you inputted is empty.',
    'Sorry, the phone number you inputted is invalid.': 'Sorry, the phone number you inputted is invalid.',
    'The username need to start with a letter and comprise 6-20 characters.': 'The username need to start with a letter and comprise 6-20 characters.',
    'The username only support two special characters: - and _': 'The username only support two special characters: - and _',
    'The password needs to have more than 6 letters': 'The password needs to have more than 6 letters',
    'inviteErrorText1': 'Sorry, the link has expired',
    'inviteErrorText2': 'You can ask the inviter to send you another invite link or click the button below to sign up yourself.',
    'inviteErrorText3': 'There are two possible causes for this problem',
    'inviteErrorText4': ' · The link was generated more than 7 days ago',
    'inviteErrorText5': ' · The URL of the link is incomplete',
    'Skip and verify later': 'Skip and verify later',
    'Enter email, phone or username to accept': 'Enter email, phone or username to accept',
    'Enter email, phone or username to register': 'Enter email, phone or username to register',
    'Start secure messaging': 'Join',
    'Accept': 'Accept',
    'Open in App': 'Open in App',
    'Your password': 'Your password',
    'Login to Crait with this account to start messaging': 'Open the app and sign in with the account to get started',
    'Not your account? ': 'Not your account? ',
    'Switch': 'Switch',
    'Tap': 'Tap',
    'icon in the top right corner': 'icon in the top right corner',
    'Click': 'Click',
    'open in browser': 'open in browser',
    'input your mobile number or email here': 'input your mobile number or email here',
    'Scan the QR code to sign in': 'Scan the QR code to sign in',
    'remember password': 'remember password',
    'Forgot password': 'Forgot password',
    'Low version notice': 'The current version is too low to use. Please download the latest version from the official website.'
  };
  var ZH_CN = {
    'title': 'Crait邀请',
    'inviteTitle0': '\u60A8\u7684\u670B\u53CB' + val[0] + '\u9080\u8BF7\u4F60\u52A0\u5165' + val[1],
    'inviteTitle1': '\u60A8\u7684\u670B\u53CB' + val[0] + '\u9080\u8BF7\u4F60\u52A0\u5165' + val[1],
    'inviteTitle3': '\u60A8\u88AB\u9080\u8BF7\u52A0\u5165\u7FA4\uFF1A' + val[0],
    'newInviteTitle0': val[0] + ' \u6B63\u5728\u4F7F\u7528Crait\uFF0C\u8D76\u5FEB\u52A0\u5165\u5427',
    'newInviteTitle1': val[0] + ' \u6B63\u5728\u4F7F\u7528Crait\uFF0C\u8D76\u5FEB\u52A0\u5165\u5427',
    'newInviteTitle3': '\u52A0\u5BC6\u3001\u5B89\u5168\u7684Crait\u7FA4\u804A\u201C' + val[0] + '\u201D\u9080\u8BF7\u60A8\u52A0\u5165',
    'newInviteTitle4': 'Crait\u7528\u6237\u201C' + val[0] + '\u201D\u60A8\u597D\uFF0C\u8BF7\u8F93\u5165\u5BC6\u7801\u4EE5\u63A5\u53D7\u9080\u8BF7',
    'newInviteTitle5': '\u60A8\u4E0E\u201C' + val[0] + '\u201D\u5DF2\u6210\u4E3A\u597D\u53CB',
    'newInviteTitle6': '\u4F60\u5DF2\u52A0\u5165\u7FA4\u804A \u201C' + val[0] + '\u201D',
    'newInviteTitle7': 'Crait\u7528\u6237\u201C' + val[0] + '\u201D\u60A8\u597D\uFF0C\u8BF7\u8BF7\u8F93\u5165\u5BC6\u7801\u4EE5\u6CE8\u518C\u8D26\u53F7',
    'newInviteTitle8': '\u60A8\u5DF2\u52A0\u5165\u201C' + val[0] + '\u201D\u56E2\u961F',
    'Welcome to Crait': '欢迎使用Crait，一款安全、私密的聊天与协作工具',
    'Account registered. Welcome to Crait!': '注册成功，欢迎使用Crait！',
    'Your email': '请输入邮箱',
    'Your email, phone number or username': '请输入邮箱，手机号或用户名',
    'Sign in': '登录',
    'Name': '姓名',
    'Password': '密码',
    'New password': '密码',
    'Verification code': '验证码',
    'Continue': '继续',
    'Join': '加入',
    'Next': '下一步',
    'Back': '返回',
    'Done': '完成',
    'Open Crait': '打开 Crait',
    'Open/Download Crait': '打开/下载 Crait',
    'Download Crait': '立即安装Crait',
    'Go to sign up page': '前往注册页',
    'You have joined Crait': '你已加入 Crait',
    'By registering, you agree to the ': '注册即代表您同意 ',
    'User agreement': 'Crait用户协议',
    'Send Code': '获取验证码',
    'Sorry, the password you inputted is empty.': '抱歉，您输入的密码为空',
    'Sorry, the input is empty.': '抱歉，输入框为空',
    'Sorry, the name you inputted is empty.': '抱歉，您输入的姓名为空',
    'Sorry, the code you inputted is empty.': '抱歉，您输入的验证码为空',
    'Sorry, the phone number you inputted is invalid.': '抱歉，您输入的手机号有误',
    'The username need to start with a letter and comprise 6-20 characters.': '用户名需要以字母开始，长度在6-20个字符之间',
    'The username only support two special characters: - and _': '用户名仅支持这两个特殊字符：- 和 _',
    'The password needs to have more than 6 letters': '密码需长于6个字符',
    'inviteErrorText1': '抱歉，该邀请链接已失效',
    'inviteErrorText2': '您可以再从邀请人处获取一个邀请链接，或者点击下方按钮直接注册',
    'inviteErrorText3': '有两个原因可能导致这个问题',
    'inviteErrorText4': ' · 该链接是超过7天前生成的',
    'inviteErrorText5': ' · 该链接地址不完整',
    'Skip and verify later': '稍后验证',
    'Enter email, phone or username to accept': '请输入手机号、邮箱或用户名接受邀请',
    'Enter email, phone or username to register': '请输入手机号、邮箱或用户名注册账号',
    'Start secure messaging': '加入',
    'Accept': '接受邀请',
    'Open in App': 'App內打开',
    'Your password': '请输入您的密码',
    'Login to Crait with this account to start messaging': '打开app登录该账号即可开始使用',
    'Not your account? ': '不是你的账号？',
    'Switch': '点击切换',
    'Tap': '点击',
    'icon in the top right corner': '右上角的按钮',
    'Click': '点击',
    'open in browser': '在浏览器打开',
    'input your mobile number or email here': '请输入手机号、邮箱',
    // new device indify text.
    'indentifyTitile': '新设备验证', // translate('indentifyTitile')
    'indentifyDescription': '系统检测到你在新设备登录，为了保障你的账号安全，请验证身份',
    'useEmailTip': '使用邮箱',
    'usePhoneTip': '使用手机',
    'inputCodeTip': '输入4位邮箱验证码',
    'timerDecTip': '后',
    'getCodeButtonTip': '获取验证码',
    'regetCode': '重发验证码',
    'needHelpTip': '需要帮助',
    'helpTip': '验证身份遇到问题？你可以发邮件至 support@crait.com 获取帮助！',
    'sure': '好的',
    'verifyButton': '验证',
    'Scan the QR code to sign in': '使用' + appNameFirstUppercase + '手机版扫描二维码登录',
    'remember password': '记住密码',
    'Forgot password': '忘记密码',
    'Low version notice': '当前版本过低无法使用，请至 https://vanish.myhexin.com 下载最新版本。'
  };
  var ZH_TD = {
    'title': 'Crait邀請',
    'newInviteTitle0': val[0] + ' \u6B63\u5728\u4F7F\u7528Crait\uFF0C\u8D95\u5FEB\u52A0\u5165\u5427',
    'newInviteTitle1': val[0] + ' \u6B63\u5728\u4F7F\u7528Crait\uFF0C\u8D95\u5FEB\u52A0\u5165\u5427',
    'newInviteTitle3': '\u60A8\u5DF2\u52A0\u5165\u5B89\u5168\u7FA4\u804A\u201C' + val[0] + '\u201D',
    'newInviteTitle4': 'Crait\u7528\u6236\u201C' + val[0] + '\u201D\u60A8\u597D\uFF0C\u8ACB\u8F38\u5165\u5BC6\u78BC\u4EE5\u63A5\u53D7\u9080\u8ACB',
    'newInviteTitle5': '\u60A8\u8207\u201C' + val[0] + '\u201D\u5DF2\u6210\u70BA\u597D\u53CB',
    'newInviteTitle6': '\u4F60\u5DF2\u52A0\u5165\u7FA4\u804A\u201C' + val[0] + '\u201D',
    'newInviteTitle7': 'Crait\u7528\u6236\u201C' + val[0] + '\u201D\u60A8\u597D\uFF0C\u8ACB\u8F38\u5165\u5BC6\u78BC\u4EE5\u8A3B\u518A\u5E33\u865F',
    'newInviteTitle8': '\u60A8\u5DF2\u52A0\u5165\u201C' + val[0] + '\u201D\u5718\u968A',
    'Account registered. Welcome to Crait!': '注册成功，歡迎使用Crait！',
    'Welcome to Crait': '歡迎使用Crait，一款安全、私密的聊天與協作工具',
    'Sorry, the password you inputted is empty': '抱歉，您輸入的密碼為空',
    'Sorry, the input is empty.': '抱歉，輸入框為空',
    'Sorry, the name you inputted is empty.': '抱歉，您輸入的姓名為空',
    'Sorry, the code you inputted is empty.': '抱歉，您輸入的驗證碼為空',
    'Sorry, the phone number you inputted is invalid.': '抱歉，您輸入的手機號有誤',
    'The username need to start with a letter and comprise 6-20 characters.': '用戶名需要以字母開始，長度在6-20個字符之間',
    'The username only support two special characters: - and _': '用戶名僅支持這兩個特殊字元：-和_',
    'The password needs to have more than 6 letters': '密碼需長於6個字元',
    'inviteErrorText1': '抱歉，該邀請連結已失效',
    'inviteErrorText2': '您可以再從邀請人處獲取一個邀請連結，或者點擊下方按鈕直接注册',
    'inviteErrorText3': '有兩個原因可能導致這個問題',
    'inviteErrorText4': ' · 該連結是超過7天前生成的',
    'inviteErrorText5': ' · 該連結位址不完整',
    'Open/Download Crait': '下載/打開 Crait',
    'Download Crait': '立即安裝Crait',
    'Go to sign up page': '前往註冊頁',
    'Enter email, phone or username to accept': '請輸入手機號、郵箱或用戶名接受邀請',
    'Enter email, phone or username to register': '請輸入手機號、郵箱或用戶名註冊帳號',
    'Start secure messaging': '加入',
    'Accept': '接受邀請',
    'Open in App': 'App中打開',
    'Your password': '請輸入您的密碼',
    'Login to Crait with this account to start messaging': '打開app登錄該賬號即可開始使用',
    'Not your account? ': '不是你的賬號？',
    'Switch': '點擊切換',
    'Tap': '點擊',
    'icon in the top right corner': '右上角的按鈕',
    'Click': '點擊',
    'open in browser': '在瀏覽器打開',
    'input your mobile number or email here': '請輸入手機號、郵箱',
    'Low version notice': '当前版本过低无法使用，请至 https://vanish.myhexin.com 下载最新版本。'
  };
  var ES = {
    'title': 'Crait Invitación',
    'newInviteTitle0': val[0] + ' est\xE1 usando crait, \xFAnete ahora',
    'newInviteTitle1': val[0] + ' est\xE1 usando crait, \xFAnete ahora',
    'newInviteTitle3': 'El chat de grupo privado seguro "' + val[0] + '" lo invit\xF3 a unirse',
    'newInviteTitle4': 'Estimado usuario de Crait "' + val[0] + '", ingrese su contrase\xF1a para aceptar la invitaci\xF3n',
    'newInviteTitle5': '\u0412\u044B \u0438 "' + val[0] + '" \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u044B',
    'newInviteTitle6': 'Te has unido al chat grupal "' + val[0] + '"',
    'newInviteTitle7': 'Estimado usuario de Crait "' + val[0] + '", por favor ingrese su contrase\xF1a para registrarse',
    'newInviteTitle8': 'Te has unido al equipo \u201C' + val[0] + '\u201D',
    'Account registered. Welcome to Crait!': 'Cuenta registrada.¡Bienvenido a crait!',
    'Welcome to Crait': 'Bienvenido a Crait, una aplicación de mensajería segura y privada',
    'Sorry, the password you inputted is empty': 'Lo siento, la contraseña introducida es vacio',
    'Sorry, the input is empty.': 'Lo siento, la entrada está vacía.',
    'Sorry, the name you inputted is empty.': ' Lo siento, el nombre que introdujo esta vacia.',
    'Sorry, the code you inputted is empty.': 'Lo siento, el código que introduciste está vacío.',
    'Sorry, the phone number you inputted is invalid.': 'Lo siento, el numero de telefono introducido no es válido.',
    'The username need to start with a letter and comprise 6-20 characters.': 'El nombre de usuario debe comenzar con una letra y comprenden 6 - 20 caracteres.',
    'The username only support two special characters: - and _': 'El nombre de usuario solo de Apoyo de dos caracteres especiales: - y _',
    'The password needs to have more than 6 letters': ' La contraseña debe tener mas de 6 letras',
    'inviteErrorText1': 'Lo siento, el enlace ha caducado',
    'inviteErrorText2': 'Usted puede pedir el invitador para otro enlace de invitacion, o haga clic en el boton de abajo para registrarse primero',
    'inviteErrorText3': 'Hay dos posibles causas para este problema',
    'inviteErrorText4': ' · La referencia fue generado hace mas de 7 dias',
    'inviteErrorText5': ' · La dirección de enlace no es completa',
    'Open/Download Crait': 'Descargar / Abrir Crait',
    'Download Crait': 'Instala Crait ahora',
    'Go to sign up page': 'Ir a la página de registro',
    'Enter email, phone or username to accept': 'Ingrese el correo electrónico, el teléfono o la contraseña para aceptar la invitación',
    'Enter email, phone or username to register': 'Introduzca el correo electrónico, teléfono o contraseña para registrarse',
    'Start secure messaging': 'Unirse',
    'Accept': 'Aceptar',
    'Open in App': 'abra en la aplicación',
    'Your password': 'Tu contraseña',
    'Login to Crait with this account to start messaging': 'Abra la aplicación e inicie sesión en la cuenta para comenzar',
    'Not your account? ': 'No es tu cuenta? ',
    'Switch': 'Cambiar',
    'Tap': 'Toque',
    'icon in the top right corner': 'icono en la esquina superior derecha',
    'Click': 'Haga clic',
    'open in browser': 'abrir en el navegador',
    'input your mobile number or email here': 'ingrese su número de móvil o correo electrónico aquí',
    'Low version notice': 'The current version is too low to use. Please download the latest version from the official website.'
  };
  var RU = {
    'title': 'Crait приглашение',
    'newInviteTitle0': val[0] + ' \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 crait, \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u0441\u0435\u0439\u0447\u0430\u0441',
    'newInviteTitle1': val[0] + ' \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 crait, \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u0441\u0435\u0439\u0447\u0430\u0441',
    'newInviteTitle3': '\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u044B\u0439 \u0433\u0440\u0443\u043F\u043F\u043E\u0432\u043E\u0439 \u0447\u0430\u0442 \xAB' + val[0] + '\xBB \u043F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u043B \u0432\u0430\u0441 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F',
    'newInviteTitle4': '\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C Crait \xAB' + val[0] + '\xBB, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043F\u0430\u0440\u043E\u043B\u044C, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435',
    'newInviteTitle5': 'Usted y "' + val[0] + '" han sido conectados',
    'Account registered. Welcome to Crait!': 'счет зарегистрирован.добро пожаловать в crait!',
    'newInviteTitle6': '\u0412\u044B \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0438\u0441\u044C \u043A \u0433\u0440\u0443\u043F\u043F\u043E\u0432\u043E\u043C\u0443 \u0447\u0430\u0442\u0443 \xAB' + val[0] + '\xBB',
    'newInviteTitle7': '\u0423\u0432\u0430\u0436\u0430\u0435\u043C\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C Crait \xAB' + val[0] + '\xBB, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438',
    'newInviteTitle8': 'T\u0412\u044B \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0438\u0441\u044C \u043A \u043A\u043E\u043C\u0430\u043D\u0434\u0435 \u201C' + val[0] + '\u201D',
    'Welcome to Crait': 'Добро пожаловать в Crait, приложение для безопасного и частного обмена сообщениями',
    'Sorry, the password you inputted is empty': 'прости, пароль, введенных пуста',
    'Sorry, the input is empty.': 'прости, вклад пуст.',
    'Sorry, the name you inputted is empty.': 'прости, как ты ввел пуст.',
    'Sorry, the code you inputted is empty.': 'прости, ты ввел кодекс пуст.',
    'Sorry, the phone number you inputted is invalid.': 'прости, номер телефона, на который ты ввел неверный.',
    'The username need to start with a letter and comprise 6-20 characters.': 'имя нужно начать с письмом и составляют 20 персонажей',
    'The username only support two special characters: - and _': 'имя только в поддержку двух специальных символов: - и _',
    'The password needs to have more than 6 letters': 'пароль должен иметь больше, чем 6 букв',
    'inviteErrorText1': 'прости, связь которых истек',
    'inviteErrorText2': 'вы можете спросить inviter еще предложить ссылку, или нажмите кнопку ниже, чтобы зарегистрироваться',
    'inviteErrorText3': 'есть два возможных причин этой проблемы,',
    'inviteErrorText4': ' · связь было подготовлено более 7 дней назад',
    'inviteErrorText5': ' · связь решения еще не завершена',
    'Open/Download Crait': 'Скачать / открыто Crait',
    'Download Crait': 'Установите Crait Now',
    'Go to sign up page': 'Перейти на страницу регистрации',
    'Enter email, phone or username to accept': 'Введите адрес электронной почты, телефон или пароль, чтобы принять приглашение',
    'Enter email, phone or username to register': 'введите адрес электронной почты, по телефону или пароль для регистрации',
    'Start secure messaging': 'Присоединиться',
    'Accept': 'принимать',
    'Open in App': 'откройте приложение',
    'Your password': 'Ваш пароль',
    'Login to Crait with this account to start messaging': 'Откройте приложение и войдите в учетную запись, чтобы начать',
    'Not your account? ': 'Не ваша учетная запись? ',
    'Switch': 'переключатель',
    'Tap': 'Нажмите',
    'icon in the top right corner': 'значок в правом верхнем углу',
    'Click': 'Нажмите',
    'open in browser': 'открыть в браузере',
    'input your mobile number or email here': 'введите номер мобильного телефона или адрес электронной почты здесь',
    'Low version notice': 'The current version is too low to use. Please download the latest version from the official website.'
  };
  if ((0, _Common.browserLanguage)() === 'zh-CN') {
    return ZH_CN[key];
  } else if ((0, _Common.browserLanguage)() === 'zh-hant') {
    return ZH_TD[key];
  } else if ((0, _Common.browserLanguage)() === 'es–ES') {
    return ES[key];
  } else if ((0, _Common.browserLanguage)() === 'ru–RU') {
    return RU[key];
  } else {
    return EN_US[key];
  }
}

exports.default = new Translate().translate;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(61);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _appinfo = __webpack_require__(280);

var _appinfo2 = _interopRequireDefault(_appinfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// if you want to change app, you should to remove the comment.
var AppInfo = function () {
  function AppInfo() {
    (0, _classCallCheck3.default)(this, AppInfo);

    this.appName = '';
    this.appIcon = '';
    this.backgroundImg = '';
    this.appVersion = '';
    this.genericVersion = true;
    this.init();
  }

  (0, _createClass3.default)(AppInfo, [{
    key: 'init',
    value: function init() {
      this.appName = _appinfo2.default.appName;
      this.appVersion = _appinfo2.default.appVersion;
      this.genericVersion = _appinfo2.default.isGenericVersion;
      this.appIcon = _appinfo2.default.appIcon;
      this.backgroundImg = _appinfo2.default.backgroundImg;
    }
  }, {
    key: 'getfirstUpperCaseAppName',
    value: function getfirstUpperCaseAppName() {
      return this.appName.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
        return L.toUpperCase();
      });
    }
  }, {
    key: 'getAppName',
    value: function getAppName() {
      return this.appName;
    }
  }, {
    key: 'getAppIcon',
    value: function getAppIcon() {
      return this.appIcon;
    }
  }, {
    key: 'getBackgroundImg',
    value: function getBackgroundImg() {
      return this.backgroundImg;
    }
  }, {
    key: 'getAppVersion',
    value: function getAppVersion() {
      return this.appVersion;
    }
  }, {
    key: 'isGenericVersion',
    value: function isGenericVersion() {
      return this.genericVersion;
    }
  }]);
  return AppInfo;
}(); // import appinfo from './crait/appinfo'
// import appinfo from './sectone/appinfo'


exports.default = new AppInfo();

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  "data-v-0aed068d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorFn = undefined;

var _classCallCheck2 = __webpack_require__(61);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorFn = function () {
  function ErrorFn() {
    (0, _classCallCheck3.default)(this, ErrorFn);

    this.errorTip = {
      EMPTY_PASSWORD: (0, _Translate2.default)('Sorry, the password you inputted is empty.'),
      EMPTY_ACCOUNT: (0, _Translate2.default)('Sorry, the input is empty.'),
      EMPTY_NAME: (0, _Translate2.default)('Sorry, the name you inputted is empty.'),
      EMPTY_CODE: (0, _Translate2.default)('Sorry, the code you inputted is empty.'),
      INVALID_PHONE: (0, _Translate2.default)('Sorry, the phone number you inputted is invalid.'),
      INVALID_USERNAME_1: (0, _Translate2.default)('The username need to start with a letter and comprise 6-20 characters.'),
      INVALID_USERNAME_2: (0, _Translate2.default)('The username only support two special characters: - and _'),
      INVALID_PASSWORD: (0, _Translate2.default)('The password needs to have more than 6 letters')
    };
  }

  (0, _createClass3.default)(ErrorFn, [{
    key: 'openErrorTip',
    value: function openErrorTip(msg, that) {
      if (this.errorTip[msg]) {
        that.errorMsg = this.errorTip[msg];
      } else {
        that.errorMsg = msg;
      }
      that.errorShow = true;
    }
  }, {
    key: 'closeErrorTip',
    value: function closeErrorTip(that) {
      that.errorMsg = '';
      that.errorShow = false;
    }
  }]);
  return ErrorFn;
}();

var errorFn = exports.errorFn = new ErrorFn();

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uploadWebEvent;

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 埋点统计公用方法
var uid = Math.random().toString().slice(-8);
var uploadWebEventFn = function uploadWebEventFn(eid, r, type, result) {
  var params = {
    uid: uid,
    eid: eid
  };
  if (r) {
    params['r'] = r;
  }
  if (type !== '' && type !== void 0) {
    params['type'] = type;
  }
  if (result !== '' && result !== void 0) {
    params['result'] = result;
  }
  _axios2.default.get('/proxy-api/dpadmin/uploadWebEvent.php', { params: params });
};

function uploadWebEvent(type, params) {
  var fn = {
    // 注册页面输入并跳转到下一页面
    'SIGNUP_INPUT_NEXT': function SIGNUP_INPUT_NEXT(params) {
      if (params.type === 0) {
        uploadWebEventFn('0000200'); // 埋点统计：注册页面输入并跳转到邮箱注册页面
      } else if (params.type === 1) {
        uploadWebEventFn('0000000'); // 埋点统计：注册页面输入并跳转到手机号注册页面
      } else if (params.type === 2) {
        uploadWebEventFn('0000100'); // 埋点统计：注册页面输入并跳转到用户名注册页面
      }
    },
    // 注册页面返回上一步
    'SIGNUP_BACK': function SIGNUP_BACK(params) {
      if (params.type === 0) {
        uploadWebEventFn('0000220'); // 埋点统计：邮箱注册密码输入页返回上一步
      } else if (params.type === 1) {
        uploadWebEventFn('0000020'); // 埋点统计：手机号注册姓名密码页返回上一步
      } else if (params.type === 2) {
        uploadWebEventFn('0000120'); // 埋点统计：用户名注册密码输入页返回上一步
      } else if (params.type === 3) {
        uploadWebEventFn('0000050'); // 埋点统计：手机号注册输入验证码页面返回上一步
      }
    },
    // 注册密码完成页输入错误
    'SIGNUPNEXT_DONE_ERROR': function SIGNUPNEXT_DONE_ERROR(params) {
      if (params.type === 0) {
        uploadWebEventFn('0000230'); // 埋点统计：邮箱注册密码输入页密码输入错误
      } else if (params.type === 1) {
        uploadWebEventFn('0000060'); // 埋点统计：手机号注册输入验证码页面输入错误
      } else if (params.type === 2) {
        uploadWebEventFn('0000130'); // 埋点统计：用户名注册密码输入页密码输入错误
      }
    },
    // 手机号注册姓名密码页点击下一步
    'SIGNUPNEXT_PHONE_NEXT': function SIGNUPNEXT_PHONE_NEXT() {
      uploadWebEventFn('0000010'); // 埋点统计：手机号注册姓名密码页点击下一步
    },
    // 手机号注册姓名密码页提示输入错误
    'SIGNUPNEXT_PHONE_ERROR': function SIGNUPNEXT_PHONE_ERROR() {
      uploadWebEventFn('0000030'); // 埋点统计：手机号注册姓名密码页提示输入错误
    },
    // 手机号注册输入验证码页面切换国别码
    'SIGNUP_PHONE_COUNTRYCODE': function SIGNUP_PHONE_COUNTRYCODE() {
      uploadWebEventFn('0000070'); // 埋点统计：手机号注册输入验证码页面切换国别码
    },
    // 注册结果
    'SIGNUP_RESULT': function SIGNUP_RESULT(params) {
      if (params.type === 0) {
        uploadWebEventFn('0000240', params.status); // 埋点统计：邮箱注册结果
      } else if (params.type === 1) {
        uploadWebEventFn('0000080', params.status); // 埋点统计：手机注册结果
      } else if (params.type === 2) {
        uploadWebEventFn('0000140', params.status); // 埋点统计：用户名注册结果
      } else if (params.from === 'verifyLater') {
        uploadWebEventFn('0000090', params.status); // 埋点统计：稍后验证注册结果
      }
    },
    // 注册页面提示账号已存在
    'SIGNUP_ACCOUNT_EXIST': function SIGNUP_ACCOUNT_EXIST() {
      uploadWebEventFn('0000300'); // 埋点统计：注册页面提示账号已存在
    },
    // 从账号已存在提示跳转到登录页面
    'SIGNUP_ACCOUNT_EXIST_TO_SIGNIN': function SIGNUP_ACCOUNT_EXIST_TO_SIGNIN() {
      uploadWebEventFn('0000310'); // 埋点统计：从账号已存在提示跳转到登录页面
    },
    // 首个页面输入框手机号不合法
    'INVALID_PHONE': function INVALID_PHONE(params) {
      if (params.type === 'signup') {
        uploadWebEventFn('0000510'); // 埋点统计：注册页面首个输入框手机号不合法
      } else if (params.type === 'signin') {
        uploadWebEventFn('0010810'); // 埋点统计：登录页面首个输入框手机号不合法
      }
    },
    // 首个页面输入框用户名不合法
    'INVALID_USERNAME': function INVALID_USERNAME(params) {
      if (params.type === 'signup') {
        uploadWebEventFn('0000500'); // 埋点统计：注册页面首个输入框用户名不合法
      } else if (params.type === 'signin') {
        uploadWebEventFn('0010800'); // 埋点统计：登录页面首个输入框用户名不合法
      }
    },
    // 登录页面输入强制跳转到扫码
    'SIGNIN_INPUT_TO_SCAN': function SIGNIN_INPUT_TO_SCAN(params) {
      if (params.type === 0) {
        uploadWebEventFn('0010302'); // 埋点统计：登录页面输入邮箱强制跳转到扫码
      } else if (params.type === 1) {
        uploadWebEventFn('0010102'); // 埋点统计：登录页面输入手机号强制跳转到扫码
      } else if (params.type === 2) {
        uploadWebEventFn('0010202'); // 埋点统计：登录页面输入用户名强制跳转到扫码
      }
    },
    // 登录页面输入强制跳转到下一步登录
    'SIGNIN_INPUT_TO_NEXT': function SIGNIN_INPUT_TO_NEXT(params) {
      if (params.type === 0) {
        uploadWebEventFn('0010300'); // 埋点统计：登录页面输入并跳转到邮箱登录
      } else if (params.type === 1) {
        uploadWebEventFn('0010100'); // 埋点统计：登录页面输入并跳转到手机号登录
      } else if (params.type === 2) {
        uploadWebEventFn('0010200'); // 埋点统计：登录页面输入并跳转到用户名登录
      }
    },
    // 登录扫码登录结果
    'SIGNIN_SCAN_RESULT': function SIGNIN_SCAN_RESULT(params) {
      // if (params.type === 0) {
      //   uploadWebEventFn('0010303', params.status) // 埋点统计：邮箱登录扫码登录结果
      // } else if (params.type === 1) {
      //   uploadWebEventFn('0010103', params.status) // 埋点统计：手机号登录扫码登录结果
      // } else if (params.type === 2) {
      //   uploadWebEventFn('0010203', params.status) // 埋点统计：用户名登录扫码登录结果
      // }
      uploadWebEventFn('0010401', params.status); // 登录扫码登录结果
    },
    // 登录输入密码登录结果
    'SIGNIN_PASSWORD_RESULT': function SIGNIN_PASSWORD_RESULT(params) {
      if (params.type === 0) {
        uploadWebEventFn('0010301', params.status); // 埋点统计：邮箱登录输入密码登录结果
      } else if (params.type === 1) {
        uploadWebEventFn('0010101', params.status); // 埋点统计：手机号登录输入密码登录结果
      } else if (params.type === 2) {
        uploadWebEventFn('0010201', params.status); // 埋点统计：用户名登录输入密码登录结果
      }
    },
    // 登录页面输入并提示账号不存在
    'SIGNIN_ACCOUNT_NOT_EXIST': function SIGNIN_ACCOUNT_NOT_EXIST() {
      uploadWebEventFn('0010500'); // 埋点统计：登录页面输入并提示账号不存在
    },
    // 从账号不存在提示跳转到注册页面
    'SIGNIN_ACCOUNT_NOT_EXIST_TO_SIGNUP': function SIGNIN_ACCOUNT_NOT_EXIST_TO_SIGNUP() {
      uploadWebEventFn('0010501'); // 埋点统计：从账号不存在提示跳转到注册页面
    },
    // 扫码界面切换回登录界面
    'SCAN_TO_SIGNIN': function SCAN_TO_SIGNIN() {
      uploadWebEventFn('0010402'); // 埋点统计：扫码界面切换回登录界面
    },
    // 登录页面切换到扫码页面
    'SIGNIN_TO_SCAN': function SIGNIN_TO_SCAN() {
      uploadWebEventFn('0010400'); // 埋点统计：登录页面切换到扫码页面
    },
    // 注册页面主动跳转到登录页面
    'SINGUP_TO_SIGNIN': function SINGUP_TO_SIGNIN() {
      uploadWebEventFn('0000400'); // 埋点统计：注册页面主动跳转到登录页面
    },
    // 登录页面主动跳转到注册页面
    'SINGIN_TO_SIGNUP': function SINGIN_TO_SIGNUP() {
      uploadWebEventFn('0010600'); // 埋点统计：登录页面主动跳转到注册页面
    },
    // 登录页面点击重置密码
    'SIGNIN_TO_RESET': function SIGNIN_TO_RESET(params) {
      if (params.type === 0) {
        uploadWebEventFn('0010710'); // 埋点统计：邮箱登录页面点击重置密码
      } else if (params.type === 1) {
        uploadWebEventFn('0010700'); // 埋点统计：手机号登录页面点击重置密码
      }
    },
    // 重置密码页面验证码错误
    'RESET_PASSWORD_ERROR': function RESET_PASSWORD_ERROR(params) {
      if (params.type === 0) {
        uploadWebEventFn('0010713'); // 埋点统计：邮箱重置密码页面验证码错误
      } else if (params.type === 1) {
        uploadWebEventFn('0010703'); // 埋点统计：手机号重置密码页面验证码错误
      }
    },
    // 重置密码结果
    'RESET_PASSWORD_RESULT': function RESET_PASSWORD_RESULT(params) {
      if (params.type === 0) {
        uploadWebEventFn('0010714', params.status); // 埋点统计：邮箱重置密码结果
      } else if (params.type === 1) {
        uploadWebEventFn('0010704', params.status); // 埋点统计：手机号重置密码结果
      }
    },
    // 重置密码页面点击回到登录页
    'RESET_BACK_TO_SIGNIN': function RESET_BACK_TO_SIGNIN(params) {
      if (params.type === 0) {
        uploadWebEventFn('0010712'); // 埋点统计：邮箱重置密码页面点击回到登录页
      } else if (params.type === 1) {
        uploadWebEventFn('0010702'); // 埋点统计：手机号重置密码页面点击回到登录页
      }
    },
    // 邮箱重置密码页面获取验证码
    'EMAIL_SEND_CODE': function EMAIL_SEND_CODE() {
      uploadWebEventFn('0010711'); // 埋点统计：邮箱重置密码页面获取验证码
    },
    // 手机号重置密码页面获取验证码
    'PHONE_RESET_SEND_CODE': function PHONE_RESET_SEND_CODE() {
      uploadWebEventFn('0010701'); // 埋点统计：手机号重置密码页面获取验证码
    },
    // 手机号注册点击获取手机验证码
    'PHONE_SIGNUP_SEND_CODE': function PHONE_SIGNUP_SEND_CODE() {
      uploadWebEventFn('0000040'); // 埋点统计：手机号注册点击获取手机验证码
    },
    // 首个页面输入框手机号不合法
    'INVITE_INVALID_USERNAME': function INVITE_INVALID_USERNAME() {
      uploadWebEventFn('105000'); // 埋点统计：首个页面输入框手机号不合法
    },
    // 首个页面输入框手机号不合法
    'INVITE_INVALID_PHONE': function INVITE_INVALID_PHONE() {
      uploadWebEventFn('105010'); // 埋点统计：首个页面输入框手机号不合法
    },
    // 邀请页面提示账号已存在
    'INVITE_ACCOUNT_EXIST': function INVITE_ACCOUNT_EXIST() {
      uploadWebEventFn('106000'); // 埋点统计：邀请页面提示账号已存在
    },
    // 邀请登录页面提示密码不合法
    'INVITE_JOIN_PASSWORD_ERROR': function INVITE_JOIN_PASSWORD_ERROR() {
      uploadWebEventFn('106020'); // 埋点统计：邀请登录页面提示密码不合法
    },
    // 埋点统计：邀请登录页面登录结果
    'INVITE_JOIN_PASSWORD_RESULT': function INVITE_JOIN_PASSWORD_RESULT(params) {
      uploadWebEventFn('106030', params.status); // 埋点统计：邀请登录页面登录结果
    },
    // 邀请成功界面点击Download/Open Crait
    'INVITE_SUCCESS_OPEN': function INVITE_SUCCESS_OPEN() {
      if (params.type === 0) {
        uploadWebEventFn('107060'); // 埋点统计：邮箱邀请成功界面点击Download/Open Crait
      } else if (params.type === 1) {
        uploadWebEventFn('108110'); // 埋点统计：手机号邀请成功界面点击Download/Open Crait
      } else if (params.type === 2) {
        uploadWebEventFn('109060'); // 埋点统计：用户名邀请成功界面点击Download/Open Crait
      } else if (params.type === 3) {
        uploadWebEventFn('106040'); // 埋点统计：登录邀请成功界面点击Download/Open Crait
      }
    },
    // 邀请页面输入并跳转到下一页面
    'INVITE_INPUT_NEXT': function INVITE_INPUT_NEXT(params) {
      if (params.type === 0) {
        uploadWebEventFn('107000'); // 埋点统计：邀请页面输入并跳转到邮箱注册页面
      } else if (params.type === 1) {
        uploadWebEventFn('108000'); // 埋点统计：邀请页面输入并跳转到手机号注册页面
      } else if (params.type === 2) {
        uploadWebEventFn('109000'); // 埋点统计：邀请页面输入并跳转到用户名注册页面
      }
    },
    // 邀请页面返回上一步
    'INVITE_BACK': function INVITE_BACK(params) {
      if (params.type === 0) {
        uploadWebEventFn('107010'); // 埋点统计：邮箱邀请密码输入页返回上一步
      } else if (params.type === 1) {
        uploadWebEventFn('108010'); // 埋点统计：手机号邀请姓名密码页返回上一步
      } else if (params.type === 2) {
        uploadWebEventFn('109010'); // 埋点统计：用户名邀请密码输入页返回上一步
      } else if (params.type === 3) {
        uploadWebEventFn('108080'); // 埋点统计：手机号邀请输入验证码页面返回上一步
      }
    },
    // 手机号邀请姓名密码页提示输入错误
    'INVITENEXT_PHONE_ERROR': function INVITENEXT_PHONE_ERROR() {
      uploadWebEventFn('108030'); // 埋点统计：手机号邀请姓名密码页提示输入错误
    },
    // 邀请注册页点击查看用户协议
    'INVITENEXT_AGGREMENT': function INVITENEXT_AGGREMENT(params) {
      if (params.type === 0) {
        uploadWebEventFn('107040'); // 埋点统计：邮箱邀请注册页点击查看用户协议
      } else if (params.type === 1) {
        uploadWebEventFn('108040'); // 埋点统计：手机号邀请注册页点击查看用户协议
      } else if (params.type === 2) {
        uploadWebEventFn('109040'); // 埋点统计：用户名邀请注册页点击查看用户协议
      }
    },
    // 手机号邀请姓名密码页点击下一步
    'INVITENEXT_PHONE_NEXT': function INVITENEXT_PHONE_NEXT() {
      uploadWebEventFn('108050'); // 埋点统计：手机号邀请姓名密码页点击下一步
    },
    // 手机号邀请注册输入验证码页面切换国别码
    'INVITE_PHONE_COUNTRYCODE': function INVITE_PHONE_COUNTRYCODE() {
      uploadWebEventFn('108060'); // 埋点统计：手机号邀请注册输入验证码页面切换国别码
    },
    // 手机号邀请注册页面获取验证码
    'PHONE_INVITE_SEND_CODE': function PHONE_INVITE_SEND_CODE() {
      uploadWebEventFn('108070'); // 埋点统计：手机号邀请注册页面获取验证码
    },
    // 邀请注册结果
    'INVITE_RESULT': function INVITE_RESULT(params) {
      if (params.type === 0) {
        uploadWebEventFn('107050', params.status); // 埋点统计：邮箱邀请注册结果
      } else if (params.type === 1) {
        uploadWebEventFn('108100', params.status); // 埋点统计：手机邀请注册结果
      } else if (params.type === 2) {
        uploadWebEventFn('109050', params.status); // 埋点统计：用户名邀请注册结果
      } else if (params.from === 'verifyLater') {
        uploadWebEventFn('108120', params.status); // 埋点统计：稍后验证邀请注册结果
      }
    },
    // 邀请页面点击切换账号
    'INVITE_SWITCH_BACK': function INVITE_SWITCH_BACK(params) {
      if (params.type === 0) {
        uploadWebEventFn('107020'); // 埋点统计：邀请邮箱注册页面点击切换账号
      } else if (params.type === 1) {
        uploadWebEventFn('108020'); // 埋点统计：邀请手机号注册页面点击切换账号
      } else if (params.type === 2) {
        uploadWebEventFn('109020'); // 埋点统计：邀请手机号注册页面点击切换账号
      } else if (params.type === 3) {
        uploadWebEventFn('106010'); // 埋点统计：邀请登录页面点击切换账号
      }
    },
    //
    'INVITENEXT_DONE_ERROR': function INVITENEXT_DONE_ERROR(params) {
      if (params.type === 0) {
        uploadWebEventFn('107030'); // 埋点统计：邮箱邀请密码输入页密码输入错误
      } else if (params.type === 1) {
        uploadWebEventFn('108090'); // 埋点统计：手机号邀请输入验证码页面输入错误
      } else if (params.type === 2) {
        uploadWebEventFn('109030'); // 埋点统计：用户名邀请密码输入页密码输入错误
      }
    },
    'VIEW': function VIEW(params) {
      if (params.type) {
        uploadWebEventFn('tView', '', 0); // 埋点统计：微信打开页面
      } else {
        uploadWebEventFn('tView', '', 1); // 埋点统计：其他打开页面
      }
    },
    'START': function START(params) {
      uploadWebEventFn('tStart', '', params.type); // 埋点统计：首页_开始安全通信 输入框手机号不合法
    },
    'OPENAPP': function OPENAPP(params) {
      uploadWebEventFn('tOpenApp', '', params.type); // 埋点统计：点击app中打开 首页
    },
    'SWITCH': function SWITCH(params) {
      uploadWebEventFn('tSwitch'); // 埋点统计：老用户点击切换账号
    },
    'REGISTER': function REGISTER(params) {
      uploadWebEventFn('rRegister', '', params.type, params.result); // 埋点统计：新用户注册结果
    },
    'ACCEPT': function ACCEPT(params) {
      uploadWebEventFn('rAccept', '', '', params.result); // 埋点统计：老用户接收邀请结果
    },
    'DOWNLOAD': function DOWNLOAD(params) {
      uploadWebEventFn('tDownload', '', params.type); // 埋点统计：点击打开/下载app
    }
  };
  fn[type](params);
}

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  "data-v-5b8d7094",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  "data-v-d6d7dcde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = {
  isVanish: false,
  isLogin: true,
  type: 'login',
  pwdPublicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDlOf8L1Qe0/4hjteRSO6psXldm\n  sq7Vv7j6i9LZ9MMhRspdGzlrYiuRXgDCiZYxSMtwSPfCQGIfYbpxwwFN0pVPwaqs\n  kFMfxNiKrr6Xv7Z1bVt0mI43W7LioPEl1mllvvmghlx5M1johribJtd2dnwefK48\n  A7U36AvvGXLNba2KaQIDAQAB'
  // type: 'invite',
  // type: 'newInvite'
};

exports.default = config;

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  "data-v-65bd6139",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  "data-v-2f964cdc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkScan = exports.post = undefined;

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _is = __webpack_require__(334);

var _is2 = _interopRequireDefault(_is);

var _promise = __webpack_require__(135);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(79);

var _qs2 = _interopRequireDefault(_qs);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 设置默认请求头
// axios.defaults.headers = {
//   'X-Requested-With': 'XMLHttpRequest'
// }
_axios2.default.defaults.timeout = 30000;

/*
 * 统一封装axios方法
 * @param url: 请求地址
 * @param param: 请求参数
 * @param callback: 回调函数
 * @param location: 请求时的路由，用来处理由于响应时间过长，点击其他页面带来的影响
 */
var post = exports.post = function post(url, param, callback, location) {
  if (!localStorage.getItem('pcVersion')) {
    param['useragent'] = 'web';
  } else {
    param['useragent'] = localStorage.getItem('pcVersion');
  }
  return new _promise2.default(function (resolve, reject) {
    _axios2.default.post(url, _qs2.default.stringify(param)).then(function (res) {
      if ((0, _Common.getLocationHash)() === location || location === void 0) {
        if (callback) callback(res.data.msg, res.data.status, res.data.payload);
        if ((0, _is2.default)(res.data.status, '0')) {
          resolve(res);
        } else {
          reject(res);
          console.error(res.data.msg);
        }
      }
    }).catch(function (err) {
      // if (callback) callback('Oops, an unexpected error occurred. Please try again.')
      reject(err);
      console.error(err);
      // this.$message({
      //   message: 'ERROR!',
      //   type: 'error'
      // })
    });
  });
};

// 判断账号是否需要扫码的通用接口
var checkScan = exports.checkScan = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(route, param, callback, location) {
    var res;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return post('/proxy-api/client/web/index/check-need-scan', param, callback, location);

          case 2:
            res = _context.sent;

            if (!(res.data.payload.need_scan === 1)) {
              _context.next = 8;
              break;
            }

            route['path'] = '/login/scan';
            return _context.abrupt('return', route);

          case 8:
            route['path'] = '/login/password';
            return _context.abrupt('return', route);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function checkScan(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(661)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  "data-v-7a3ae26f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(657)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  "data-v-6ec7ce38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(System) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeviceInfo = exports.getUUIDFromSandBox = undefined;

var _slicedToArray2 = __webpack_require__(341);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getUUIDFromSandBox = exports.getUUIDFromSandBox = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var uuid;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _Sandbox2.default.getUUIDFromSandbox().catch(function (error) {
              console.log('get uuid from sand box.', error);
              return '';
            });

          case 2:
            uuid = _context.sent;

            console.log('uuid', uuid);
            return _context.abrupt('return', uuid);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getUUIDFromSandBox() {
    return _ref.apply(this, arguments);
  };
}();

var getDeviceId = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var deviceId;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // get uuid from localStorage.
            deviceId = getUUIDFromLocalStorage();

            if (!deviceId) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt('return', deviceId);

          case 3:
            _context2.next = 5;
            return getUUIDFromSandBox();

          case 5:
            deviceId = _context2.sent;

            if (!deviceId) {
              // local not exist uuid. generate uuid.
              deviceId = generateUUID();
            }
            // save uuid to local Storage.
            saveUUIDToLocalStorage(deviceId);
            return _context2.abrupt('return', deviceId);

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getDeviceId() {
    return _ref2.apply(this, arguments);
  };
}();

var getDeviceInfo = exports.getDeviceInfo = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    var deviceInfo;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            deviceInfo = {
              'deviceId': null,
              'deviceName': null
            };

            deviceInfo.deviceName = getSystemName();
            _context3.next = 4;
            return getDeviceId();

          case 4:
            deviceInfo.deviceId = _context3.sent;
            return _context3.abrupt('return', deviceInfo);

          case 6:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getDeviceInfo() {
    return _ref3.apply(this, arguments);
  };
}();

exports.generateUUID = generateUUID;
exports.saveUUIDToLocalStorage = saveUUIDToLocalStorage;
exports.getUUIDFromLocalStorage = getUUIDFromLocalStorage;
exports.isGrayEnv = isGrayEnv;
exports.setLoginInfo = setLoginInfo;
exports.jumpToMainWeb = jumpToMainWeb;
exports.checkVersion = checkVersion;

var _Sandbox = __webpack_require__(282);

var _Sandbox2 = _interopRequireDefault(_Sandbox);

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateUUID() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

var identificationDeviceName = 'WEB-UUID';

function saveUUIDToLocalStorage(uuid) {
  localStorage.setItem(identificationDeviceName, uuid);
}

function getUUIDFromLocalStorage() {
  return localStorage.getItem(identificationDeviceName);
}

function checkSystemISPC(userAgent) {
  if (userAgent.indexOf('electron') > -1) {
    return true;
  }
  return false;
}

function getSystemName() {
  var systemName = void 0;
  var userAgent = navigator.userAgent.toLowerCase();
  if (!userAgent) {
    return 'web';
  }

  if (checkSystemISPC(userAgent)) {
    systemName = getOSVersion(userAgent) + ' ' + 'PC';
  } else {
    systemName = getOSVersion(userAgent) + ' ' + getBrowerName(userAgent);
  }
  return systemName;
}

function getOSVersion(userAgent) {
  var OSVersion = void 0;
  if (userAgent.indexOf('win') > -1) {
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      OSVersion = 'Windows 2000';
    } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      OSVersion = 'Windows XP';
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      OSVersion = 'Windows Vista';
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      OSVersion = 'Windows 7';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      OSVersion = 'Windows 8';
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      OSVersion = 'Windows 8.1';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      OSVersion = 'Windows 10';
    } else {
      OSVersion = 'Unknown';
    }
  } else if (userAgent.indexOf('mac') > -1) {
    OSVersion = 'Mac';
  } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
    OSVersion = 'Unix';
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      OSVersion = 'Android';
    } else {
      OSVersion = 'Linux';
    }
  } else {
    OSVersion = 'Unknown';
  }
  return OSVersion;
}

function getBrowerName(userAgent) {
  // safari也提供了专门的判定方式
  var systemType = System.isIE ? 'IE' : window.opera || userAgent.indexOf('opr') > 0 ? 'Opera' : userAgent.indexOf('chrome') > 0 ? 'Chrome' : window.openDatabase ? 'Safari' : userAgent.indexOf('firefox') > 0 ? 'Firefox' : 'unknow';

  return systemType;
}

function isGrayEnv() {
  var hashParam = window.location.hash.length > 0 ? window.location.hash.substring(3) : '';
  if (!hashParam) {
    return 0;
  }
  var vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars['isGray'] ? +vars['isGray'] : 0;
}

function setLoginInfo(params) {
  localStorage.removeItem('login_token');
  localStorage.removeItem('login_code');
  if (!params) {
    return;
  }
  var token = params['pc_token'];
  var code = params['code'];
  localStorage.setItem('login_token', token);
  localStorage.setItem('login_code', code);
}

function jumpToMainWeb(isGray) {
  if (!checkVersion()) {
    return;
  }
  if (+isGray === 1 && window.VanishPCSDK) {
    window.VanishPCSDK.store.set('user.isGray', true);
  }
  // 测试环境、预发布 直接访问grayscale web address
  if (location.host.startsWith('vanish-testenv') || location.host.startsWith('vanish-pre')) {
    isGray = 1;
  }
  switch (+isGray) {
    case 0:
      location.replace('../web/index.html'); // release web address.
      break;
    case 1:
      location.replace('../grayscale/index.html'); // gray web address.
      break;
    default:
      location.replace('../web/index.html'); // default is release address
  }
}

function checkVersion() {
  if (location.search.indexOf('?ua=') > -1 && location.search.indexOf('&version=') > -1) {
    var version = location.search.substr(location.search.indexOf('&version=') + 9);

    var _version$split = version.split('.'),
        _version$split2 = (0, _slicedToArray3.default)(_version$split, 3),
        majorVersion = _version$split2[0],
        subVersion = _version$split2[1],
        stageVersion = _version$split2[2];

    console.log('current Version', majorVersion, subVersion, stageVersion);
    // 2.0以前版本，提示版本太低无法使用
    if (majorVersion < '2') {
      _vue2.default.prototype.$message({
        showClose: true,
        message: (0, _Translate2.default)('Low version notice'),
        type: 'error',
        duration: 0
      });
      return false;
    }
  }
  return true;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(805)))

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(61);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsencrypt = __webpack_require__(683);

var _jsencrypt2 = _interopRequireDefault(_jsencrypt);

var _cryptoJs = __webpack_require__(77);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cipher = function () {
  function Cipher() {
    (0, _classCallCheck3.default)(this, Cipher);
  }

  (0, _createClass3.default)(Cipher, [{
    key: 'rando',
    value: function rando(m) {
      var num = '';
      var getrandomarray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      for (var i = 0; i < m; i++) {
        var val = parseInt(Math.random() * 35, 10);
        if (i === 0 && val === 0) {
          i--;
          continue;
        }
        num += getrandomarray[val];
      }
      return num;
    }
  }, {
    key: 'MD5',
    value: function MD5(string) {
      return _cryptoJs2.default.MD5(string).toString();
    }
  }, {
    key: 'RSAencrypt',
    value: function RSAencrypt(publickey, string) {
      var encrypt = new _jsencrypt2.default.JSEncrypt();
      encrypt.setPublicKey(publickey, '10001');
      var encrypted = encrypt.encrypt(string);
      return encrypted;
    }
  }, {
    key: 'RSAprivateKeyEncrypt',
    value: function RSAprivateKeyEncrypt(privatekey, string) {
      var encrypt = new _jsencrypt2.default.JSEncrypt();
      encrypt.setPrivateKey(privatekey);
      var encrypted = encrypt.privateKeyEncrypt(string);
      return encrypted;
    }
  }, {
    key: 'RSApublicKeyDecrypt',
    value: function RSApublicKeyDecrypt(publickey, string) {
      var decrypt = new _jsencrypt2.default.JSEncrypt();
      decrypt.setPublicKey(publickey);
      var uncrypted = decrypt.publicKeyDecrypt(string);
      return uncrypted;
    }
  }, {
    key: 'RSAdecrypt',
    value: function RSAdecrypt(privatekey, string) {
      var decrypt = new _jsencrypt2.default.JSEncrypt();
      decrypt.setPrivateKey(privatekey, '10001');
      var uncrypted = decrypt.decrypt(string);
      return uncrypted;
    }
  }, {
    key: 'AESencrypt',
    value: function AESencrypt(key, string) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var encrypted = _cryptoJs2.default.AES.encrypt(string, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      return encrypted.toString();
    }
  }, {
    key: 'AESencryptAB',
    value: function AESencryptAB(key, abv) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var data = _cryptoJs2.default.lib.WordArray.create(abv);
      var encrypted = _cryptoJs2.default.AES.encrypt(data, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      return encrypted.ciphertext.toString();
    }
  }, {
    key: 'AESdecrypt',
    value: function AESdecrypt(key, string) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var decrypted = _cryptoJs2.default.AES.decrypt(string, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      try {
        return decrypted.toString(_cryptoJs2.default.enc.Utf8);
      } catch (e) {
        console.log(e);
        return '';
      }
    }
  }, {
    key: 'AESdecryptBase64',
    value: function AESdecryptBase64(key, base64Str) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var decrypted = _cryptoJs2.default.AES.decrypt(base64Str, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      return decrypted;
    }
  }, {
    key: 'AESencryptFilePart',
    value: function AESencryptFilePart(key, block, blockSize, isEnd) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var data = _cryptoJs2.default.lib.WordArray.create(block);
      var encrypted = _cryptoJs2.default.AES.encrypt(data, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      var enAbv = hex2abv(encrypted.ciphertext.toString());
      if (isEnd) {
        return enAbv;
      } else {
        return enAbv.slice(0, blockSize);
      }
    }
  }, {
    key: 'AESencryptFileByBlock',
    value: function AESencryptFileByBlock(key, file, blockSize, callback, progressCB) {
      var blockId = 0;
      var block = void 0;
      var reader = new FileReader();
      var enBlockArr = [];
      var that = this;
      var curEndByte = 0;

      reader.onloadend = function (evt) {
        var enRes = that.AESencryptAB(key, evt.target.result);
        var enAbv = hex2abv(enRes);
        if (curEndByte < file.size) {
          enBlockArr.push(enAbv.slice(0, blockSize));
        } else {
          enBlockArr.push(enAbv);
        }
        if (file.size === 0) {
          progressCB && progressCB(100);
        } else {
          progressCB && progressCB(Math.ceil(curEndByte / file.size * 100));
        }
        blockId++;
        if (blockId * blockSize < file.size) {
          curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size;
          block = file.slice(blockId * blockSize, curEndByte);
          reader.readAsArrayBuffer(block);
        } else {
          var blob = new Blob(enBlockArr);
          callback && callback(blob);
        }
      };
      curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size;
      block = file.slice(blockId * blockSize, curEndByte);
      reader.readAsArrayBuffer(block);
    }
  }, {
    key: 'AESdecryptFileByBlock',
    value: function AESdecryptFileByBlock(key, file, originfilesize, blockSize, callback, progressCB) {
      if (!key) {
        console.error('aes decrypt failed, key is null,params is ', arguments);
        return callback('');
      }
      // key value length is 16.
      var keyLength = 16;
      // split key value, keep the key length correct.
      key = key.substr(0, keyLength);

      var blockId = 0;
      var block = void 0;
      var reader = new FileReader();
      var deBlockArr = [];
      var that = this;
      var curEndByte = 0;

      reader.onloadend = function (evt) {
        var data = _cryptoJs2.default.lib.WordArray.create(evt.target.result); // create wordArray
        var enBase64 = data.toString(_cryptoJs2.default.enc.Base64); // wordArray => base64
        var deWords = that.AESdecryptBase64(key, enBase64);
        if (file.size === 0) {
          progressCB && progressCB(100);
        } else {
          progressCB && progressCB(Math.ceil(curEndByte / file.size * 100));
        }
        blockId++;
        var isEnd = blockId * blockSize >= file.size;
        var deAbv = wordToAB(deWords.words, deWords.sigBytes, isEnd); // wordArray => arrayBuffer
        deBlockArr.push(deAbv);
        if (!isEnd) {
          curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size;
          block = file.slice(blockId * blockSize, curEndByte);
          reader.readAsArrayBuffer(block);
        } else {
          var blob = new Blob(deBlockArr);
          callback && callback(blob);
        }
      };
      curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size;
      block = file.slice(blockId * blockSize, curEndByte);
      reader.readAsArrayBuffer(block);
    }
  }]);
  return Cipher;
}();

// Convert a hex string to an ArrayBufferView


function hex2abv(hex) {
  if (hex.length % 2 !== 0) {
    hex = '0' + hex;
  }
  var abv = new Uint8Array(hex.length / 2);
  for (var i = 0; i < abv.length; ++i) {
    abv[i] = parseInt(hex.substr(2 * i, 2), 16);
  }
  return abv;
}

function wordToAB(wordArray, sigBytes, isEnd) {
  var byteArray = [];
  var word = void 0;
  var i = void 0;
  var j = void 0;
  for (i = 0; i < wordArray.length; ++i) {
    word = wordArray[i];
    for (j = 3; j >= 0; --j) {
      byteArray.push(word >> 8 * j & 0xFF);
    }
  }
  // last block needs to split the useless bytes.
  if (isEnd) byteArray.length = sigBytes;
  return new Uint8Array(byteArray);
}

// eslint-disable-next-line no-unused-vars
function wordToByteArray(word, length) {
  var ba = [];
  var xFF = 0xFF;
  if (length > 0) {
    ba.push(word >>> 24);
  }
  if (length > 1) {
    ba.push(word >>> 16 & xFF);
  }
  if (length > 2) {
    ba.push(word >>> 8 & xFF);
  }
  if (length > 3) {
    ba.push(word & xFF);
  }

  return ba;
}

// eslint-disable-next-line no-unused-vars
function wordArrayToArrayBuffer(wordArray, length) {
  if (wordArray.hasOwnProperty('sigBytes') && wordArray.hasOwnProperty('words')) {
    length = wordArray.sigBytes;
    wordArray = wordArray.words;
  }

  var result = [];
  var bytes = void 0;
  var i = 0;
  while (length > 0) {
    bytes = this.wordToByteArray(wordArray[i], Math.min(4, length));
    length -= bytes.length;
    result.push(bytes);
    i++;
  }
  return new Uint8Array([].concat.apply([], result));
}

// Convert an ArrayBufferView to a hex string
// eslint-disable-next-line no-unused-vars
function abv2hex(abv) {
  var b = new Uint8Array(abv);
  var hex = '';
  for (var i = 0; i < b.length; ++i) {
    var zeropad = b[i] < 0x10 ? '0' : '';
    hex += zeropad + b[i].toString(16);
  }
  return hex;
}

// eslint-disable-next-line no-unused-vars
function base64ToAB(base64) {
  var binarString = window.atob(base64);
  var len = binarString.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binarString.charCodeAt(i);
  }
  return bytes.buffer;
}

exports.default = new Cipher();

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryCode = undefined;

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getCountryCode = exports.getCountryCode = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var res, newCodeObj, codeEN, i, countryArr;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(countryInfo.length === 0)) {
              _context.next = 8;
              break;
            }

            _context.next = 3;
            return (0, _Axios.post)('/proxy-api/client/web/index/get-country-code', { language: (0, _Common.browserLanguage)() });

          case 3:
            res = _context.sent;


            user = res.data.payload.user;
            if ((0, _Common.browserLanguage)() === 'zh-CN') {
              newCodeObj = {};
              codeEN = res.data.payload['country_code_en'];

              for (i in codeEN) {
                newCodeObj[codeEN[i]] = i;
              }
              user['alphaCode'] = isoCountries[newCodeObj[user['country_code']]].toLowerCase();
            } else {
              user['alphaCode'] = isoCountries[user['country_name']].toLowerCase();
            }

            countryArr = (0, _keys2.default)(res.data.payload['country_code']).sort();

            countryArr.forEach(function (country) {
              var obj = {
                'country': country,
                'code': res.data.payload['country_code'][country]
              };
              if ((0, _Common.browserLanguage)() === 'zh-CN') {
                obj['alphaCode'] = isoCountries[newCodeObj[obj.code]] ? isoCountries[newCodeObj[obj.code]].toLowerCase() : '';
              } else {
                obj['alphaCode'] = isoCountries[country] ? isoCountries[country].toLowerCase() : '';
              }
              countryInfo.push(obj);
            });

          case 8:
            return _context.abrupt('return', {
              countryInfo: countryInfo,
              user: user
            });

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getCountryCode() {
    return _ref.apply(this, arguments);
  };
}();

// 国家alpha-2 code


var _Axios = __webpack_require__(82);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countryInfo = [];
var user = {};

var isoCountries = {
  'Afghanistan': 'AF',
  'Aland Islands': 'AX',
  'Albania': 'AL',
  'Algeria': 'DZ',
  'American Samoa': 'AS',
  'Andorra': 'AD',
  'Angola': 'AO',
  'Anguilla': 'AI',
  'Antarctica': 'AQ',
  'Antigua And Barbuda': 'AG',
  'Argentina': 'AR',
  'Armenia': 'AM',
  'Aruba': 'AW',
  'Australia': 'AU',
  'Austria': 'AT',
  'Azerbaijan': 'AZ',
  'Bahamas': 'BS',
  'Bahrain': 'BH',
  'Bangladesh': 'BD',
  'Barbados': 'BB',
  'Belarus': 'BY',
  'Belgium': 'BE',
  'Belize': 'BZ',
  'Benin': 'BJ',
  'Bermuda': 'BM',
  'Bhutan': 'BT',
  'Bolivia': 'BO',
  'Bosnia And Herzegovina': 'BA',
  'Botswana': 'BW',
  'Bouvet Island': 'BV',
  'Brazil': 'BR',
  'British Indian Ocean Territory': 'IO',
  'Brunei Darussalam': 'BN',
  'Bulgaria': 'BG',
  'Burkina Faso': 'BF',
  'Burundi': 'BI',
  'Cambodia': 'KH',
  'Cameroon': 'CM',
  'Canada': 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  'Chad': 'TD',
  'Chile': 'CL',
  'China': 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  'Colombia': 'CO',
  'Comoros': 'KM',
  'Congo': 'CG',
  'Congo, Democratic Republic': 'CD',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  'Cote D\'Ivoire': 'CI',
  'Croatia': 'HR',
  'Cuba': 'CU',
  'Cyprus': 'CY',
  'Czech Republic': 'CZ',
  'Denmark': 'DK',
  'Djibouti': 'DJ',
  'Dominica': 'DM',
  'Dominican Republic': 'DO',
  'Ecuador': 'EC',
  'Egypt': 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  'Eritrea': 'ER',
  'Estonia': 'EE',
  'Ethiopia': 'ET',
  'Falkland Islands': 'FK',
  'Faroe Islands': 'FO',
  'Fiji': 'FJ',
  'Finland': 'FI',
  'France': 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  'Gabon': 'GA',
  'Gambia': 'GM',
  'Georgia': 'GE',
  'Germany': 'DE',
  'Ghana': 'GH',
  'Gibraltar': 'GI',
  'Greece': 'GR',
  'Greenland': 'GL',
  'Grenada': 'GD',
  'Guadeloupe': 'GP',
  'Guam': 'GU',
  'Guatemala': 'GT',
  'Guernsey': 'GG',
  'Guinea': 'GN',
  'Guinea-Bissau': 'GW',
  'Guyana': 'GY',
  'Haiti': 'HT',
  'Heard Island & Mcdonald Islands': 'HM',
  'Holy See (Vatican City State)': 'VA',
  'Honduras': 'HN',
  'Hong Kong': 'HK',
  'Hungary': 'HU',
  'Iceland': 'IS',
  'India': 'IN',
  'Indonesia': 'ID',
  'Iran, Islamic Republic Of': 'IR',
  'Iraq': 'IQ',
  'Ireland': 'IE',
  'Isle Of Man': 'IM',
  'Israel': 'IL',
  'Italy': 'IT',
  'Jamaica': 'JM',
  'Japan': 'JP',
  'Jersey': 'JE',
  'Jordan': 'JO',
  'Kazakhstan': 'KZ',
  'Kenya': 'KE',
  'Kiribati': 'KI',
  'Korea': 'KR',
  'Kuwait': 'KW',
  'Kyrgyzstan': 'KG',
  'Lao People\'s Democratic Republic': 'LA',
  'Latvia': 'LV',
  'Lebanon': 'LB',
  'Lesotho': 'LS',
  'Liberia': 'LR',
  'Libyan Arab Jamahiriya': 'LY',
  'Liechtenstein': 'LI',
  'Lithuania': 'LT',
  'Luxembourg': 'LU',
  'Macao': 'MO',
  'Macedonia': 'MK',
  'Madagascar': 'MG',
  'Malawi': 'MW',
  'Malaysia': 'MY',
  'Maldives': 'MV',
  'Mali': 'ML',
  'Malta': 'MT',
  'Marshall Islands': 'MH',
  'Martinique': 'MQ',
  'Mauritania': 'MR',
  'Mauritius': 'MU',
  'Mayotte': 'YT',
  'Mexico': 'MX',
  'Micronesia, Federated States Of': 'FM',
  'Moldova': 'MD',
  'Monaco': 'MC',
  'Mongolia': 'MN',
  'Montenegro': 'ME',
  'Montserrat': 'MS',
  'Morocco': 'MA',
  'Mozambique': 'MZ',
  'Myanmar': 'MM',
  'Namibia': 'NA',
  'Nauru': 'NR',
  'Nepal': 'NP',
  'Netherlands': 'NL',
  'Netherlands Antilles': 'AN',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  'Nicaragua': 'NI',
  'Niger': 'NE',
  'Nigeria': 'NG',
  'Niue': 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  'Norway': 'NO',
  'Oman': 'OM',
  'Pakistan': 'PK',
  'Palau': 'PW',
  'Palestinian Territory, Occupied': 'PS',
  'Panama': 'PA',
  'Papua New Guinea': 'PG',
  'Paraguay': 'PY',
  'Peru': 'PE',
  'Philippines': 'PH',
  'Pitcairn': 'PN',
  'Poland': 'PL',
  'Portugal': 'PT',
  'Puerto Rico': 'PR',
  'Qatar': 'QA',
  'Reunion': 'RE',
  'Romania': 'RO',
  'Russian Federation': 'RU',
  'Rwanda': 'RW',
  'Saint Barthelemy': 'BL',
  'Saint Helena': 'SH',
  'Saint Kitts And Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin': 'MF',
  'Saint Pierre And Miquelon': 'PM',
  'Saint Vincent And Grenadines': 'VC',
  'Samoa': 'WS',
  'San Marino': 'SM',
  'Sao Tome And Principe': 'ST',
  'Saudi Arabia': 'SA',
  'Senegal': 'SN',
  'Serbia': 'RS',
  'Seychelles': 'SC',
  'Sierra Leone': 'SL',
  'Singapore': 'SG',
  'Slovakia': 'SK',
  'Slovenia': 'SI',
  'Solomon Islands': 'SB',
  'Somalia': 'SO',
  'South Africa': 'ZA',
  'South Georgia And Sandwich Isl.': 'GS',
  'Spain': 'ES',
  'Sri Lanka': 'LK',
  'Sudan': 'SD',
  'Suriname': 'SR',
  'Svalbard And Jan Mayen': 'SJ',
  'Swaziland': 'SZ',
  'Sweden': 'SE',
  'Switzerland': 'CH',
  'Syrian Arab Republic': 'SY',
  'Taiwan': 'TW',
  'Tajikistan': 'TJ',
  'Tanzania': 'TZ',
  'Thailand': 'TH',
  'Timor-Leste': 'TL',
  'Togo': 'TG',
  'Tokelau': 'TK',
  'Tonga': 'TO',
  'Trinidad And Tobago': 'TT',
  'Tunisia': 'TN',
  'Turkey': 'TR',
  'Turkmenistan': 'TM',
  'Turks And Caicos Islands': 'TC',
  'Tuvalu': 'TV',
  'Uganda': 'UG',
  'Ukraine': 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  'United States Outlying Islands': 'UM',
  'Uruguay': 'UY',
  'Uzbekistan': 'UZ',
  'Vanuatu': 'VU',
  'Venezuela': 'VE',
  'Vietnam': 'VN',
  'Virgin Islands, British': 'VG',
  'Virgin Islands, U.S.': 'VI',
  'Wallis And Futuna': 'WF',
  'Western Sahara': 'EH',
  'Yemen': 'YE',
  'Zambia': 'ZM',
  'Zimbabwe': 'ZW'
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ScanFlag = exports.ScanFlag = {
  IS_SCAN_LOGIN: 1, // 1 is scan login
  NOT_SCAN_LOGIN: 0 // 0 is not scan login
};

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  "data-v-360a0ff6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(764),
  /* scopeId */
  "data-v-2348d8ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  "data-v-ee29433e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(61);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _cryptoJs = __webpack_require__(77);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Crypto = function () {
  function Crypto() {
    (0, _classCallCheck3.default)(this, Crypto);
  }

  (0, _createClass3.default)(Crypto, [{
    key: 'aesEncrypt',

    // aes加密
    value: function aesEncrypt(key, string) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var encrypted = _cryptoJs2.default.AES.encrypt(string, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      return encrypted.toString();
    }
    // aes解密

  }, {
    key: 'aesDecrypt',
    value: function aesDecrypt(key, string) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var decrypted = _cryptoJs2.default.AES.decrypt(string, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      return decrypted.toString(_cryptoJs2.default.enc.Utf8);
    }
    // 获取md5

  }, {
    key: 'getMD5',
    value: function getMD5(value) {
      return _cryptoJs2.default.MD5(value).toString().substr(8, 16);
    }
  }]);
  return Crypto;
}();

exports.default = Crypto;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(190);

var _values2 = _interopRequireDefault(_values);

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(189);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(61);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(340);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(338);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(339);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Crypto2 = __webpack_require__(187);

var _Crypto3 = _interopRequireDefault(_Crypto2);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 目前的功能是在原基础上修改，目前只支持记住一个密码，且函数的命名还可以优化
var RememberPassword = function (_Crypto) {
  (0, _inherits3.default)(RememberPassword, _Crypto);

  function RememberPassword() {
    (0, _classCallCheck3.default)(this, RememberPassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RememberPassword.__proto__ || (0, _getPrototypeOf2.default)(RememberPassword)).call(this));

    _this.account = '';
    _this.accountList = [];
    _this.password = '';
    _this.passwordArr = [];
    _this.passwordObj = {};
    return _this;
  }
  // 获取密码


  (0, _createClass3.default)(RememberPassword, [{
    key: 'getPassword',
    value: function getPassword(account) {
      this.account = account;
      this.passwordArr = JSON.parse(localStorage.getItem('passwords'));
      if (!this.passwordArr || this.passwordArr.length === 0) {
        localStorage.setItem('passwords', (0, _stringify2.default)([]));
        this.passwordArr = [];
      } else {
        this._getAccountAndPassword();
        this._getAccountList();
        this._transferArrToObj();
      }
      return this.password;
    }
    // 存储密码

  }, {
    key: 'savePassword',
    value: function savePassword(account, password, rememberpw) {
      this._deleteAccountAndPassword(); // 保存信息先去重
      var publicKey = (0, _Common.getPublicKey)(account);
      var md5 = (0, _get3.default)(RememberPassword.prototype.__proto__ || (0, _getPrototypeOf2.default)(RememberPassword.prototype), 'getMD5', this).call(this, publicKey);
      var passwordObj = {};
      if (rememberpw) {
        passwordObj[account] = (0, _get3.default)(RememberPassword.prototype.__proto__ || (0, _getPrototypeOf2.default)(RememberPassword.prototype), 'aesEncrypt', this).call(this, md5, password);
      } else {
        passwordObj[account] = '';
      }
      this.passwordArr = [];
      this.passwordArr.push(passwordObj);
      localStorage.setItem('passwords', (0, _stringify2.default)(this.passwordArr));
    }
    // 获取登录信息

  }, {
    key: '_getAccountAndPassword',
    value: function _getAccountAndPassword() {
      var arr = this.passwordArr[this.passwordArr.length - 1];
      // this.account = Object.keys(arr)[0]
      var publicKey = (0, _Common.getPublicKey)(this.account);
      var md5 = (0, _get3.default)(RememberPassword.prototype.__proto__ || (0, _getPrototypeOf2.default)(RememberPassword.prototype), 'getMD5', this).call(this, publicKey);
      this.password = (0, _get3.default)(RememberPassword.prototype.__proto__ || (0, _getPrototypeOf2.default)(RememberPassword.prototype), 'aesDecrypt', this).call(this, md5, (0, _values2.default)(arr)[0]);
    }
    // 删除登录信息

  }, {
    key: '_deleteAccountAndPassword',
    value: function _deleteAccountAndPassword() {
      for (var i in this.passwordArr) {
        if (this.account === (0, _keys2.default)(this.passwordArr[i])[0]) {
          this.passwordArr.splice(i, 1);
          break;
        }
      }
    }
    // 获取登录账号列表

  }, {
    key: '_getAccountList',
    value: function _getAccountList() {
      var _this2 = this;

      this.passwordArr.forEach(function (item) {
        _this2.accountList.push((0, _keys2.default)(item)[0]);
      });
    }
    // 将密码数组转换为对象

  }, {
    key: '_transferArrToObj',
    value: function _transferArrToObj() {
      for (var i in this.passwordArr) {
        this.passwordObj[(0, _keys2.default)(this.passwordArr[i])[0]] = (0, _values2.default)(this.passwordArr[i])[0];
      }
    }
  }]);
  return RememberPassword;
}(_Crypto3.default);

exports.default = RememberPassword;

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAAByCAMAAAC4A3VPAAAAilBMVEUAAADPz8/KysrJycnLy8vJycnKysrKysrKysrKysrKysrT09PX19fe3t7Ly8vk5OTo6Ojy8vL5+fn////Pz8/Kysra2trr6+v8/PzQ0NDLy8vKysrKysrNzc3h4eHKysr19fXKysrJycnLy8vKysru7u7JycnJycnKysrKysrU1NTJycnv7+/l5eUCqnPGAAAALHRSTlMAED9ff6+/7/8wb////0///////yCf/////0DPj///YP+QgHCg/1CwwPD/0IRVThUAAAP/SURBVHgBvNOJcqowFIBh45afC1TCUYLirl3e/wmvmZZOF5kalvxdXb8J5zjyS40n09l8PtcA+vbPbDoZq9FQRf9mmrvp2b+od05NvnBxcitN3e/4Czvp87RPM95LFpnJ5Vu5yRYJ782eejrgVH9wRhozH6yedj/qcoWrsKX8UWkLXKtlD+A6y+Wh8mzdFZ1qB1rxyDpUT1uCmwpIjHhmEqDatADVFthZaZHdAVvlK0YVsC+lVeUeqCI/8aAhPkrrTAz64AGqFZCW0qEyBVbqYbFqmKL3RCv1uBgfpXPH+FEzcmIpPVQ6M3pA1FA4sQ+zAB09IqbSW+nfpqpqsT+zUh5iANOJhfRcAlUzufLaVY+9XTWJBw/R0zw0LuvuKAN03KGjpkFaGSTbsEInSGWgUjj9Fjeeg0yt5zg3v8gKjj4i+JjmziflDHs/0c/cw+W7uNTsSk/R6xXlDr38Rl7BeotHz629fjskJEOKrgSW3w9pBhbl+dsxFayHFV1rUF/X1Q4uioXzJ6lZDy+6Y+pafIEsgCgZvHyQr5AHECWH18/lKYYXXUW9QAewQUSxcKivaxlElLK+spokhOhK0E6MYBFIlAVEN/ICJpAoBi7vowwjuuC1HmUQsR6mgkUwURagRhvIgomSwWZ0ABNMFAOH0RnyYKLkcHYLG0p0wXX0RhxQlJi3G5kEFCWpyTBiTf5v3lxY44aBILziOQYFOHqgxkBNfOLslZL///daRNLS4tt45XHJ8DLPDyxZ2p0dA9Ei9uvxWQBEPtFCQoAfBpGOfDKR6SSk9WLTSS9WG9JiUg2ECG0fCZPp+C5tJhlZvv1HZsFqH+t8JpA/v7wS/fKyr2g28wLc9xQiiVuI7Cq3ErfcMs8COjNC7dKZzwSW3Q1CYjYIO9ugRGyD7MXkMiPU1dImSkvra9wTo3E37Qk+MwLBa8KkoyZM9ltNiWQ1iRqGGpH5DO2yDRPBNjTMUS7zGRo6LeBEsIC9RnciGN1eOz8R7Hy5qmsEkXqGFno9NJppzOSb5dzkH1Xg4mM6B1B1a8xWvnuYrjFbAcavMEyUUM8cmdYgGxr0vMGwDrKpybmcjoWc5IGyg+kiZnmkUM+JMlQRk8kPbNQgJCaB2DQoO3yjnwd+lBgxir+JNrOS9m3bq/VvorGehREXKxvraDApobhG3MnMnOhfFocmBcqln3gpgE7i0lCPxDif0DaOU+HlWFj1JYhfYwUQX73A1wigjtKnWfuCx3qTbl1zT7w6H8x05/0h8ggA2oDHFGZt1PhmReXfGg86B6HovgDv2K0fAt5xQL4LT2FaFB8qf357KPiQLlMQtoZbw25Il9sgZymM05zXddVG+vWQ5/sYxKWfrmbffKvyD+UAAAAASUVORK5CYII="

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  "data-v-963126e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.directive('clickoutside', {
  bind: function bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
    }
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 替换所有
String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, "gm"), s2);
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(803);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Login = __webpack_require__(728);

var _Login2 = _interopRequireDefault(_Login);

var _Qrcode = __webpack_require__(729);

var _Qrcode2 = _interopRequireDefault(_Qrcode);

var _Signup = __webpack_require__(730);

var _Signup2 = _interopRequireDefault(_Signup);

var _Forgot = __webpack_require__(726);

var _Forgot2 = _interopRequireDefault(_Forgot);

var _Signin = __webpack_require__(747);

var _Signin2 = _interopRequireDefault(_Signin);

var _Signup3 = __webpack_require__(748);

var _Signup4 = _interopRequireDefault(_Signup3);

var _Signupnext = __webpack_require__(749);

var _Signupnext2 = _interopRequireDefault(_Signupnext);

var _Signupphone = __webpack_require__(750);

var _Signupphone2 = _interopRequireDefault(_Signupphone);

var _Signupsuccess = __webpack_require__(751);

var _Signupsuccess2 = _interopRequireDefault(_Signupsuccess);

var _Scan = __webpack_require__(746);

var _Scan2 = _interopRequireDefault(_Scan);

var _Password = __webpack_require__(744);

var _Password2 = _interopRequireDefault(_Password);

var _Forgotpassword = __webpack_require__(742);

var _Forgotpassword2 = _interopRequireDefault(_Forgotpassword);

var _Resetsuccess = __webpack_require__(745);

var _Resetsuccess2 = _interopRequireDefault(_Resetsuccess);

var _Accountnotexist = __webpack_require__(741);

var _Accountnotexist2 = _interopRequireDefault(_Accountnotexist);

var _Accountexist = __webpack_require__(740);

var _Accountexist2 = _interopRequireDefault(_Accountexist);

var _Start = __webpack_require__(739);

var _Start2 = _interopRequireDefault(_Start);

var _Accountexist3 = __webpack_require__(734);

var _Accountexist4 = _interopRequireDefault(_Accountexist3);

var _Invitenext = __webpack_require__(736);

var _Invitenext2 = _interopRequireDefault(_Invitenext);

var _Invitephone = __webpack_require__(737);

var _Invitephone2 = _interopRequireDefault(_Invitephone);

var _Invitesuccess = __webpack_require__(738);

var _Invitesuccess2 = _interopRequireDefault(_Invitesuccess);

var _Inviteerror = __webpack_require__(735);

var _Inviteerror2 = _interopRequireDefault(_Inviteerror);

var _Start3 = __webpack_require__(756);

var _Start4 = _interopRequireDefault(_Start3);

var _Invitenext3 = __webpack_require__(754);

var _Invitenext4 = _interopRequireDefault(_Invitenext3);

var _Invitesuccess3 = __webpack_require__(755);

var _Invitesuccess4 = _interopRequireDefault(_Invitesuccess3);

var _Inviteerror3 = __webpack_require__(753);

var _Inviteerror4 = _interopRequireDefault(_Inviteerror3);

var _IndifyDevice = __webpack_require__(743);

var _IndifyDevice2 = _interopRequireDefault(_IndifyDevice);

var _genericForgotpassword = __webpack_require__(752);

var _genericForgotpassword2 = _interopRequireDefault(_genericForgotpassword);

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [];
if (_config2.default.type === 'login') {
  if (_config2.default.isVanish) {
    routes = [{
      path: '/login',
      name: 'Login',
      component: _Login2.default
    }, {
      path: '/qrcode',
      name: 'Qrcode',
      component: _Qrcode2.default
    }, {
      path: '/signup',
      name: 'SignupOld',
      component: _Signup2.default
    }, {
      path: '/forgot',
      name: 'Forgot',
      component: _Forgot2.default
    }];
    if (localStorage.getItem('vanishAccount')) {
      routes.unshift({
        path: '/',
        name: 'Login',
        component: _Login2.default
      });
    } else {
      routes.unshift({
        path: '/',
        name: 'Qrcode',
        component: _Qrcode2.default
      });
    }
  } else {
    routes = [{
      path: '/login/signin',
      name: 'Signin',
      component: _Signin2.default
    }, {
      path: '/login/signup',
      name: 'Signup',
      component: _Signup4.default
    }, {
      path: '/login/signupnext',
      name: 'Signupnext',
      component: _Signupnext2.default
    }, {
      path: '/login/signupphone',
      name: 'Signupphone',
      component: _Signupphone2.default
    }, {
      path: '/login/signupsuccess',
      name: 'Signupsuccess',
      component: _Signupsuccess2.default
    }, {
      path: '/login/scan',
      name: 'Scan',
      component: _Scan2.default
    }, {
      path: '/login/password',
      name: 'Password',
      component: _Password2.default
    }, {
      path: '/login/forgotpassword',
      name: 'ForgotPassword',
      component: _Forgotpassword2.default
    }, {
      path: '/login/genericforgotpassword',
      name: 'GenericForgot',
      component: _genericForgotpassword2.default
    }, {
      path: '/login/resetsuccess',
      name: 'ResetSuccess',
      component: _Resetsuccess2.default
    }, {
      path: '/login/accountnotexist',
      name: 'AccountNotExist',
      component: _Accountnotexist2.default
    }, {
      path: '/login/accountexist',
      name: 'AccountExist',
      component: _Accountexist2.default
    }, {
      path: '/login/indifyDevice',
      name: 'IndifyDevice',
      component: _IndifyDevice2.default
    }];
    if (JSON.parse(localStorage.getItem('passwords')) && JSON.parse(localStorage.getItem('passwords'))[0] && (0, _keys2.default)(JSON.parse(localStorage.getItem('passwords'))[0])[0] !== 'undefined') {
      routes.unshift({
        path: '/',
        name: 'Signin',
        component: _Signin2.default
      });
    } else {
      if (!_index2.default.isGenericVersion()) {
        routes.unshift({
          path: '/',
          name: 'Signup',
          component: _Signup4.default
        });
      } else {
        routes.unshift({
          path: '/',
          name: 'Signin',
          component: _Signin2.default
        });
      }
    }
  }
} else if (_config2.default.type === 'invite') {
  if (_config2.default.isVanish) {} else {
    routes = [{
      path: '/',
      name: 'Start',
      component: _Start2.default
    }, {
      path: '/invite/start',
      name: 'Start2',
      component: _Start2.default
    }, {
      path: '/invite/accountexist',
      name: 'InviteAccountExist',
      component: _Accountexist4.default
    }, {
      path: '/invite/invitenext',
      name: 'InviteNext',
      component: _Invitenext2.default
    }, {
      path: '/invite/invitephone',
      name: 'InvitePhone',
      component: _Invitephone2.default
    }, {
      path: '/invite/invitesuccess',
      name: 'InviteSuccess',
      component: _Invitesuccess2.default
    }, {
      path: '/invite/inviteerror',
      name: 'InviteError',
      component: _Inviteerror2.default
    }];
  }
} else if (_config2.default.type === 'newInvite') {
  if (_config2.default.isVanish) {} else {
    routes = [{
      path: '/',
      name: 'NewInviteStart',
      component: _Start4.default
    }, {
      path: '/invite/invitenext',
      name: 'NewInviteNext',
      component: _Invitenext4.default
    }, {
      path: '/invite/invitesuccess',
      name: 'NewInviteSuccess',
      component: _Invitesuccess4.default
    }, {
      path: '/invite/inviteerror',
      name: 'NewInviteError',
      component: _Inviteerror4.default
    }];
  }
}

var router = new _vueRouter2.default({
  // mode: 'history',
  // base: '/website/option/share/index.html',
  routes: routes
  // routes: [{
  //   path: '/',
  //   name: 'Qrcode',
  //   component: Qrcode
  // }, {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login
  // }, {
  //   path: '/qrcode',
  //   name: 'Qrcode',
  //   component: Qrcode
  // }, {
  //   path: '/signup',
  //   name: 'Signup',
  //   component: Signup
  // }, {
  //   path: '/forgot',
  //   name: 'Forgot',
  //   component: Forgot
  // }]
  // routes: [{
  //   path: '/',
  //   name: 'Signin',
  //   component: Signin
  // }, {
  //   path: '/login/signin',
  //   name: 'Signin',
  //   component: Signin
  // }, {
  //   path: '/login/signup',
  //   name: 'Signup',
  //   component: Signup
  // }, {
  //   path: '/login/signupnext',
  //   name: 'Signupnext',
  //   component: Signupnext
  // }, {
  //   path: '/login/signupphone',
  //   name: 'Signupphone',
  //   component: Signupphone
  // }, {
  //   path: '/login/signupsuccess',
  //   name: 'Signupsuccess',
  //   component: Signupsuccess
  // }, {
  //   path: '/login/scan',
  //   name: 'Scan',
  //   component: Scan
  // }, {
  //   path: '/login/password',
  //   name: 'Password',
  //   component: Password
  // }, {
  //   path: '/login/forgotpassword',
  //   name: 'ForgotPassword',
  //   component: ForgotPassword
  // }, {
  //   path: '/login/resetsuccess',
  //   name: 'ResetSuccess',
  //   component: ResetSuccess
  // }, {
  //   path: '/login/accountnotexist',
  //   name: 'AccountNotExist',
  //   component: AccountNotExist
  // }, {
  //   path: '/login/accountexist',
  //   name: 'AccountExist',
  //   component: AccountExist
  // }]
});

exports.default = router;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isNewClient = !!window.VanishPCSDK;

if (isNewClient) {
  var ipcRenderer = window.VanishPCSDK.ipcRenderer;

  ipcRenderer.on('client-request-quit', function () {
    ipcRenderer.send('client-quit');
  });
}

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  appName: 'vanish',
  appVersion: '2.2.23',
  isGenericVersion: true,
  appIcon: __webpack_require__(695),
  backgroundImg: __webpack_require__(694)
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__(259);

var _index2 = _interopRequireDefault(_index);

var _lib = __webpack_require__(257);

var _lib2 = _interopRequireDefault(_lib);

__webpack_require__(258);

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(262);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(255);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(256);

__webpack_require__(253);

__webpack_require__(261);

__webpack_require__(260);

__webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_lib2.default);
// Vue.set(router, router)
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(135);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(61);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(62);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sandboxSize = 500 * 1024 * 1024; // sandbox size is 500
var identificationFilePath = 'UUID' + '/' + 'WEB-UUID'; // uuid save to this file.

var SandboxManager = function () {
  function SandboxManager() {
    (0, _classCallCheck3.default)(this, SandboxManager);
  }

  (0, _createClass3.default)(SandboxManager, [{
    key: 'getUUIDFromSandbox',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _this = this;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;
                return _context2.abrupt('return', new _promise2.default(function () {
                  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
                    var usedSize;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return getSandBoxUsedSize();

                          case 2:
                            usedSize = _context.sent;

                            console.log('usedSize', usedSize);
                            if (usedSize === 0) {
                              reject();
                            }
                            window.requestFileSystem(window.PERSISTENT, sandboxSize, function (fs) {
                              fs.root.getFile(identificationFilePath, {
                                create: false
                              }, function (fileEntry) {
                                fileEntry.file(function readFile(file) {
                                  var reader = new FileReader();
                                  reader.onloadend = function (e) {
                                    resolve(e.target.result);
                                  };
                                  reader.readAsText(file);
                                }, function (error) {
                                  reject(error);
                                });
                              }, function (error) {
                                reject(error);
                              });
                            });

                          case 6:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x, _x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUUIDFromSandbox() {
        return _ref.apply(this, arguments);
      }

      return getUUIDFromSandbox;
    }()
  }]);
  return SandboxManager;
}();

function getSandBoxUsedSize() {
  return new _promise2.default(function (resolve, reject) {
    if (!navigator.webkitPersistentStorage) {
      resolve(0);
    }
    navigator.webkitPersistentStorage.queryUsageAndQuota(function (usedBytes, grantedBytes) {
      // console.log('总容量：%sM, 已使用容量：%sM, 剩余容量：%sM', grantedBytes/(1024*1024), usedBytes/(1024*1024), (grantedBytes - usedBytes)/(1024*1024))
      resolve(usedBytes);
    });
  });
}
exports.default = new SandboxManager();

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _qrious = __webpack_require__(685);

var _qrious2 = _interopRequireDefault(_qrious);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        value: {
            type: String,

            required: true,

            default: ''
        },

        cls: {
            type: String,

            default: ''
        },

        size: {
            type: Number,

            default: 100
        },

        level: {
            type: String,

            default: 'L',

            validator: function validator(l) {
                return ['L', 'Q', 'M', 'H'].indexOf(l) > -1;
            }
        },

        background: {
            type: String,

            default: '#fff'
        },

        foreground: {
            type: String,

            default: '#000'
        },

        mime: {
            type: String,

            default: 'image/png'
        },

        padding: {
            type: Number,

            default: 0
        },

        type: {
            type: String,

            default: 'canvas',

            validator: function validator(t) {
                return ['canvas', 'image'].indexOf(t) > -1;
            }
        }
    },

    methods: {
        render: function render() {
            var qr = new _qrious2.default({
                background: this.background,

                foreground: this.foreground,

                level: this.level,

                mime: this.mime,

                padding: this.padding,

                size: this.size,

                value: this.value
            });

            this.$el.innerHTML = '';

            this.$el.appendChild(qr[this.type]);
        }
    },

    mounted: function mounted() {
        var _this = this;

        this.render();

        this.$options._propKeys.forEach(function (key) {
            return _this.$watch(key, _this.render);
        });
    }
}; //
//
//
//

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Wrap = __webpack_require__(731);

var _Wrap2 = _interopRequireDefault(_Wrap);

var _Header = __webpack_require__(727);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'app',
  components: {
    Wrap: _Wrap2.default,
    elHeader: _Header2.default
  }
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(91);

var _message2 = _interopRequireDefault(_message);

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(79);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      email: ''
    };
  },

  methods: {
    forgotClick: function forgotClick() {
      var _this = this;

      this.$emit('show');
      _axios2.default.post('/proxy-api/client/user/index/reset-password', _qs2.default.stringify({
        email: this.email
      })).then(function (result) {
        console.log(result);
        if (result.data.status === '0') {
          _this.$emit('hide');
          setTimeout(function () {
            location.href = './';
          }, 1000);
          (0, _message2.default)({
            message: 'Please check your email.',
            type: 'success'
          });
        } else {
          _this.$emit('hide');
          (0, _message2.default)({
            message: result.data.msg,
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$emit('hide');
        (0, _message2.default)({
          message: 'Warning!',
          type: 'warning'
        });
      });
    }
  }
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _message = __webpack_require__(91);

var _message2 = _interopRequireDefault(_message);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _values = __webpack_require__(190);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(79);

var _qs2 = _interopRequireDefault(_qs);

var _cryptoJs = __webpack_require__(77);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _GeneralVariable = __webpack_require__(108);

var _utils = __webpack_require__(95);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _Cipher = __webpack_require__(106);

var _Cipher2 = _interopRequireDefault(_Cipher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      email: '',
      emailList: [],
      password: '',
      rememberpw: false,
      passwordArr: [],
      passwordObj: {},
      logoImg: _index2.default.getAppIcon()
    };
  },
  mounted: function mounted() {
    this.passwordArr = JSON.parse(localStorage.getItem('passwords'));
    if (!this.passwordArr || this.passwordArr.length === 0) {
      localStorage.setItem('passwords', (0, _stringify2.default)([]));
      this.passwordArr = [];
    } else {
      this.getEmailAndPassword();
      this.getEmailList();
      this.transferArrToObj();
      if (this.password !== '') {
        this.rememberpw = true;
      }
    }
    if (localStorage.vanishAccount) {
      this.email = localStorage.vanishAccount;
    }
  },

  watch: {
    email: function email() {
      if (this.passwordObj[this.email]) {
        var publickey = this.getPublickey();
        var md5 = this.getMd5(publickey);
        this.password = this.aesDecrypt(md5, this.passwordObj[this.email]);
      }
    }
  },
  methods: {
    // aes加密
    aesEncrypt: function aesEncrypt(key, string) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var encrypted = _cryptoJs2.default.AES.encrypt(string, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      return encrypted.toString();
    },

    // aes解密
    aesDecrypt: function aesDecrypt(key, string) {
      var iv = _cryptoJs2.default.enc.Latin1.parse(key);
      var decrypted = _cryptoJs2.default.AES.decrypt(string, iv, {
        iv: iv,
        mode: _cryptoJs2.default.mode.ECB,
        padding: _cryptoJs2.default.pad.Pkcs7
      });
      return decrypted.toString(_cryptoJs2.default.enc.Utf8);
    },

    // 获取publickey
    getPublickey: function getPublickey() {
      return localStorage.getItem(this.email + '_publickey');
    },

    // 获取md5
    getMd5: function getMd5(publickey) {
      return _cryptoJs2.default.MD5(publickey).toString().substr(8, 16);
    },

    // 存储登录信息
    saveEmailAndPassword: function saveEmailAndPassword() {
      this.deleteEmailAndPassword(); // 保存信息先去重
      var publickey = this.getPublickey();
      var md5 = this.getMd5(publickey);
      var passwordObj = {};
      if (this.rememberpw) {
        passwordObj[this.email] = this.aesEncrypt(md5, this.password);
      } else {
        passwordObj[this.email] = '';
      }
      this.passwordArr = [];
      this.passwordArr.push(passwordObj);
    },

    // 删除登录信息
    deleteEmailAndPassword: function deleteEmailAndPassword() {
      for (var i in this.passwordArr) {
        if (this.email === (0, _keys2.default)(this.passwordArr[i])[0]) {
          this.passwordArr.splice(i, 1);
          break;
        }
      }
    },

    // 获取登录信息
    getEmailAndPassword: function getEmailAndPassword() {
      var password = this.passwordArr[this.passwordArr.length - 1];
      this.email = (0, _keys2.default)(password)[0];
      var publickey = this.getPublickey();
      var md5 = this.getMd5(publickey);
      this.password = this.aesDecrypt(md5, (0, _values2.default)(password)[0]);
    },

    // 获取登录邮箱列表
    getEmailList: function getEmailList() {
      var _this = this;

      this.passwordArr.forEach(function (item) {
        _this.emailList.push((0, _keys2.default)(item)[0]);
      });
    },

    // 将密码数组转换为对象
    transferArrToObj: function transferArrToObj() {
      for (var i in this.passwordArr) {
        this.passwordObj[(0, _keys2.default)(this.passwordArr[i])[0]] = (0, _values2.default)(this.passwordArr[i])[0];
      }
    },
    login: function login() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var publickey, reg, data, deviceInfo;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$emit('show');
                publickey = _this2.getPublickey();
                //      let reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
                //      let reg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((\\-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\\.|\\-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/

                reg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\.|-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/;
                data = {};

                if (reg.test(_this2.email)) {
                  data = {
                    email: _this2.email,
                    password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, _this2.password),
                    decrypt_type: 2,
                    // useragent: 'web',
                    // 此cryptojs版本有bug，需要tostring转换一下
                    key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                  };
                } else {
                  data = {
                    phone_md5: _cryptoJs2.default.MD5(_this2.email).toString().substr(8, 16),
                    password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, _this2.password),
                    decrypt_type: 2,
                    // useragent: 'web',
                    // 此cryptojs版本有bug，需要tostring转换一下
                    key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                  };
                }
                if (!localStorage.getItem('pcVersion')) {
                  data['useragent'] = 'web';
                } else {
                  data['useragent'] = localStorage.getItem('pcVersion');
                }

                // data add scan login flag.
                data['is_scan'] = _GeneralVariable.ScanFlag.NOT_SCAN_LOGIN;
                // add device info.
                _context.next = 9;
                return (0, _utils.getDeviceInfo)();

              case 9:
                deviceInfo = _context.sent;

                data['device_name'] = deviceInfo.deviceName;
                data['device_id'] = deviceInfo.deviceId;
                data['temporary_gray'] = (0, _utils.isGrayEnv)();

                _axios2.default.post('/proxy-api/client/user/index/web-login', _qs2.default.stringify(data)).then(function (result) {
                  if (+result.data.status === 0) {
                    _this2.$emit('hide');
                    (0, _message2.default)({
                      message: 'Success!',
                      type: 'success'
                    });
                    // if (this.rememberpw) {
                    //   this.saveEmailAndPassword()
                    // } else {
                    //   this.deleteEmailAndPassword()
                    // }
                    _this2.saveEmailAndPassword();
                    localStorage.vanishAccount = _this2.email;
                    localStorage.setItem('passwords', (0, _stringify2.default)(_this2.passwordArr));
                    (0, _utils.setLoginInfo)(result.data.payload);
                    (0, _utils.jumpToMainWeb)(result.data.payload['is_gray']);
                    // location.href = '../web/index.html'
                  } else if (+result.data.status === 4) {
                    console.log('device different. need scan login.');
                    // vanish haven't device indenity UI. So normal login.
                    _this2.$emit('hide');
                    (0, _message2.default)({
                      message: 'Please login from scan qrcode.!',
                      type: 'warning'
                    });
                    _this2.$router.push('/qrcode');
                  } else {
                    _this2.$emit('hide');
                    (0, _message2.default)({
                      message: result.data.msg,
                      type: 'error'
                    });
                  }
                }).catch(function (error) {
                  console.log(error);
                  _this2.$emit('hide');
                  (0, _message2.default)({
                    message: 'Warning!',
                    type: 'warning'
                  });
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(252);

var _index2 = _interopRequireDefault(_index);

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(79);

var _qs2 = _interopRequireDefault(_qs);

var _cryptoJs = __webpack_require__(77);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _GeneralVariable = __webpack_require__(108);

var _utils = __webpack_require__(95);

var _Cipher = __webpack_require__(106);

var _Cipher2 = _interopRequireDefault(_Cipher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      randomcode: '',
      aeskey: 0,
      ti: 0,
      qrcode: '',
      size: 240,
      flash: false
    };
  },
  mounted: function mounted() {
    if (location.search.indexOf('?ua=') > -1 && location.search.indexOf('&version=') > -1) {
      var version = location.search.substr(location.search.indexOf('&version=') + 9);
      var pcVersion = 'pc/' + version;
      localStorage.setItem('pcVersion', pcVersion);
    }
    this.longPolling();
  },

  methods: {
    refresh: function refresh() {
      this.flash = false;
      this.longPolling();
    },

    // 创建qrcode
    createqrcode: function createqrcode() {
      this.randomcode = new Date().getTime().toString() + this.rando(3);
      this.aeskey = this.rando(16);
      var qrcode = {
        'id': this.randomcode,
        'aeskey': this.aeskey,
        'platform': 'web'
      };
      this.qrcode = (0, _stringify2.default)(qrcode);
      this.ti++;
    },

    // 生成一个随机数
    rando: function rando(m) {
      var num = '';
      for (var i = 0; i < m; i++) {
        var val = parseInt(Math.random() * 10, 10);
        if (i === 0 && val === 0) {
          i--;
          continue;
        }
        num += val;
      }
      return num;
    },

    // 长连方法
    longPolling: function longPolling() {
      var _this = this;

      this.createqrcode();
      // 浏览器检测
      if (navigator.userAgent.indexOf('Chrome') === -1) {
        var messageTip = 'We highly recommend you to use Crait in Chrome for optimized user experience.';
        if (_config2.default.isVanish) {
          messageTip = 'We highly recommend you to use Vanish in Chrome for optimized user experience.';
        }
        _vue2.default.prototype.$message({
          showClose: true,
          //            message: '我们推荐您使用Chrome浏览器登录，以免出现兼容性问题！',
          message: messageTip,
          type: 'warning',
          duration: 0
        });
      } else {
        var ua = navigator.userAgent.toLowerCase();
        var s = ua.match(/chrome\/([\d.]+)/);
        if (parseInt(s[1]) < 62 && !(ua.indexOf('electron') > -1)) {
          _vue2.default.prototype.$message({
            showClose: true,
            //            message: '我们推荐您使用Chrome浏览器登录，以免出现兼容性问题！',
            message: 'The version of Chrome you are using is old. Update your browser to optimize user experience.',
            type: 'warning',
            duration: 0
          });
        }
      }
      (0, _axios2.default)({
        url: '/proxy-api/client/user/index/scan-login',
        params: {
          id: this.randomcode
        },
        method: 'post',
        timeout: 30000,
        responseType: 'json'
      }).then(function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(result) {
          var payload, rpayload, aeskeyhandle, decrypted, content, email, password, privatekey, publickey, loginAccount, type, data, deviceInfo;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  payload = result.data.payload;
                  rpayload = payload.replaceAll('%2B', '+');
                  aeskeyhandle = _cryptoJs2.default.enc.Latin1.parse(_this.aeskey);
                  decrypted = _cryptoJs2.default.AES.decrypt(rpayload, aeskeyhandle, {
                    iv: aeskeyhandle,
                    mode: _cryptoJs2.default.mode.ECB,
                    padding: _cryptoJs2.default.pad.Pkcs7
                  });
                  content = decrypted.toString(_cryptoJs2.default.enc.Utf8);

                  content = JSON.parse(content);
                  email = content['email'];
                  password = content['password'];
                  privatekey = content['private_key'];
                  publickey = content['public_key'] || '';
                  loginAccount = content['login_account'];
                  type = content['type'];
                  // 存入ls
                  //          localStorage.setItem(email + '_privatekey', privatekey)
                  //          if (publickey) {
                  //            localStorage.setItem(email + '_publickey', publickey)
                  //          }

                  // 登录

                  data = {};

                  if (+type === 1) {
                    if (privatekey) {
                      localStorage.setItem(loginAccount + '_privatekey', privatekey);
                    }
                    if (publickey) {
                      localStorage.setItem(loginAccount + '_publickey', publickey);
                    }
                    data = {
                      phone_md5: _cryptoJs2.default.MD5(loginAccount).toString().substr(8, 16),
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2,
                      // 此cryptojs版本有bug，需要tostring转换一下
                      key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                    };
                  } else if (+type === 0) {
                    email = loginAccount || email;
                    if (privatekey) {
                      localStorage.setItem(email + '_privatekey', privatekey);
                    }
                    if (publickey) {
                      localStorage.setItem(email + '_publickey', publickey);
                    }
                    data = {
                      email: email,
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2,
                      // 此cryptojs版本有bug，需要tostring转换一下
                      key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                    };
                  } else if (+type === 2) {
                    if (privatekey) {
                      localStorage.setItem(loginAccount + '_privatekey', privatekey);
                    }
                    if (publickey) {
                      localStorage.setItem(loginAccount + '_publickey', publickey);
                    }
                    data = {
                      account_id: loginAccount,
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2,
                      key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                    };
                  }

                  if (!localStorage.getItem('pcVersion')) {
                    data['useragent'] = 'web';
                  } else {
                    data['useragent'] = localStorage.getItem('pcVersion');
                  }

                  // data add scan login flag.
                  data['is_scan'] = _GeneralVariable.ScanFlag.IS_SCAN_LOGIN;
                  // add device info.
                  _context.next = 18;
                  return (0, _utils.getDeviceInfo)();

                case 18:
                  deviceInfo = _context.sent;

                  data['device_name'] = deviceInfo.deviceName;
                  data['device_id'] = deviceInfo.deviceId;
                  data['temporary_gray'] = (0, _utils.isGrayEnv)();

                  _this.login(data);

                case 23:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (XMLHttpRequest, textStatus, errorThrown) {
        if (_this.ti < 3) {
          _this.longPolling();
          _this.ti++;
        } else {
          _this.flash = true;
        }
      });
    },

    // 登录方法
    login: function login(data) {
      var _this2 = this;

      _axios2.default.post('/proxy-api/client/user/index/web-login', _qs2.default.stringify(data)).then(function (result) {
        console.log(result);
        if (result.data.status === '0') {
          localStorage.vanishAccount = result.data.payload.login_account;
          (0, _utils.setLoginInfo)(result.data.payload);
          (0, _utils.jumpToMainWeb)(result.data.payload['is_gray']);
          // location.href = '../web/index.html'
        } else {
          _this2.flash = true;
        }
      }).catch(function (error) {
        console.log(error);
        _this2.flash = true;
      });
    }
  },
  components: {
    Qrcode: _index2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(91);

var _message2 = _interopRequireDefault(_message);

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(79);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      username: '',
      email: '',
      password: '',
      confirm: ''
    };
  },

  methods: {
    signup: function signup() {
      var _this = this;

      // 有未填项
      console.log(this.privateKey);
      if (!this.username || !this.email || !this.password || !this.confirm) {
        (0, _message2.default)({
          message: 'Empty input!',
          type: 'error'
        });
        return;
      }
      // 验证两次输入密码是否一致
      if (this.password !== this.confirm) {
        (0, _message2.default)({
          message: 'Entered passwords differ!',
          type: 'error'
        });
        return;
      }
      // 发送请求
      this.$emit('show');
      _axios2.default.post('/proxy-api/client/user/index/register', _qs2.default.stringify({
        username: this.username,
        email: this.email,
        password: this.password,
        useragent: 'web'
      })).then(function (result) {
        console.log(result);
        if (result.data.status === '0') {
          _this.$emit('hide');
          (0, _message2.default)({
            message: 'Please check email to activate',
            type: 'success'
          });
          setTimeout(function () {
            location.href = './';
          }, 1000);
        } else {
          _this.$emit('hide');
          (0, _message2.default)({
            message: result.data.msg,
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$emit('hide');
        (0, _message2.default)({
          message: 'Warning!',
          type: 'warning'
        });
      });
    }
  }
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Common = __webpack_require__(7);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

var _utils = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isPc: Boolean,
      bgImg: _index2.default.getBackgroundImg()
    };
  },
  mounted: function mounted() {
    this.isPc = (0, _Common.checkDevice)();
    (0, _Common.changeTitle)();
    (0, _utils.checkVersion)();
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {};
  },

  props: ['type', 'content'],
  mounted: function mounted() {},

  methods: {
    clickIcon: function clickIcon() {
      if (!_config2.default.isLogin) {
        // 埋点统计：邀请页面点击切换账号
        (0, _UploadWebEvent2.default)('INVITE_SWITCH_BACK', {
          type: this.type
        });
      }
      if (_config2.default.isLogin && (this.$route.path === '/' || this.$route.path === '/login/signin')) {
        this.$emit('showPassword', false);
      } else {
        history.back();
      }
    }
  }
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _cryptoJs = __webpack_require__(77);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _Axios = __webpack_require__(82);

var _Common = __webpack_require__(7);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Cipher = __webpack_require__(106);

var _Cipher2 = _interopRequireDefault(_Cipher);

var _GeneralVariable = __webpack_require__(108);

var _utils = __webpack_require__(95);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      rolling: __webpack_require__(713),
      loadingImgUrl: __webpack_require__(705),
      loading: false,
      isGenericVersion: _index2.default.isGenericVersion(),
      params: {
        // 点击加入邀请
        join: {
          type: 'join',
          text: (0, _Translate2.default)('Join'),
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _data, type, password, account, publicKey, obj, that, callback1, callback2, res, code, route;

            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if ((0, _Common.checkEmpty)(this.data)) {
                      _context.next = 5;
                      break;
                    }

                    this.$emit('openErrorTip', 'EMPTY_ACCOUNT');
                    return _context.abrupt('return', false);

                  case 5:
                    _data = this.data, type = _data.type, password = _data.password, account = _data.account;
                    publicKey = (0, _Common.getPublicKey)(account);
                    obj = {};
                    that = this;

                    callback1 = function callback1(msg, status) {
                      if (status !== '0') {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      }
                    };

                    callback2 = function callback2(msg, status) {
                      // 埋点统计：邀请登录页面登录结果
                      (0, _UploadWebEvent2.default)('INVITE_JOIN_PASSWORD_RESULT', {
                        type: type,
                        status: status
                      });
                      if (status !== '0') {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      }
                    };
                    // 判断密码是否为空


                    if ((0, _Common.checkEmpty)(password)) {
                      _context.next = 15;
                      break;
                    }

                    // 埋点统计：邀请登录页面提示密码不合法
                    (0, _UploadWebEvent2.default)('INVITE_JOIN_PASSWORD_ERROR', {
                      type: type
                    });
                    this.$emit('openErrorTip', 'EMPTY_PASSWORD');
                    return _context.abrupt('return', false);

                  case 15:
                    this.loading = true;
                    if (type === 0) {
                      obj = {
                        email: account,
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey),
                        from: 'invite'
                      };
                    } else if (type === 1) {
                      obj = {
                        phone_md5: (0, _Common.getMD5)(account),
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey),
                        from: 'invite'
                      };
                    } else {
                      obj = {
                        account_id: account,
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey),
                        from: 'invite'
                      };
                    }

                    // data add scan login flag.
                    // obj['is_scan'] = ScanFlag.NOT_SCAN_LOGIN
                    // // add device info.
                    // let deviceInfo = await getDeviceInfo()
                    // obj['device_name'] = deviceInfo.deviceName
                    // obj['device_id'] = deviceInfo.deviceId

                    _context.next = 19;
                    return (0, _Axios.post)('/proxy-api/client/user/index/web-login', obj, callback1, (0, _Common.getLocationHash)());

                  case 19:
                    res = _context.sent;
                    code = res.data.payload.code;
                    _context.next = 23;
                    return (0, _Axios.post)('/proxy-api/client/web/index/share-complete-new', { code: code, invite_token: this.$route.query['token'], from: this.$route.query['from'], language: (0, _Common.browserLanguage)() }, callback2, (0, _Common.getLocationHash)());

                  case 23:
                    route = {
                      path: '/invite/invitesuccess',
                      query: {
                        account: account,
                        type: 3
                      }
                    };
                    return _context.abrupt('return', route);

                  case 25:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          })).bind(this)
        },
        // 输入账号点击登录
        signin: {
          type: 'signin',
          text: (0, _Translate2.default)('Sign in'),
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var that, callback, res, user, countryCode, publicKey, keyMd5, route, _res, type, _that, _callback;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if ((0, _Common.checkEmpty)(this.data)) {
                      _context2.next = 5;
                      break;
                    }

                    this.$emit('openErrorTip', 'EMPTY_ACCOUNT');
                    return _context2.abrupt('return', false);

                  case 5:
                    this.loading = true;
                    that = this;

                    callback = function callback(msg, status) {
                      if (status !== '0') {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      }
                    };
                    // 检测账号是否存在


                    _context2.next = 10;
                    return (0, _Axios.post)('/proxy-api/client/web/index/check-account-exist', { account: this.data }, callback, (0, _Common.getLocationHash)());

                  case 10:
                    res = _context2.sent;
                    user = res.data.payload.user;

                    if (!(res.data.payload.is_exist === 1)) {
                      _context2.next = 34;
                      break;
                    }

                    countryCode = user.countryCode || '';
                    publicKey = (0, _Common.getPublicKey)(this.data);
                    keyMd5 = _cryptoJs2.default.MD5(publicKey).toString().substr(8, 16);
                    route = {
                      query: {
                        account: this.data,
                        countryCode: countryCode,
                        showTip: true
                      }
                      // 检测是否需要扫码
                    };
                    _context2.next = 19;
                    return (0, _Axios.checkScan)(route, { account: this.data, key_md5: keyMd5 }, callback, (0, _Common.getLocationHash)());

                  case 19:
                    _res = _context2.sent;
                    type = 2;

                    if ((0, _Common.checkEmail)(this.data)) type = 0;
                    if ((0, _Common.checkPhone)(this.data)) type = 1;

                    if (!(_res.path === '/login/scan')) {
                      _context2.next = 28;
                      break;
                    }

                    // 埋点统计：登录页面输入强制跳转到扫码
                    if (!this.isGenericVersion) {
                      (0, _UploadWebEvent2.default)('SIGNIN_INPUT_TO_SCAN', {
                        type: type
                      });
                    }
                    return _context2.abrupt('return', _res);

                  case 28:
                    if (!(_res.path === '/login/password')) {
                      _context2.next = 32;
                      break;
                    }

                    // 埋点统计：登录页面输入强制跳转到下一步登录
                    if (!this.isGenericVersion) {
                      (0, _UploadWebEvent2.default)('SIGNIN_INPUT_TO_NEXT', {
                        type: type
                      });
                    }
                    this.$emit('showPassword', true);
                    return _context2.abrupt('return', false);

                  case 32:
                    _context2.next = 40;
                    break;

                  case 34:
                    _that = this;

                    _callback = function _callback(msg, status) {
                      if (status !== '0') {
                        _that.$emit('openErrorTip', msg);
                        _that.loading = false;
                      }
                    };

                    if (!(0, _Common.checkInputAccount)(this.data, _callback, 'signin')) {
                      _context2.next = 40;
                      break;
                    }

                    if (!_that.isGenericVersion) {
                      (0, _UploadWebEvent2.default)('SIGNIN_ACCOUNT_NOT_EXIST'); // 埋点统计：登录页面输入并提示账号不存在
                    }
                    this.$emit('accountNotExist');
                    return _context2.abrupt('return', false);

                  case 40:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          })).bind(this)
        },
        // 输入密码点击登录
        login: {
          type: 'login',
          text: (0, _Translate2.default)('Sign in'),
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var _data2, type, password, account, publicKey, obj, that, callback, deviceInfo;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _data2 = this.data, type = _data2.type, password = _data2.password, account = _data2.account;
                    publicKey = (0, _Common.getPublicKey)(account);
                    obj = {};
                    that = this;

                    callback = function callback(msg, status, payload) {
                      // 埋点统计：登录输入密码登录结果
                      if (!that.isGenericVersion) {
                        (0, _UploadWebEvent2.default)('SIGNIN_PASSWORD_RESULT', {
                          type: type,
                          status: status
                        });
                      }
                      if (+status === 0) {
                        (0, _Common.savePwd)(payload, password);
                        that.$emit('loginSuccess', password);
                        (0, _utils.setLoginInfo)(payload);
                        (0, _utils.jumpToMainWeb)(payload['is_gray']);
                      } else if (+status === 4) {
                        // need to indify device info.
                        console.log('device different. need scan login.');
                        var route = {
                          path: '/login/indifyDevice',
                          query: {
                            countryCode: payload['country_code'],
                            phone: payload['phone'],
                            email: payload['email'],
                            code: payload['code']
                          }
                        };
                        that.$router.push(route);
                      } else {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                        if (payload && +payload['need_scan'] === 1) that.$emit('loginSuccess');
                      }
                    };
                    // 判断密码是否为空


                    if ((0, _Common.checkEmpty)(password)) {
                      _context3.next = 8;
                      break;
                    }

                    this.$emit('openErrorTip', 'EMPTY_PASSWORD');
                    return _context3.abrupt('return', false);

                  case 8:
                    this.loading = true;
                    if (type === 0) {
                      obj = {
                        email: account,
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey)
                      };
                    } else if (type === 1) {
                      obj = {
                        phone_md5: (0, _Common.getMD5)(account),
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey)
                      };
                    } else {
                      obj = {
                        account_id: account,
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey)
                      };
                    }
                    if (!localStorage.getItem('pcVersion')) {
                      obj['useragent'] = 'web';
                    } else {
                      obj['useragent'] = localStorage.getItem('pcVersion');
                    }

                    // data add scan login flag.
                    obj['is_scan'] = _GeneralVariable.ScanFlag.NOT_SCAN_LOGIN;
                    // add device info.
                    _context3.next = 14;
                    return (0, _utils.getDeviceInfo)();

                  case 14:
                    deviceInfo = _context3.sent;

                    obj['device_name'] = deviceInfo.deviceName;
                    obj['device_id'] = deviceInfo.deviceId;
                    obj['temporary_gray'] = (0, _utils.isGrayEnv)();
                    _context3.next = 20;
                    return (0, _Axios.post)('/proxy-api/client/user/index/web-login', obj, callback);

                  case 20:
                    return _context3.abrupt('return', false);

                  case 21:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          })).bind(this)
        },
        // 点击继续
        continue: {
          type: 'continue',
          text: (0, _Translate2.default)('Continue'),
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var that, callback, res, route;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if ((0, _Common.checkEmpty)(this.data)) {
                      _context4.next = 5;
                      break;
                    }

                    this.$emit('openErrorTip', 'EMPTY_ACCOUNT');
                    return _context4.abrupt('return', false);

                  case 5:
                    this.loading = true;
                    that = this;

                    callback = function callback(msg, status) {
                      if (status !== '0') {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      }
                    };
                    // 检测账号是否存在


                    _context4.next = 10;
                    return (0, _Axios.post)('/proxy-api/client/web/index/check-account-exist', { account: this.data }, callback, (0, _Common.getLocationHash)());

                  case 10:
                    res = _context4.sent;
                    route = {
                      query: {
                        account: this.data
                      }
                    };

                    if (!(res.data.payload.is_exist === 0)) {
                      _context4.next = 21;
                      break;
                    }

                    if (!(0, _Common.checkInputAccount)(this.data, callback, 'signup')) {
                      _context4.next = 18;
                      break;
                    }

                    if (_config2.default.isLogin) {
                      route['path'] = '/login/signupnext';
                    } else {
                      route['query']['token'] = this.$route.query['token'];
                      route['query']['from'] = this.$route.query['from'];
                      route['path'] = '/invite/invitenext';
                    }
                    return _context4.abrupt('return', route);

                  case 18:
                    return _context4.abrupt('return', false);

                  case 19:
                    _context4.next = 32;
                    break;

                  case 21:
                    if (!_config2.default.isLogin) {
                      _context4.next = 27;
                      break;
                    }

                    (0, _UploadWebEvent2.default)('SIGNUP_ACCOUNT_EXIST'); // 埋点统计：注册页面提示账号已存在
                    this.$emit('accountExist');
                    return _context4.abrupt('return', false);

                  case 27:
                    (0, _UploadWebEvent2.default)('INVITE_ACCOUNT_EXIST'); // 埋点统计：邀请页面提示账号已存在
                    route['query']['token'] = this.$route.query['token'];
                    route['query']['from'] = this.$route.query['from'];
                    route['path'] = '/invite/accountexist';
                    return _context4.abrupt('return', route);

                  case 32:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          })).bind(this)
        },
        // 点击重置密码
        reset: {
          type: 'reset',
          text: 'Reset password',
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            var _$route$query, account, countryCode, isEmail, _data3, code, password, type, that, callback, oData, callback2, res, validateToken, _oData;

            return _regenerator2.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _$route$query = this.$route.query, account = _$route$query.account, countryCode = _$route$query.countryCode, isEmail = _$route$query.isEmail;
                    _data3 = this.data, code = _data3.code, password = _data3.password;
                    type = isEmail === true || isEmail === 'true' ? 0 : 1;
                    that = this;

                    callback = function callback(msg, status) {
                      // 埋点统计：重置密码结果
                      (0, _UploadWebEvent2.default)('RESET_PASSWORD_RESULT', {
                        type: type,
                        status: status
                      });
                      if (status !== '0') {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      }
                    };
                    // 判断验证码是否为空


                    if ((0, _Common.checkEmpty)(code)) {
                      _context5.next = 9;
                      break;
                    }

                    // 埋点统计：重置密码页面验证码错误
                    (0, _UploadWebEvent2.default)('RESET_PASSWORD_ERROR', {
                      type: type
                    });
                    this.$emit('openErrorTip', 'EMPTY_CODE');
                    return _context5.abrupt('return', false);

                  case 9:
                    if ((0, _Common.checkEmpty)(password)) {
                      _context5.next = 13;
                      break;
                    }

                    // 埋点统计：重置密码页面验证码错误
                    (0, _UploadWebEvent2.default)('RESET_PASSWORD_ERROR', {
                      type: type
                    });
                    this.$emit('openErrorTip', 'EMPTY_PASSWORD');
                    return _context5.abrupt('return', false);

                  case 13:
                    if (!(password.length < 6)) {
                      _context5.next = 17;
                      break;
                    }

                    // 埋点统计：重置密码页面验证码错误
                    (0, _UploadWebEvent2.default)('RESET_PASSWORD_ERROR', {
                      type: type
                    });
                    this.$emit('openErrorTip', 'INVALID_PASSWORD');
                    return _context5.abrupt('return', false);

                  case 17:
                    this.loading = true;

                    if (!(type === 0)) {
                      _context5.next = 25;
                      break;
                    }

                    oData = {
                      email: account,
                      capture: code,
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2
                    };
                    _context5.next = 22;
                    return (0, _Axios.post)('/proxy-api/client/web/index/reset-password-by-email', oData, callback, (0, _Common.getLocationHash)());

                  case 22:
                    return _context5.abrupt('return', { path: '/login/resetsuccess' });

                  case 25:
                    callback2 = function callback2(msg, status) {
                      if (status !== '0') {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      }
                    };

                    _context5.next = 28;
                    return (0, _Axios.post)('/proxy-api/client/phone/index/validate-capture', { phone_num: account, country_code: countryCode, capture: code, type: 1, language: (0, _Common.browserLanguage)() }, callback2, (0, _Common.getLocationHash)());

                  case 28:
                    res = _context5.sent;
                    validateToken = res.data.payload['validate_token'];
                    _oData = {
                      phone_md5: _cryptoJs2.default.MD5(account).toString().substr(8, 16),
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2,
                      validate_token: validateToken
                    };
                    _context5.next = 33;
                    return (0, _Axios.post)('/proxy-api/client/phone/index/forget-password', _oData, callback, (0, _Common.getLocationHash)());

                  case 33:
                    return _context5.abrupt('return', { path: '/login/resetsuccess' });

                  case 34:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          })).bind(this)
        },
        // 回退
        back: {
          type: 'back',
          text: (0, _Translate2.default)('Back'),
          fn: function () {
            var type = this.data ? this.data.type : 3;
            if (_config2.default.isLogin) {
              // 埋点统计：注册页面返回上一步
              (0, _UploadWebEvent2.default)('SIGNUP_BACK', {
                type: type
              });
            } else {
              // 埋点统计：邀请页面返回上一步
              (0, _UploadWebEvent2.default)('INVITE_BACK', {
                type: type
              });
            }
            history.back();
            return false;
          }.bind(this)
        },
        // 下一步
        next: {
          type: 'next',
          text: (0, _Translate2.default)('Next'),
          fn: function () {
            if (_config2.default.isLogin) {
              (0, _UploadWebEvent2.default)('SIGNUPNEXT_PHONE_NEXT'); // 埋点统计：手机号注册姓名密码页点击下一步
            } else {
              (0, _UploadWebEvent2.default)('INVITENEXT_PHONE_NEXT'); // 埋点统计：手机号邀请姓名密码页点击下一步
            }
            var _data4 = this.data,
                username = _data4.username,
                password = _data4.password,
                account = _data4.account;
            // 判断name是否为空

            if (!(0, _Common.checkEmpty)(username)) {
              if (_config2.default.isLogin) {
                (0, _UploadWebEvent2.default)('SIGNUPNEXT_PHONE_ERROR'); // 埋点统计：手机号注册姓名密码页提示输入错误
              } else {
                (0, _UploadWebEvent2.default)('INVITENEXT_PHONE_ERROR'); // 埋点统计：手机号邀请姓名密码页提示输入错误
              }
              this.$emit('openErrorTip', 'EMPTY_NAME');
              return false;
            }
            // 判断密码是否为空
            if (!(0, _Common.checkEmpty)(password)) {
              if (_config2.default.isLogin) {
                (0, _UploadWebEvent2.default)('SIGNUPNEXT_PHONE_ERROR'); // 埋点统计：手机号注册姓名密码页提示输入错误
              } else {
                (0, _UploadWebEvent2.default)('INVITENEXT_PHONE_ERROR'); // 埋点统计：手机号邀请姓名密码页提示输入错误
              }
              this.$emit('openErrorTip', 'EMPTY_PASSWORD');
              return false;
            }
            // 判断密码是否少于六位
            if (password && password.length < 6) {
              if (_config2.default.isLogin) {
                (0, _UploadWebEvent2.default)('SIGNUPNEXT_PHONE_ERROR'); // 埋点统计：手机号注册姓名密码页提示输入错误
              } else {
                (0, _UploadWebEvent2.default)('INVITENEXT_PHONE_ERROR'); // 埋点统计：手机号邀请姓名密码页提示输入错误
              }
              this.$emit('openErrorTip', 'INVALID_PASSWORD');
              return false;
            }
            var route = {
              query: {
                account: account
              }
            };
            if (_config2.default.isLogin) {
              route['path'] = '/login/signupphone';
            } else {
              route['query']['token'] = this.$route.query['token'];
              route['query']['from'] = this.$route.query['from'];
              route['path'] = '/invite/invitephone';
            }
            _Common.transferData.saveData(this.data);
            return route;
          }.bind(this)
        },
        // 完成
        done: {
          type: 'done',
          text: (0, _Translate2.default)('Done'),
          fn: function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(from) {
              var _data5, type, username, password, account, capture, countryCode, validateToken, encryptStr, that, callback, callback2, obj, _res2, _obj, res, code, route;

              return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _data5 = this.data, type = _data5.type, username = _data5.username, password = _data5.password, account = _data5.account, capture = _data5.capture, countryCode = _data5.countryCode;

                      from = 'verifyLater';
                      validateToken = void 0;
                      encryptStr = void 0;
                      that = this;

                      callback = function callback(msg, status) {
                        if (_config2.default.isLogin) {
                          // 埋点统计：注册结果
                          (0, _UploadWebEvent2.default)('SIGNUP_RESULT', {
                            type: type,
                            status: status,
                            from: from
                          });
                        } else {
                          // 埋点统计：邀请注册结果
                          (0, _UploadWebEvent2.default)('INVITE_RESULT', {
                            type: type,
                            status: status,
                            from: from
                          });
                        }
                        if (status !== '0') {
                          that.$emit('openErrorTip', msg);
                          that.loading = false;
                        }
                      };

                      callback2 = function callback2(msg, status) {
                        if (status !== '0') {
                          that.$emit('openErrorTip', msg);
                          that.loading = false;
                        }
                      };
                      // 判断手机号是否有效


                      if (!(type === 1)) {
                        _context6.next = 12;
                        break;
                      }

                      if ((0, _Common.checkPhone)(account || this.$route.query['account'])) {
                        _context6.next = 12;
                        break;
                      }

                      if (_config2.default.isLogin) {
                        // 埋点统计：注册密码完成页输入错误
                        (0, _UploadWebEvent2.default)('SIGNUPNEXT_DONE_ERROR', {
                          type: type
                        });
                      } else {
                        // 埋点统计：邀请密码完成页输入错误
                        (0, _UploadWebEvent2.default)('INVITENEXT_DONE_ERROR', {
                          type: type
                        });
                      }
                      this.$emit('openErrorTip', 'INVALID_PHONE');
                      return _context6.abrupt('return', false);

                    case 12:
                      if ((0, _Common.checkEmpty)(username)) {
                        _context6.next = 16;
                        break;
                      }

                      if (_config2.default.isLogin) {
                        // 埋点统计：注册密码完成页输入错误
                        (0, _UploadWebEvent2.default)('SIGNUPNEXT_DONE_ERROR', {
                          type: type
                        });
                      } else {
                        // 埋点统计：邀请密码完成页输入错误
                        (0, _UploadWebEvent2.default)('INVITENEXT_DONE_ERROR', {
                          type: type
                        });
                      }
                      this.$emit('openErrorTip', 'EMPTY_NAME');
                      return _context6.abrupt('return', false);

                    case 16:
                      if ((0, _Common.checkEmpty)(password)) {
                        _context6.next = 20;
                        break;
                      }

                      if (_config2.default.isLogin) {
                        // 埋点统计：注册密码完成页输入错误
                        (0, _UploadWebEvent2.default)('SIGNUPNEXT_DONE_ERROR', {
                          type: type
                        });
                      } else {
                        // 埋点统计：邀请密码完成页输入错误
                        (0, _UploadWebEvent2.default)('INVITENEXT_DONE_ERROR', {
                          type: type
                        });
                      }
                      this.$emit('openErrorTip', 'EMPTY_PASSWORD');
                      return _context6.abrupt('return', false);

                    case 20:
                      if (!(password && password.length < 6)) {
                        _context6.next = 24;
                        break;
                      }

                      if (_config2.default.isLogin) {
                        // 埋点统计：注册密码完成页输入错误
                        (0, _UploadWebEvent2.default)('SIGNUPNEXT_DONE_ERROR', {
                          type: type
                        });
                      } else {
                        // 埋点统计：邀请密码完成页输入错误
                        (0, _UploadWebEvent2.default)('INVITENEXT_DONE_ERROR', {
                          type: type
                        });
                      }
                      this.$emit('openErrorTip', 'INVALID_PASSWORD');
                      return _context6.abrupt('return', false);

                    case 24:
                      // 判断验证码是否为空
                      // if (capture === '' && from !== 'verifyLater') {
                      //   if (config.isLogin) {
                      //     // 埋点统计：注册密码完成页输入错误
                      //     uploadWebEvent('SIGNUPNEXT_DONE_ERROR', {
                      //       type
                      //     })
                      //   } else {
                      //     // 埋点统计：邀请密码完成页输入错误
                      //     uploadWebEvent('INVITENEXT_DONE_ERROR', {
                      //       type
                      //     })
                      //   }
                      //   this.$emit('openErrorTip', 'EMPTY_CODE')
                      //   return false
                      // }
                      this.loading = true;

                      if (!(type === 0)) {
                        _context6.next = 30;
                        break;
                      }

                      obj = {
                        email: account,
                        password: password
                      };

                      encryptStr = (0, _stringify2.default)(obj);
                      _context6.next = 45;
                      break;

                    case 30:
                      if (!(type === 1)) {
                        _context6.next = 43;
                        break;
                      }

                      account = account || this.$route.query['account'];

                      if (!(from !== 'verifyLater')) {
                        _context6.next = 40;
                        break;
                      }

                      _context6.next = 35;
                      return (0, _Axios.post)('/proxy-api/client/phone/index/validate-capture', { capture: capture, country_code: countryCode, type: 0, phone_num: account, language: (0, _Common.browserLanguage)() }, callback2, (0, _Common.getLocationHash)());

                    case 35:
                      _res2 = _context6.sent;

                      validateToken = _res2.data.payload['validate_token'];
                      encryptStr = countryCode + '|' + account + '|' + password + '|' + validateToken;
                      _context6.next = 41;
                      break;

                    case 40:
                      // 稍后验证，跳过验证码接口
                      encryptStr = countryCode + '|' + account + '|' + password;

                    case 41:
                      _context6.next = 45;
                      break;

                    case 43:
                      _obj = {
                        account_id: account,
                        password: password
                      };

                      encryptStr = (0, _stringify2.default)(_obj);

                    case 45:
                      _context6.next = 47;
                      return (0, _Axios.post)('/proxy-api/client/user/index/register', { username: '', type: type, invite_token: this.$route.query['token'], encrypt_str: window.btoa(encryptStr), language: (0, _Common.browserLanguage)() }, callback, (0, _Common.getLocationHash)());

                    case 47:
                      res = _context6.sent;
                      code = res.data.payload.code;
                      route = {
                        query: {
                          account: account
                        }
                      };

                      if (!_config2.default.isLogin) {
                        _context6.next = 54;
                        break;
                      }

                      route['path'] = '/login/signupsuccess';
                      _context6.next = 58;
                      break;

                    case 54:
                      _context6.next = 56;
                      return (0, _Axios.post)('/proxy-api/client/web/index/share-complete-new', { code: code, invite_token: this.$route.query['token'], from: this.$route.query['from'], language: (0, _Common.browserLanguage)() }, callback2, (0, _Common.getLocationHash)());

                    case 56:
                      route['query']['type'] = type;
                      route['path'] = '/invite/invitesuccess';

                    case 58:
                      return _context6.abrupt('return', route);

                    case 59:
                    case 'end':
                      return _context6.stop();
                  }
                }
              }, _callee6, this);
            }));

            return function (_x) {
              return _ref6.apply(this, arguments);
            };
          }().bind(this)
        },
        // 下载
        open: {
          type: 'open',
          text: this.$route.query['user'] === 'old' ? (0, _Translate2.default)('Open/Download Crait') : (0, _Translate2.default)('Download Crait'),
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            var data, publicKey, keyMd5, route, res;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    data = this.$route.query.account;
                    publicKey = (0, _Common.getPublicKey)(data);
                    keyMd5 = _cryptoJs2.default.MD5(publicKey).toString().substr(8, 16);
                    route = {
                      query: {
                        account: data,
                        countryCode: '',
                        showTip: true
                      }
                    };

                    if (!_config2.default.isLogin) {
                      _context7.next = 11;
                      break;
                    }

                    _context7.next = 7;
                    return (0, _Axios.checkScan)(route, { account: data, key_md5: keyMd5 }, '', (0, _Common.getLocationHash)());

                  case 7:
                    res = _context7.sent;
                    return _context7.abrupt('return', res);

                  case 11:
                    if (_config2.default.type === 'newInvite') {
                      (0, _UploadWebEvent2.default)('DOWNLOAD', {
                        type: this.$route.query['user'] === 'old' ? 1 : 0
                      });
                    } else {
                      // 埋点统计：邀请成功界面点击Download/Open Crait
                      (0, _UploadWebEvent2.default)('INVITE_SUCCESS_OPEN', {
                        type: this.$route.query.type
                      });
                    }
                    if ((0, _Common.checkDevice)()) {
                      // location.href = 'https://www.craitapp.com/login/index.html#/login/signin'
                      location.href = 'https://dl.craitapp.com/?action=open&cmd=login&username=' + data;
                    } else {
                      // location.href = 'https://pre.craitapp.com/website/mweb/index.html?action=open&cmd=login&username=' + data
                      // location.href = 'https://share.craitapp.com/mweb/index.html?action=open&cmd=login&username=' + data
                      location.href = 'https://dl.craitapp.com/?action=open&cmd=login&username=' + data;
                    }
                    return _context7.abrupt('return', false);

                  case 14:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          })).bind(this)
        },
        // 前往注册页
        tosignup: {
          type: 'tosignup',
          text: (0, _Common.checkDevice)() ? (0, _Translate2.default)('Go to sign up page') : (0, _Translate2.default)('Open/Download Crait'),
          fn: function fn() {
            location.href = 'https://craitapp.com/login/index.html#/login/signup';
          }
        },
        // 开始安全通信
        StartSecureMessaging: {
          type: 'StartSecureMessaging',
          text: (0, _Translate2.default)('Start secure messaging'),
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
            var that, callback, res, route;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    if ((0, _Common.checkEmpty)(this.data)) {
                      _context8.next = 5;
                      break;
                    }

                    this.$emit('openErrorTip', 'EMPTY_ACCOUNT');
                    return _context8.abrupt('return', false);

                  case 5:
                    this.loading = true;
                    that = this;

                    callback = function callback(msg, status) {
                      if (status !== '0') {
                        (0, _Common.checkInputAccount)(that.data, function (error) {
                          that.$emit('openErrorTip', error || msg);
                        }, '', 0);
                        // that.$emit('openErrorTip', msg)
                        that.loading = false;
                      }
                    };
                    // 检测账号是否存在


                    _context8.next = 10;
                    return (0, _Axios.post)('/proxy-api/client/web/index/check-account-exist', { account: this.data, language: (0, _Common.browserLanguage)(), invite_token: this.$route.query['token'] }, callback, (0, _Common.getLocationHash)());

                  case 10:
                    res = _context8.sent;
                    route = {
                      query: {}
                    };

                    if (!(res.data.payload.is_exist === 0)) {
                      _context8.next = 28;
                      break;
                    }

                    if (_config2.default.type === 'newInvite') {
                      // 埋点统计：首页_开始安全通信 新用户
                      (0, _UploadWebEvent2.default)('START', {
                        type: 0
                      });
                    }

                    if (!(0, _Common.checkInputAccount)(this.data, callback, '', 1)) {
                      _context8.next = 25;
                      break;
                    }

                    route.query['user'] = 'new';
                    route.query['account'] = this.data;
                    route.query['invitename'] = (0, _Common.getInviteName)();
                    route.query['invitetype'] = (0, _Common.getInviteType)();
                    route.query['invitegroup'] = (0, _Common.getInviteGroup)();
                    route.query['inviteTeam'] = (0, _Common.getInviteTeam)();
                    route['path'] = '/invite/invitesuccess';
                    return _context8.abrupt('return', route);

                  case 25:
                    return _context8.abrupt('return', false);

                  case 26:
                    _context8.next = 46;
                    break;

                  case 28:
                    if (!(res.data.payload.is_exist === 1)) {
                      _context8.next = 44;
                      break;
                    }

                    if (_config2.default.type === 'newInvite') {
                      // 埋点统计：首页_开始安全通信 老用户
                      (0, _UploadWebEvent2.default)('START', {
                        type: 1
                      });
                    }
                    (0, _Common.addOldUserName)(res.data.payload.user.username);
                    route.query['account'] = this.data;
                    route.query['type'] = this.$route.query['type'];
                    route.query['token'] = this.$route.query['token'];
                    route.query['name'] = res.data.payload.user.username;
                    route.query['invitename'] = (0, _Common.getInviteName)();
                    route.query['invitetype'] = (0, _Common.getInviteType)();
                    route.query['invitegroup'] = (0, _Common.getInviteGroup)();
                    route.query['inviteTeam'] = (0, _Common.getInviteTeam)();
                    if (this.$route.query['source']) route.query['fromwebsite'] = 'true';
                    route['path'] = '/invite/invitenext';
                    return _context8.abrupt('return', route);

                  case 44:
                    (0, _Common.checkInputAccount)(this.data, function () {}, '', 0);
                    return _context8.abrupt('return', false);

                  case 46:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          })).bind(this)
        },
        // 接受邀请
        Accept: {
          type: 'Accept',
          text: (0, _Translate2.default)('Accept'),
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
            var _data6, type, password, account, publicKey, obj, that, callback1, callback2, res, code, route;

            return _regenerator2.default.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _data6 = this.data, type = _data6.type, password = _data6.password, account = _data6.account;
                    publicKey = (0, _Common.getPublicKey)(account);
                    obj = {};
                    that = this;

                    callback1 = function callback1(msg, status) {
                      if (status !== '0') {
                        (0, _UploadWebEvent2.default)('ACCEPT', {
                          result: 0
                        });
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      } else {
                        (0, _UploadWebEvent2.default)('ACCEPT', {
                          result: 1
                        });
                      }
                    };

                    callback2 = function callback2(msg, status) {
                      if (status !== '0') {
                        that.$emit('openErrorTip', msg);
                        that.loading = false;
                      }
                    };
                    // 判断密码是否为空


                    if ((0, _Common.checkEmpty)(password)) {
                      _context9.next = 9;
                      break;
                    }

                    this.$emit('openErrorTip', 'EMPTY_PASSWORD');
                    return _context9.abrupt('return', false);

                  case 9:
                    this.loading = true;
                    if (type === 0) {
                      obj = {
                        email: account,
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey),
                        from: 'invite'
                      };
                    } else if (type === 1) {
                      obj = {
                        phone_md5: (0, _Common.getMD5)(account),
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey),
                        from: 'invite'
                      };
                    } else {
                      obj = {
                        account_id: account,
                        password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                        decrypt_type: 2,
                        key_md5: (0, _Common.getMD5)(publicKey),
                        from: 'invite'
                      };
                    }
                    obj['language'] = (0, _Common.browserLanguage)();

                    // data add scan login flag.
                    // obj['is_scan'] = ScanFlag.NOT_SCAN_LOGIN
                    // // add device info.
                    // let deviceInfo = await getDeviceInfo()
                    // obj['device_name'] = deviceInfo.deviceName
                    // obj['device_id'] = deviceInfo.deviceId

                    _context9.next = 14;
                    return (0, _Axios.post)('/proxy-api/client/user/index/web-login', obj, callback1, (0, _Common.getLocationHash)());

                  case 14:
                    res = _context9.sent;
                    code = res.data.payload.code;
                    _context9.next = 18;
                    return (0, _Axios.post)('/proxy-api/client/web/index/share-complete-new', { code: code, invite_token: this.$route.query['token'], from: this.$route.query['from'], language: (0, _Common.browserLanguage)() }, callback2, (0, _Common.getLocationHash)());

                  case 18:
                    route = {
                      path: '/invite/invitesuccess',
                      query: {
                        user: 'old',
                        account: this.$route.query['account'],
                        invitename: this.$route.query['invitename'],
                        invitetype: this.$route.query['invitetype'],
                        invitegroup: this.$route.query['invitegroup'],
                        inviteTeam: this.$route.query['inviteTeam']
                      }
                    };
                    return _context9.abrupt('return', route);

                  case 20:
                  case 'end':
                    return _context9.stop();
                }
              }
            }, _callee9, this);
          })).bind(this)
        }
      }
    };
  },

  props: ['type', 'data'],
  mounted: function mounted() {
    if (this.type === 'tosignup') this.complie();
    if (!(0, _Common.checkDevice)()) {
      var button = document.getElementsByClassName('button')[0];
      // mobile reset width.
      button.style.width = '100%';

      var buttons = document.getElementsByClassName('buttons')[0];
      // reset 86% width.
      buttons.style.width = '86%';
      // element center.
      buttons.style.margin = '0 auto';
    } else {
      var _buttons = document.getElementsByClassName('buttons')[0];
      if (this.isGenericVersion) {
        _buttons.style.background = 'green';
        _buttons.style.border = '1px solid green';
      }
    }
  },

  methods: {
    complie: function complie() {
      var href = '';
      if ((0, _Common.checkDevice)()) {
        href = 'https://craitapp.com/login/index.html#/login/signup';
      } else {
        // href = 'https://pre.craitapp.com/website/mweb/index.html?action=open&cmd=login&username='
        href = 'https://share.craitapp.com/mweb/index.html?action=open&cmd=login&username=';
      }
      var Component = _vue2.default.extend({
        template: '<a :href="href" style="width: 200px; height: 40px; display: inherit; margin: -30px 0 0 -11px;"></a>',
        props: ['href']
      });
      var component = new Component({
        propsData: {
          href: href
        }
      }).$mount();
      this.$refs['buttonDOM'].appendChild(component.$el);
    },
    clickBtn: function clickBtn(from) {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
        var res;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (_this.loading) {
                  _context10.next = 7;
                  break;
                }

                _this.$emit('closeErrorTip');
                _context10.next = 4;
                return _this.params[_this.type].fn(from);

              case 4:
                res = _context10.sent;

                _this.loading = false;
                if (res !== false) _this.$router.push(res);

              case 7:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this);
      }))();
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _CountryCode = __webpack_require__(107);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      menuShow: false,
      code: '',
      user: {},
      alphaCode: '',
      countryCode: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var res;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _CountryCode.getCountryCode)();

            case 2:
              res = _context.sent;

              _this.countryCode = res.countryInfo;
              _this.user = res.user;
              _this.code = _this.user['country_code'];
              _this.alphaCode = _this.user.alphaCode;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    code: function code() {
      this.$emit('sendCountryCode', this.code);
    }
  },
  methods: {
    selectCountry: function selectCountry(country) {
      if (_config2.default.isLogin) {
        (0, _UploadWebEvent2.default)('SIGNUP_PHONE_COUNTRYCODE'); // 埋点统计：手机号注册输入验证码页面切换国别码
      } else {
        (0, _UploadWebEvent2.default)('INVITE_PHONE_COUNTRYCODE'); // 埋点统计：手机号注册输入验证码页面切换国别码
      }
      this.code = country.code;
      this.alphaCode = country.alphaCode;
    },
    clickOutside: function clickOutside() {
      this.menuShow = false;
    },
    switchMenuShow: function switchMenuShow() {
      this.menuShow = !this.menuShow;
      // let aaa = document.getElementsByTagName('body')[0]
      // let bbb = document.getElementsByTagName('body')[0].lastChild.style.cssText
      // let ccc = bbb.indexOf('left: ') + 5
      // let ddd = bbb.indexOf('px; transform')
      // let eee = +bbb.substring(ccc, ddd) + 110
      // document.getElementsByTagName('body')[0].lastChild.style.cssText = bbb.substring(0, ccc) + eee + bbb.substring(ddd)
      // console.log(document.getElementsByTagName('body')[0].lastChild.style.cssText)
      // document.getElementsByTagName('body')[0].lastChild.style.marginLeft = eee + 'px'
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['type', 'msg'],
  methods: {
    close: function close() {
      this.$emit('closeErrorTip');
    }
  }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      params: {
        // 已经有账号，登录
        'Already using crait': {
          text: 'Already using crait?',
          router: 'sign in',
          fn: function fn() {
            (0, _UploadWebEvent2.default)('SINGUP_TO_SIGNIN'); // 埋点统计：注册页面主动跳转到登录页面
            return '/login/signin';
          }
        },
        // 没有账号，注册
        'No using crait': {
          text: "Don't have account?",
          router: 'sign up',
          fn: function fn() {
            (0, _UploadWebEvent2.default)('SINGIN_TO_SIGNUP'); // 埋点统计：登录页面主动跳转到注册页面
            return '/login/signup';
          }
        },
        // 扫码登录
        'Scan the QR code to sign in': {
          text: (0, _Translate2.default)('Scan the QR code to sign in')
        },
        // 忘记密码
        'Forgot password': {
          router: (0, _Translate2.default)('Forgot password'),
          fn: function () {
            // 埋点统计：登录页面点击重置密码
            if (!_index2.default.isGenericVersion()) {
              (0, _UploadWebEvent2.default)('SIGNIN_TO_RESET', {
                type: this.isEmail ? 0 : 1
              });
            }
            var routerPath = _index2.default.isGenericVersion() ? '/login/genericforgotpassword' : '/login/forgotpassword';
            return { path: routerPath, query: { account: this.account, countryCode: this.$route.query.countryCode, isEmail: this.isEmail } };
          }.bind(this)
        },
        'or Sign in': {
          text: 'or',
          router: 'Sign in',
          fn: function () {
            // 埋点统计：重置密码页面点击回到登录页
            if (!_index2.default.isGenericVersion()) {
              (0, _UploadWebEvent2.default)('RESET_BACK_TO_SIGNIN', {
                type: this.isEmail ? 0 : 1
              });
            }
            return '/login/signin';
          }.bind(this)
        },
        // 退到登录页面
        'Going back to sign in page': {
          router: 'Going back to sign in page',
          fn: function fn() {
            return '/login/signin';
          }
        }
      },
      isGenericVersion: _index2.default.isGenericVersion()
    };
  },

  props: ['type', 'isEmail', 'account'],
  mounted: function mounted() {
    var _this = this;

    // 注册成功后5s后跳转到登录页
    if (this.type === 'Going back to sign in page') {
      var sec = 5;
      this.params[this.type].router = 'Going back to sign in page(' + sec + 's)';
      var time = setInterval(function () {
        sec--;
        _this.params[_this.type].router = 'Going back to sign in page(' + sec + 's)';
        if (sec === 0) {
          clearInterval(time);
          _this.$router.push('/login/signin');
        }
      }, 1000);
    }
    console.log(this.params, this.type);
  },

  methods: {
    clickRouter: function clickRouter() {
      var res = this.params[this.type].fn();
      this.$router.push(res);
    },
    help: function help() {
      this.$emit('scanHelp');
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Axios = __webpack_require__(82);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      code: (0, _Translate2.default)('Send Code'),
      account: this.$route.query.account,
      countryCode: this.$route.query.countryCode,
      isEmail: this.$route.query.isEmail
    };
  },

  props: ['type', 'data'],
  mounted: function mounted() {},

  methods: {
    // 点击获取验证码
    sendCode: function sendCode() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var sec, time, that, callback;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.code === 'Send Code' || _this.code === '获取验证码')) {
                  _context.next = 15;
                  break;
                }

                sec = 60;

                _this.code = sec + 's';
                time = setInterval(function () {
                  sec--;
                  _this.code = sec + 's';
                  if (sec === 0) {
                    clearInterval(time);
                    _this.code = (0, _Translate2.default)('Send Code');
                  }
                }, 1000);

                if (!(_this.isEmail === true || _this.isEmail === 'true')) {
                  _context.next = 10;
                  break;
                }

                (0, _UploadWebEvent2.default)('EMAIL_SEND_CODE'); // 埋点统计：邮箱重置密码页面获取验证码
                _context.next = 8;
                return (0, _Axios.post)('/proxy-api/client/web/index/send-email-capture', { email: _this.account });

              case 8:
                _context.next = 15;
                break;

              case 10:
                if (_this.$route.name === 'Signupphone') {
                  (0, _UploadWebEvent2.default)('PHONE_SIGNUP_SEND_CODE'); // 埋点统计：手机号注册点击获取手机验证码
                } else if (_this.$route.name === 'ForgotPassword') {
                  (0, _UploadWebEvent2.default)('PHONE_RESET_SEND_CODE'); // 埋点统计：手机号重置密码页面获取验证码
                } else if (_this.$route.name === 'InvitePhone') {
                  (0, _UploadWebEvent2.default)('PHONE_INVITE_SEND_CODE'); // 埋点统计：手机号邀请注册页面获取验证码
                }
                that = _this;

                callback = function callback(msg, status) {
                  if (status !== '0') {
                    that.$emit('openErrorTip', msg);
                    clearInterval(time);
                    that.code = (0, _Translate2.default)('Send Code');
                  }
                };

                _context.next = 15;
                return (0, _Axios.post)('/proxy-api/client/phone/index/send-capture', { phone_num: _this.data.phone || _this.account, type: +_this.type, country_code: _this.data.countryCode || '', language: (0, _Common.browserLanguage)() }, callback, (0, _Common.getLocationHash)());

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    imgSize: function imgSize() {
      var size = {
        width: 160 + 'px',
        height: 64 + 'px'
        // special logo.
      };if (this.isGenericVersion) {
        size.width = 180 + 'px';
        size.height = 53 + 'px';
      }
      return size;
    }
  },
  data: function data() {
    return {
      logo: _index2.default.getAppIcon(),
      isGenericVersion: _index2.default.isGenericVersion()
    };
  }
}; //
//
//
//
//
//

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _qrcode = __webpack_require__(710);

var _qrcode2 = _interopRequireDefault(_qrcode);

var _qrcode_hover = __webpack_require__(711);

var _qrcode_hover2 = _interopRequireDefault(_qrcode_hover);

var _password = __webpack_require__(708);

var _password2 = _interopRequireDefault(_password);

var _password_hover = __webpack_require__(709);

var _password_hover2 = _interopRequireDefault(_password_hover);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      src: '',
      params: {
        // 跳转扫码登录页面
        qrcode: {
          router: '/login/scan'
        },
        // 跳转账号登录页面
        account: {
          router: '/login/signin'
        }
      },
      isGenericVersion: _index2.default.isGenericVersion()
    };
  },

  props: ['type'],
  mounted: function mounted() {
    this.mouseleaveIcon();
  },

  methods: {
    clickIcon: function clickIcon() {
      if (this.$route.path === '/login/scan') {
        if (!this.isGenericVersion) {
          (0, _UploadWebEvent2.default)('SCAN_TO_SIGNIN'); // 埋点统计：扫码界面切换回登录界面
        }

        if ((0, _keys2.default)(this.$route.query).length === 0) {
          history.back();
        } else {
          this.$router.push({ path: '/login/signin' });
        }
      } else {
        if (!this.isGenericVersion) {
          (0, _UploadWebEvent2.default)('SIGNIN_TO_SCAN'); // 埋点统计：登录页面切换到扫码页面
        }
        this.$router.push({ path: '/login/scan' });
      }
    },
    mouseoverIcon: function mouseoverIcon() {
      if (this.type === 'qrcode') {
        this.src = _qrcode_hover2.default;
      } else {
        this.src = _password_hover2.default;
      }
    },
    mouseleaveIcon: function mouseleaveIcon() {
      if (this.type === 'qrcode') {
        this.src = _qrcode2.default;
      } else {
        this.src = _password2.default;
      }
    }
  }
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Common = __webpack_require__(7);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      isPC: (0, _Common.checkDevice)(),
      text: this.remember ? this.remember.password : '',
      inputType: 'text',
      rememberpw: this.remember ? this.remember.rememberpw : false,
      rememberPasswordTip: (0, _Translate2.default)('remember password'),
      passwordLevel: 0,
      bgWhite: false,
      autofocus: false,
      params: {
        // 账号输入
        account: {
          type: 'account',
          placeholder: _index2.default.isGenericVersion() ? (0, _Translate2.default)('Your email') : (0, _Translate2.default)('Your email, phone number or username')
        },
        // 密码输入
        password: {
          type: 'password',
          placeholder: (0, _Translate2.default)('Your password')
        },
        // 验证码
        code: {
          type: 'code',
          placeholder: (0, _Translate2.default)('Verification code')
        },
        // 新密碼輸入
        newpassword: {
          type: 'newpassword',
          placeholder: (0, _Translate2.default)('New password')
        },
        // 输入姓名
        name: {
          type: 'name',
          placeholder: (0, _Translate2.default)('Name')
        },
        // 输入手机号
        phone: {
          type: 'phone',
          placeholder: this.$route.query.account
        },
        // 账号不存在
        accountnotexist: {
          type: 'accountnotexist',
          placeholder: this.$route.query.account
        },
        // 账号存在
        accountexist: {
          type: 'accountexist',
          placeholder: 'Your email or phone number'
        },
        // 新邀请页账号输入
        inviteAccount: {
          type: 'inviteAccount',
          placeholder: this.$route.query.source === 'website' ? (0, _Translate2.default)('Enter email, phone or username to register') : (0, _Translate2.default)('input your mobile number or email here')
        }
      }
    };
  },

  props: ['type', 'remember', 'readonly', 'change'],
  mounted: function mounted() {
    if (this.type === 'password' || this.type === 'newpassword') {
      this.inputType = 'password';
    }
    this.$refs.input.type = this.inputType;
    // 登录页默认传入上一次输入的账号
    if (_config2.default.isLogin && (this.$route.path === '/login/signin' || this.$route.path === '/') && this.type === 'account') {
      var text = void 0;
      if (localStorage.getItem('passwords') && JSON.parse(localStorage.getItem('passwords'))[0]) {
        text = (0, _keys2.default)(JSON.parse(localStorage.getItem('passwords'))[0])[0];
      } else if (localStorage.getItem('vanishAccount')) {
        text = localStorage.getItem('vanishAccount');
      }
      if (text !== 'undefined') this.text = text;
    }
    // 登录页或者注册页，如果路由里带有账号参数，将该参数设为默认值
    if ((this.$route.path === '/login/signup' || this.$route.query.source === 'website') && this.$route.query.account) {
      this.text = this.$route.query.account;
    }
    // 登录页面自动获取焦点
    if (this.$route.path === '/login/signin' || this.$route.path === '/' || this.$route.path === '/login/password') {
      setTimeout(function () {
        document.getElementsByClassName('inputs')[0].focus();
        // document.getElementsByClassName('inputs')[0].click()
      }, 0);
    }
    if (!this.isPC) {
      var input = document.getElementsByClassName('input')[0];
      // mobile reset width.
      input.style.width = '100%';

      var inputs = document.getElementsByClassName('inputs')[0];
      // reset 86% width.
      inputs.style.width = '86%';
      // element center.
      inputs.style.margin = '0 auto';
      if (this.type === 'password' || this.type === 'newpassword') {
        var password = document.getElementById('password');
        // element right 8%.
        password.style.marginRight = '8%';
      }
    }
  },

  watch: {
    text: function text() {
      // this.bgWhite = true
      this.$emit('inputText', this.text);
      // 检测密码安全等级
      this.checkPasswordLevel();
    },
    inputType: function inputType() {
      this.$refs.input.type = this.inputType;
    },
    rememberpw: function rememberpw() {
      this.$emit('rememberpw', this.rememberpw);
    },
    change: function change() {
      this.text = this.remember.password || '';
      this.rememberpw = this.remember.rememberpw || false;
    }
  },
  methods: {
    // 显示或隐藏密码
    showPasswordOrNot: function showPasswordOrNot() {
      if (this.inputType === 'text') {
        this.inputType = 'password';
      } else {
        this.inputType = 'text';
      }
    },

    // 是否记住密码
    rememberPassword: function rememberPassword() {
      this.rememberpw = !this.rememberpw;
    },

    // 检测密码安全等级
    checkPasswordLevel: function checkPasswordLevel() {
      var strongRegex = new RegExp('^(?=.{10,})((?=.*[A-Z])|(?=.*[a-z]))(?=.*[0-9])(?=.*[!@#$%^&*()_?<>{}]).*$', 'g');
      var mediumRegex = new RegExp('^(?=.{9,})((?=.*[A-Z])|(?=.*[a-z]))(?=.*[0-9]).*$', 'g');
      var enoughRegex = new RegExp('(?=.{6,}).*', 'g');
      if (strongRegex.test(this.text)) {
        this.passwordLevel = 3;
      } else if (mediumRegex.test(this.text)) {
        this.passwordLevel = 2;
      } else if (enoughRegex.test(this.text)) {
        this.passwordLevel = 1;
      } else {
        this.passwordLevel = 0;
      }
    },
    enterInput: function enterInput() {
      this.$emit('enterInput');
    }
  }
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(91);

var _message2 = _interopRequireDefault(_message);

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _index = __webpack_require__(252);

var _index2 = _interopRequireDefault(_index);

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(79);

var _qs2 = _interopRequireDefault(_qs);

var _cryptoJs = __webpack_require__(77);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _GeneralVariable = __webpack_require__(108);

var _utils = __webpack_require__(95);

var _Common = __webpack_require__(7);

var _config = __webpack_require__(49);

var _config2 = _interopRequireDefault(_config);

var _Cipher = __webpack_require__(106);

var _Cipher2 = _interopRequireDefault(_Cipher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      randomcode: '',
      aeskey: 0,
      ti: 0,
      qrcode: '',
      size: 180,
      flash: false
    };
  },

  components: {
    Qrcode: _index2.default
  },
  mounted: function mounted() {
    this.longPolling();
  },

  methods: {
    refresh: function refresh() {
      this.flash = false;
      this.longPolling();
    },

    // 创建qrcode
    createqrcode: function createqrcode() {
      this.randomcode = new Date().getTime().toString() + this.rando(3);
      this.aeskey = this.rando(16);
      var qrcode = {
        'id': this.randomcode,
        'aeskey': this.aeskey,
        'platform': 'web'
      };
      this.qrcode = (0, _stringify2.default)(qrcode);
      this.ti++;
    },

    // 生成一个随机数
    rando: function rando(m) {
      var num = '';
      for (var i = 0; i < m; i++) {
        var val = parseInt(Math.random() * 10, 10);
        if (i === 0 && val === 0) {
          i--;
          continue;
        }
        num += val;
      }
      return num;
    },

    // 长连方法
    longPolling: function longPolling() {
      var _this = this;

      this.createqrcode();
      (0, _axios2.default)({
        url: '/proxy-api/client/user/index/scan-login',
        params: {
          id: this.randomcode
        },
        method: 'post',
        timeout: 30000,
        responseType: 'json'
      }).then(function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(result) {
          var payload, rpayload, aeskeyhandle, decrypted, content, email, password, privatekey, publickey, loginAccount, type, data, deviceInfo;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  payload = result.data.payload;
                  rpayload = payload.replaceAll('%2B', '+');
                  aeskeyhandle = _cryptoJs2.default.enc.Latin1.parse(_this.aeskey);
                  decrypted = _cryptoJs2.default.AES.decrypt(rpayload, aeskeyhandle, {
                    iv: aeskeyhandle,
                    mode: _cryptoJs2.default.mode.ECB,
                    padding: _cryptoJs2.default.pad.Pkcs7
                  });
                  content = decrypted.toString(_cryptoJs2.default.enc.Utf8);

                  content = JSON.parse(content);
                  email = content['email'];
                  password = content['password'];
                  privatekey = content['private_key'];
                  publickey = content['public_key'] || '';
                  loginAccount = content['login_account'] || content['account_id'] || content['email'];
                  type = content['type'];

                  (0, _Common.savePwd)(content, password);
                  // 存入ls
                  //          localStorage.setItem(email + '_privatekey', privatekey)
                  //          if (publickey) {
                  //            localStorage.setItem(email + '_publickey', publickey)
                  //          }

                  // 登录
                  data = {};

                  if (type === 1) {
                    if (privatekey) {
                      localStorage.setItem(loginAccount + '_privatekey', privatekey);
                    }
                    if (publickey) {
                      localStorage.setItem(loginAccount + '_publickey', publickey);
                    }
                    data = {
                      phone_md5: _cryptoJs2.default.MD5(loginAccount).toString().substr(8, 16),
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2,
                      // 此cryptojs版本有bug，需要tostring转换一下
                      key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                    };
                  } else if (type === 0) {
                    email = loginAccount || email;
                    if (privatekey) {
                      localStorage.setItem(email + '_privatekey', privatekey);
                    }
                    if (publickey) {
                      localStorage.setItem(email + '_publickey', publickey);
                    }
                    data = {
                      email: email,
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2,
                      // 此cryptojs版本有bug，需要tostring转换一下
                      key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                    };
                  } else if (type === 2) {
                    if (privatekey) {
                      localStorage.setItem(loginAccount + '_privatekey', privatekey);
                    }
                    if (publickey) {
                      localStorage.setItem(loginAccount + '_publickey', publickey);
                    }
                    data = {
                      account_id: loginAccount,
                      password_hash: _Cipher2.default.RSAencrypt(_config2.default.pwdPublicKey, password),
                      decrypt_type: 2,
                      key_md5: _cryptoJs2.default.MD5(publickey).toString().substr(8, 16)
                    };
                  }
                  if (!localStorage.getItem('pcVersion')) {
                    data['useragent'] = 'web';
                  } else {
                    data['useragent'] = localStorage.getItem('pcVersion');
                  }

                  // data add scan login flag.
                  data['is_scan'] = _GeneralVariable.ScanFlag.IS_SCAN_LOGIN;
                  // add device info.
                  _context.next = 19;
                  return (0, _utils.getDeviceInfo)();

                case 19:
                  deviceInfo = _context.sent;

                  data['device_name'] = deviceInfo.deviceName;
                  data['device_id'] = deviceInfo.deviceId;
                  data['temporary_gray'] = (0, _utils.isGrayEnv)();

                  _this.login(data, loginAccount, type);

                case 24:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (XMLHttpRequest, textStatus, errorThrown) {
        if (_this.$route.path === '/login/scan') {
          if (_this.ti < 3) {
            _this.longPolling();
            _this.ti++;
          } else {
            _this.flash = true;
          }
        }
      });
    },
    setAccountToLocal: function setAccountToLocal(loginAccount) {
      var obj = {};
      var arr = [];
      obj[loginAccount] = '';
      arr.push(obj);
      localStorage.setItem('passwords', (0, _stringify2.default)(arr));
    },

    // 登录方法
    login: function login(data, loginAccount, type) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _axios2.default.post('/proxy-api/client/user/index/web-login', _qs2.default.stringify(data)).then(function (result) {
                  // 埋点统计：登录扫码登录结果
                  (0, _UploadWebEvent2.default)('SIGNIN_SCAN_RESULT', {
                    type: type,
                    status: result.data.status
                  });
                  if (result.data.status === '0') {
                    var passwords = localStorage.getItem('passwords');
                    if (passwords && JSON.parse(passwords).length !== 0) {
                      var account = (0, _keys2.default)(JSON.parse(passwords)[0])[0];
                      if (account !== loginAccount) {
                        _this2.setAccountToLocal(loginAccount);
                      }
                    } else {
                      _this2.setAccountToLocal(loginAccount);
                    }
                    (0, _utils.setLoginInfo)(result.data.payload);
                    (0, _utils.jumpToMainWeb)(result.data.payload['is_gray']);
                    // location.href = '../web/index.html'
                  } else {
                    (0, _message2.default)({
                      message: result.data.msg,
                      type: 'error'
                    });
                    console.error(result.data.msg);
                    _this2.flash = true;
                  }
                }).catch(function (error) {
                  (0, _message2.default)({
                    message: 'Oops, an unexpected error occurred. Please try again.',
                    type: 'error'
                  });
                  console.error(error);
                  _this2.flash = true;
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      text1: (0, _Translate2.default)('Tap'),
      text2: (0, _Translate2.default)('icon in the top right corner'),
      text3: (0, _Translate2.default)('Click'),
      text4: (0, _Translate2.default)('open in browser')
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//

exports.default = {
  // props: {
  //   title: String
  // },
  data: function data() {
    return {
      isPC: (0, _Common.checkDevice)(),
      title: ''
    };
  },
  updated: function updated() {
    // this.init()
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.$route.path === '/invite/invitenext')) {
                  _context.next = 4;
                  break;
                }

                if (_this.$route.query['fromwebsite']) {
                  _this.title = (0, _Translate2.default)('newInviteTitle7', _this.$route.query['name']);
                } else {
                  _this.title = (0, _Translate2.default)('newInviteTitle4', _this.$route.query['name']);
                }
                _context.next = 7;
                break;

              case 4:
                _context.next = 6;
                return (0, _Common.getInviteTitle)(_this);

              case 6:
                _this.title = _context.sent;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Common = __webpack_require__(7);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      openAppShow: false,
      text: (0, _Translate2.default)('Open in App'),
      lang: (0, _Common.browserLanguage)()
    };
  },
  mounted: function mounted() {
    if (this.$route.path === '/' || this.$route.path === '/invite/invitenext') this.openAppShow = true;
  },

  methods: {
    showApp: function showApp() {
      if (this.$route.path === '/') {
        // 埋点统计：点击app中打开 首页
        (0, _UploadWebEvent2.default)('OPENAPP', {
          type: 0
        });
      } else if (this.$route.path === '/invite/invitenext') {
        // 埋点统计：点击app中打开 老用户登录页
        (0, _UploadWebEvent2.default)('OPENAPP', {
          type: 1
        });
      }
      var url = void 0;
      if (navigator.userAgent.indexOf('Android') > -1) {
        url = 'batchatnew://?cmd=login&type=1&token=' + this.$route.query['token'];
      } else {
        url = 'batchat://?cmd=login&type=1&token=' + this.$route.query['token'];
      }
      var iframe = document.createElement('iframe');
      var body = document.body;
      iframe.style.cssText = 'display:none;width=0;height=0';
      body.appendChild(iframe);
      iframe.src = url;
      location.href = url;
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _cryptoJs = __webpack_require__(77);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _Axios = __webpack_require__(82);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _Common = __webpack_require__(7);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      params: {
        // 账号不存在
        'accountnotexist': {
          text: 'The account does not exist',
          text2: ', want to ',
          router: 'creat a new account?',
          fn: function () {
            (0, _UploadWebEvent2.default)('SIGNIN_ACCOUNT_NOT_EXIST_TO_SIGNUP'); // 埋点统计：从账号不存在提示跳转到注册页面
            return { path: '/login/signup', query: { 'account': this.data } };
          }.bind(this)
        },
        // 账号存在
        'accountexist': {
          text: 'The account already exists',
          text2: ', want to ',
          router: 'sign in?',
          fn: (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var publicKey, keyMd5, route, res;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    (0, _UploadWebEvent2.default)('SIGNUP_ACCOUNT_EXIST_TO_SIGNIN'); // 埋点统计：从账号已存在提示跳转到登录页面
                    publicKey = localStorage.getItem(this.data + '_publickey') || '';
                    keyMd5 = _cryptoJs2.default.MD5(publicKey).toString().substr(8, 16);
                    route = {
                      query: {
                        account: this.data,
                        countryCode: '',
                        showTip: true
                      }
                      // 检测是否需要扫码
                    };
                    _context.next = 6;
                    return (0, _Axios.checkScan)(route, { account: this.data, key_md5: keyMd5 }, '', (0, _Common.getLocationHash)());

                  case 6:
                    res = _context.sent;

                    if (res.path === '/login/password') {
                      res['path'] = '/login/signin';
                    }
                    return _context.abrupt('return', res);

                  case 9:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          })).bind(this)
        }
      },
      isGeneric: _index2.default.isGenericVersion()
    };
  },

  props: ['type', 'data'],
  mounted: function mounted() {},

  methods: {
    clickRouter: function clickRouter() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.params[_this.type].fn();

              case 2:
                res = _context2.sent;

                _this.$router.push(res);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Title = __webpack_require__(93);

var _Title2 = _interopRequireDefault(_Title);

var _Account = __webpack_require__(80);

var _Account2 = _interopRequireDefault(_Account);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _ErrorMsg = __webpack_require__(26);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      errorShow: false,
      errorMsg: '',
      password: '',
      type: 0,
      account: this.$route.query.account
    };
  },

  components: {
    Icon: _Icon2.default, isError: _Error2.default, Titles: _Title2.default, Account: _Account2.default, Inputs: _Inputs2.default, Buttons: _Buttons2.default
  },
  mounted: function mounted() {
    if ((0, _Common.checkPhone)(this.$route.query.account)) {
      this.type = 1;
    } else if ((0, _Common.checkUsername)(this.$route.query.account)) {
      this.type = 2;
    }
  },

  methods: {
    getPassword: function getPassword(data) {
      this.password = data;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      text1: (0, _Translate2.default)('inviteErrorText1'),
      text2: (0, _Translate2.default)('inviteErrorText2'),
      text3: (0, _Translate2.default)('inviteErrorText3'),
      text4: (0, _Translate2.default)('inviteErrorText4'),
      text5: (0, _Translate2.default)('inviteErrorText5')
    };
  },

  components: {
    Icon: _Icon2.default, Buttons: _Buttons2.default
  },
  created: function created() {},
  mounted: function mounted() {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Title = __webpack_require__(93);

var _Title2 = _interopRequireDefault(_Title);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Account = __webpack_require__(80);

var _Account2 = _interopRequireDefault(_Account);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _GetCode = __webpack_require__(92);

var _GetCode2 = _interopRequireDefault(_GetCode);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Common = __webpack_require__(7);

var _CountryCode = __webpack_require__(107);

var _ErrorMsg = __webpack_require__(26);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      errorShow: false,
      errorMsg: '',
      type: 0,
      name: this.$route.query.account,
      newpassword: '',
      isEmail: (0, _Common.checkEmail)(this.$route.query.account),
      isPhone: (0, _Common.checkPhone)(this.$route.query.account),
      isAccount: (0, _Common.checkUsername)(this.$route.query.account),
      footText: (0, _Translate2.default)('By registering, you agree to the '),
      footRouter: (0, _Translate2.default)('User agreement')
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Titles: _Title2.default, Error: _Error2.default, Account: _Account2.default, Inputs: _Inputs2.default, GetCode: _GetCode2.default, Buttons: _Buttons2.default
  },
  mounted: function mounted() {
    if (this.isEmail) {} else if (this.isPhone) {
      this.type = 1;
      (0, _CountryCode.getCountryCode)();
    } else if (this.isAccount) {
      this.type = 2;
    }
    // 埋点统计：邀请注册页面输入并跳转到下一页面
    (0, _UploadWebEvent2.default)('INVITE_INPUT_NEXT', {
      type: this.type
    });
  },

  methods: {
    getName: function getName(data) {
      this.name = data;
    },
    getNewPassword: function getNewPassword(data) {
      this.newpassword = data;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    },
    uploadWebEvent: function uploadWebEvent() {
      // 埋点统计：邀请注册页点击查看用户协议
      (0, _UploadWebEvent2.default)('INVITENEXT_AGGREMENT', {
        type: this.type
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Title = __webpack_require__(93);

var _Title2 = _interopRequireDefault(_Title);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Countrycode = __webpack_require__(251);

var _Countrycode2 = _interopRequireDefault(_Countrycode);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _GetCode = __webpack_require__(92);

var _GetCode2 = _interopRequireDefault(_GetCode);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Common = __webpack_require__(7);

var _ErrorMsg = __webpack_require__(26);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      loading: false,
      errorShow: false,
      data: {},
      phone: '',
      countryCode: '',
      // footText: translate('By registering, you agree to the '),
      footText: (0, _Translate2.default)('Skip and verify later'),
      footRouter: (0, _Translate2.default)('User agreement')
    };
  },

  components: {
    Icon: _Icon2.default, Titles: _Title2.default, Error: _Error2.default, CountryCode: _Countrycode2.default, Inputs: _Inputs2.default, GetCode: _GetCode2.default, Buttons: _Buttons2.default
  },
  mounted: function mounted() {
    this.data = _Common.transferData.getData();
    this.data['capture'] = '';
    _Common.transferData.deleteData();
  },

  methods: {
    sendCountryCode: function sendCountryCode(data) {
      this.countryCode = data;
      this.data['countryCode'] = this.countryCode;
    },
    getAccount: function getAccount(data) {
      this.phone = data;
      this.data['account'] = data;
    },
    getCode: function getCode(data) {
      this.code = data;
      this.data['capture'] = this.code;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      this.closeErrorTip();
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    },

    // 稍后验证
    verifyLater: function verifyLater() {
      this.$refs.btn.clickBtn('verifyLater');
    }
  }
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Iconsuccess = __webpack_require__(132);

var _Iconsuccess2 = _interopRequireDefault(_Iconsuccess);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      text: (0, _Translate2.default)('You have joined Crait')
    };
  },

  components: {
    Icon: _Icon2.default, Iconsuccess: _Iconsuccess2.default, Buttons: _Buttons2.default
  },
  created: function created() {},
  mounted: function mounted() {}
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Title = __webpack_require__(93);

var _Title2 = _interopRequireDefault(_Title);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _ErrorMsg = __webpack_require__(26);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      errorShow: false,
      errorMsg: '',
      account: '' // 输入的账号
    };
  },

  components: {
    Icon: _Icon2.default, Error: _Error2.default, Titles: _Title2.default, Inputs: _Inputs2.default, Buttons: _Buttons2.default
  },
  beforeCreate: function beforeCreate() {
    (0, _Common.inviteRedirect)(this);
  },
  mounted: function mounted() {},
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    next(function (vm) {
      if (from.query['source'] === 'website' && from.query['account'] && to.name === null) {
        setTimeout(function () {
          vm.$refs.btn.clickBtn();
        }, 0);
      }
    });
  },

  methods: {
    getAccount: function getAccount(data) {
      this.account = data;
      this.exist = false;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Warn = __webpack_require__(133);

var _Warn2 = _interopRequireDefault(_Warn);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      account: '' // 输入的账号
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Inputs: _Inputs2.default, Warn: _Warn2.default, Buttons: _Buttons2.default
  },
  methods: {
    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Warn = __webpack_require__(133);

var _Warn2 = _interopRequireDefault(_Warn);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      account: '' // 输入的账号
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Inputs: _Inputs2.default, Warn: _Warn2.default, Buttons: _Buttons2.default
  },
  methods: {
    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Account = __webpack_require__(80);

var _Account2 = _interopRequireDefault(_Account);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _GetCode = __webpack_require__(92);

var _GetCode2 = _interopRequireDefault(_GetCode);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Foot = __webpack_require__(81);

var _Foot2 = _interopRequireDefault(_Foot);

var _ErrorMsg = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      errorShow: false,
      errorMsg: '',
      code: '',
      password: '',
      isEmail: this.$route.query.isEmail
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Error: _Error2.default, Account: _Account2.default, Inputs: _Inputs2.default, GetCode: _GetCode2.default, Buttons: _Buttons2.default, Foot: _Foot2.default
  },
  mounted: function mounted() {},

  methods: {
    getCode: function getCode(data) {
      this.code = data;
    },
    getPassword: function getPassword(data) {
      this.password = data;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(21);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _message = __webpack_require__(91);

var _message2 = _interopRequireDefault(_message);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Common = __webpack_require__(7);

var _Axios = __webpack_require__(82);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      indentifyTitile: (0, _Translate2.default)('indentifyTitile'), // translate('indentifyTitile')
      description: (0, _Translate2.default)('indentifyDescription'),
      useDeviceTip: (0, _Translate2.default)('usePhoneTip'),
      inputCodeTip: (0, _Translate2.default)('inputCodeTip'),
      timerTip: '00:',
      timerDecTip: (0, _Translate2.default)('timerDecTip'),
      getCodeButtonTip: (0, _Translate2.default)('getCodeButtonTip'),
      regetCodeTip: (0, _Translate2.default)('regetCode'),
      needHelpTip: (0, _Translate2.default)('needHelpTip'),
      verifyButton: (0, _Translate2.default)('verifyButton'),
      currentKey: '',
      currentAccount: '',
      showGetCode: true,
      showAccountList: false,
      phoneTimerNum: _Common.MaxTimeOut,
      emailTimerNum: _Common.MaxTimeOut,
      phoneIntervalId: '',
      emailIntervalId: '',
      accountList: {},
      phoneCountryCode: '',
      userCode: '',
      verifyLoading: false,
      isGenericVersion: _index2.default.isGenericVersion()
      // {
      //   'country_code': '+86',
      //   'phone': '12345678901',
      //   'email': 'chenjiancao@myhexin.com'
      // }
    };
  },

  computed: {
    showdropbutton: function showdropbutton() {
      return (0, _keys2.default)(this.accountList).length > 1;
    },
    showTimerTip: function showTimerTip() {
      var showTimerNum = void 0;
      if (this.currentKey === 'phone') {
        showTimerNum = this.getShowTimerNum(this.phoneTimerNum);
        return '00:' + showTimerNum + this.timerDecTip;
      } else if (this.currentKey === 'email') {
        showTimerNum = this.getShowTimerNum(this.emailTimerNum);
        return '00:' + showTimerNum + this.timerDecTip;
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.query) {
      // init country code.
      if (this.$route.query.country_code) {
        this.phoneCountryCode = this.$route.query.country_code;
      }
      // init phone
      if (this.$route.query.phone) {
        this.accountList['phone'] = this.$route.query.phone;
      }
      // init email.
      if (this.$route.query.email) {
        this.accountList['email'] = this.$route.query.email;
      }
      // init code.
      if (this.$route.query.code) {
        this.userCode = this.$route.query.code;
      }
    }
    // default use phone account.
    if (this.accountList.phone) {
      this.useDeviceTip = (0, _Translate2.default)('usePhoneTip');
      this.currentAccount = this.phoneCountryCode + ' ' + this.accountList.phone;
      this.currentKey = 'phone';
    } else {
      this.useDeviceTip = (0, _Translate2.default)('useEmailTip');
      this.currentAccount = this.accountList.email;
      this.currentKey = 'email';
    }
  },

  methods: {
    getShowTimerNum: function getShowTimerNum(time) {
      return time < 10 ? '0' + time : time;
    },
    closeWindow: function closeWindow() {
      console.log('close indetify window. ');
      this.$router.push('/login/signin');
    },
    getDeviceName: function getDeviceName(key) {
      if (key === 'phone') {
        return (0, _Translate2.default)('usePhoneTip');
      } else if (key === 'email') {
        return (0, _Translate2.default)('useEmailTip');
      }
    },
    getDeviceValue: function getDeviceValue(key) {
      if (key === 'phone') {
        return this.phoneCountryCode + this.accountList.phone;
      } else if (key === 'email') {
        return this.accountList.email;
      }
    },
    sendVerifyCode: function sendVerifyCode() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var verifyCode, requestParams, res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.verifyLoading = true;
                console.log('send verify code');
                verifyCode = document.getElementsByClassName('inputcode')[0].value.trim();

                verifyCode = verifyCode.replace(/\s+/g, '');
                console.log(verifyCode);
                requestParams = {
                  code: _this.userCode,
                  capture: verifyCode,
                  type: _this.currentKey === 'phone' ? _Common.accountType.PHONE_TYPE : _Common.accountType.EMAIL_TYPE
                  // validate verify code.
                };
                _context.next = 8;
                return (0, _Axios.post)('/proxy-api/client/user/index/validate-capture-by-code', requestParams).catch(function (err) {
                  return err;
                });

              case 8:
                res = _context.sent;


                _this.verifyLoading = false;
                // verify success. perform login operation.
                if (+res.data.status === 0) {
                  (0, _message2.default)({
                    message: 'Successful verification',
                    type: 'success'
                  });
                  location.href = '../web/index.html';
                } else {
                  (0, _message2.default)({
                    message: res.data.msg,
                    type: 'error'
                  });
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openList: function openList() {
      if ((0, _keys2.default)(this.accountList).length > 1) {
        this.showAccountList = !this.showAccountList;
      }
    },
    openHelpWindow: function openHelpWindow() {
      var text = (0, _Translate2.default)('helpTip');
      this.$confirm(text, '', {
        confirmButtonText: (0, _Translate2.default)('sure'),
        type: 'info',
        showClose: false,
        showCancelButton: false
      }).then(function () {
        console.log('support@crait.com can help you.');
      }).catch(function () {
        console.log('support@crait.com can help you.');
      });
    },
    selectAccount: function selectAccount(value, key) {
      this.useDeviceTip = this.getDeviceName(key);
      this.currentAccount = this.getDeviceValue(key);
      this.currentKey = key;
      this.showAccountList = false;
      if (key === 'phone' && this.phoneTimerNum === _Common.MaxTimeOut) {
        this.showGetCode = true;
      } else if (key === 'email' && this.emailTimerNum === _Common.MaxTimeOut) {
        this.showGetCode = true;
      } else {
        this.showGetCode = false;
      }
    },
    getCode: function getCode() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var that, requestParams, res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;

                _this2.showGetCode = false;
                // set account to get verification code time.
                if (that.currentKey === 'phone') {
                  _this2.phoneIntervalId = setInterval(function () {
                    that.phoneTimerNum = that.phoneTimerNum - 1;
                    if (that.phoneTimerNum === 0) {
                      window.clearInterval(that.phoneIntervalId);
                      that.phoneTimerNum = _Common.MaxTimeOut;
                      if (_this2.currentKey === 'phone') {
                        _this2.showGetCode = true;
                      }
                    }
                  }, 1000);
                } else if (that.currentKey === 'email') {
                  _this2.emailIntervalId = setInterval(function () {
                    that.emailTimerNum = that.emailTimerNum - 1;
                    if (that.emailTimerNum === 0) {
                      window.clearInterval(that.emailIntervalId);
                      that.emailTimerNum = _Common.MaxTimeOut;
                      if (_this2.currentKey === 'email') {
                        _this2.showGetCode = true;
                      }
                    }
                  }, 1000);
                }

                // request send capture code.
                requestParams = {
                  code: _this2.userCode,
                  device: 'web',
                  type: that.currentKey === 'phone' ? _Common.accountType.PHONE_TYPE : _Common.accountType.EMAIL_TYPE
                };
                _context2.next = 6;
                return (0, _Axios.post)('/proxy-api/client/user/index/send-capture-by-code', requestParams);

              case 6:
                res = _context2.sent;

                console.log('send Capture code. res is', res);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Account = __webpack_require__(80);

var _Account2 = _interopRequireDefault(_Account);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Foot = __webpack_require__(81);

var _Foot2 = _interopRequireDefault(_Foot);

var _RememberPassword = __webpack_require__(188);

var _RememberPassword2 = _interopRequireDefault(_RememberPassword);

var _Common = __webpack_require__(7);

var _ErrorMsg = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      loading: false,
      errorShow: false,
      errorMsg: '',
      type: 0,
      rememberPassword: '',
      account: this.$route.query.account,
      password: '',
      rememberpw: false,
      isEmail: (0, _Common.checkEmail)(this.$route.query.account),
      isPhone: (0, _Common.checkPhone)(this.$route.query.account),
      isAccount: (0, _Common.checkUsername)(this.$route.query.account)
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Error: _Error2.default, Account: _Account2.default, Inputs: _Inputs2.default, Buttons: _Buttons2.default, Foot: _Foot2.default
  },
  created: function created() {
    this.rememberPassword = new _RememberPassword2.default();
    console.log(this.account);
    this.password = this.rememberPassword.getPassword(this.account);
    console.log(this.password);
    if (this.password !== '') {
      this.rememberpw = true;
    }
  },
  mounted: function mounted() {
    if (this.isEmail) {} else if (this.isPhone) {
      this.type = 1;
    } else if (this.isAccount) {
      this.type = 2;
    }
  },

  methods: {
    // 获取密码
    getPassword: function getPassword(data) {
      this.password = data;
    },

    // 获取记住密码状态
    getRememberpw: function getRememberpw(data) {
      this.rememberpw = data;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    },

    // 登录成功回调
    loginSuccess: function loginSuccess(password) {
      this.rememberPassword.savePassword(password, this.rememberpw);
      location.href = '../web/index.html';
    }
  }
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Iconsuccess = __webpack_require__(132);

var _Iconsuccess2 = _interopRequireDefault(_Iconsuccess);

var _Foot = __webpack_require__(81);

var _Foot2 = _interopRequireDefault(_Foot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    Icon: _Icon2.default, Iconsuccess: _Iconsuccess2.default, Foot: _Foot2.default
  },
  mounted: function mounted() {}
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Qrcode = __webpack_require__(732);

var _Qrcode2 = _interopRequireDefault(_Qrcode);

var _Foot = __webpack_require__(81);

var _Foot2 = _interopRequireDefault(_Foot);

var _ErrorMsg = __webpack_require__(26);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isGeneric: _index2.default.isGenericVersion(),
      errorShow: true,
      errorMsg: 'To verify your identity, please scan this QRcode with the ' + _index2.default.getAppName() + ' mobile app',
      account: '', // 输入的账号
      scanHelpShow: false,
      scanHelpImg: __webpack_require__(806)("./" + _index2.default.getAppName() + '/scan_help.png')
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Error: _Error2.default, Qrcode: _Qrcode2.default, Foot: _Foot2.default
  },
  props: ['isPc'],
  mounted: function mounted() {
    // if (this.$route.query.showTip) this.scanHelpShow = true
  },

  methods: {
    getAccount: function getAccount(data) {
      this.account = data;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },
    scanHelp: function scanHelp() {
      this.scanHelpShow = !this.scanHelpShow;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(50);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Account = __webpack_require__(80);

var _Account2 = _interopRequireDefault(_Account);

var _Warn = __webpack_require__(133);

var _Warn2 = _interopRequireDefault(_Warn);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Foot = __webpack_require__(81);

var _Foot2 = _interopRequireDefault(_Foot);

var _ErrorMsg = __webpack_require__(26);

var _RememberPassword = __webpack_require__(188);

var _RememberPassword2 = _interopRequireDefault(_RememberPassword);

var _Common = __webpack_require__(7);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      errorShow: false,
      errorMsg: '',
      account: '', // 输入的账号
      notExist: false,
      type: 0,
      rememberPassword: '',
      // account: this.$route.query.account,
      password: '',
      rememberpw: false,
      isEmail: '',
      isPhone: '',
      isAccount: '',
      passwordShow: false,
      change: 0,
      isGenericVersion: _index2.default.isGenericVersion()
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Error: _Error2.default, Inputs: _Inputs2.default, Account: _Account2.default, Warn: _Warn2.default, Buttons: _Buttons2.default, Foot: _Foot2.default
  },
  props: ['isPc'],
  created: function created() {
    this.getRememberedPassword();
  },
  mounted: function mounted() {
    if (location.search.indexOf('?ua=') > -1 && location.search.indexOf('&version=') > -1) {
      var version = location.search.substr(location.search.indexOf('&version=') + 9);
      var pcVersion = 'pc/' + version;
      localStorage.setItem('pcVersion', pcVersion);
    }
    // 浏览器检测
    if ((0, _Common.checkIsChrome)()) {
      var ua = navigator.userAgent.toLowerCase();
      var s = ua.match(/chrome\/([\d.]+)/);
      if (parseInt(s[1]) < 62 && !(ua.indexOf('electron') > -1)) {
        _vue2.default.prototype.$message({
          showClose: true,
          message: 'The version of Chrome you are using is old. Update your browser to optimize user experience.',
          type: 'warning',
          duration: 0
        });
      }
    } else if (!(0, _Common.isTablet)()) {
      var messageTip = 'We highly recommend you to use ' + _index2.default.getfirstUpperCaseAppName() + ' in Chrome for optimized user experience.';
      _vue2.default.prototype.$message({
        showClose: true,
        message: messageTip,
        type: 'warning',
        duration: 0
      });
    }
  },

  methods: {
    getRememberedPassword: function getRememberedPassword(data) {
      this.rememberPassword = new _RememberPassword2.default();
      if (JSON.parse(localStorage.getItem('passwords')) && JSON.parse(localStorage.getItem('passwords'))[0]) {
        var account = data || (0, _keys2.default)(JSON.parse(localStorage.getItem('passwords'))[0])[0];
        if (account !== 'undefined') {
          this.password = this.rememberPassword.getPassword(account);
          this.rememberpw = this.password !== '';
          this.passwordShow = true;
          this.passwordPageInit();
        }
      }
    },
    getAccount: function getAccount(data) {
      this.account = data;
      this.notExist = false;
    },
    checkError: function checkError(msg) {
      this.openErrorTip(msg);
    },
    accountNotExist: function accountNotExist() {
      this.errorShow = false;
      this.notExist = true;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 显示输入密码框
    showPassword: function showPassword(data) {
      this.passwordShow = data;
      this.errorShow = false;
      if (data) {
        // let passwords = localStorage.getItem('passwords')
        // if (passwords) {
        //   let account = Object.keys(JSON.parse(passwords)[0])[0]
        //   if (account !== this.account) {
        //     this.password = ''
        //     this.rememberpw = false
        //   }
        // }
        this.getRememberedPassword(this.account);
        ++this.change;
        this.passwordPageInit();
      }
    },

    // 输入密码页初始化
    passwordPageInit: function passwordPageInit() {
      var _this = this;

      setTimeout(function () {
        _this.isEmail = (0, _Common.checkEmail)(_this.account);
        _this.isPhone = (0, _Common.checkPhone)(_this.account);
        _this.isAccount = (0, _Common.checkUsername)(_this.account);
        if (_this.isEmail) {
          _this.type = 0;
        } else if (_this.isPhone) {
          _this.type = 1;
        } else if (_this.isAccount) {
          _this.type = 2;
        }
        document.getElementsByClassName('inputs')[1].focus();
      }, 0);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    },

    // 获取密码
    getPassword: function getPassword(data) {
      this.password = data;
    },

    // 获取记住密码状态
    getRememberpw: function getRememberpw(data) {
      this.rememberpw = data;
    },

    // 登录成功回调
    loginSuccess: function loginSuccess(password) {
      if (password !== void 0) {
        this.rememberPassword.savePassword(this.account, password, this.rememberpw);
      } else {
        this.$router.push({ path: '/login/scan' });
      }
    }
  }
};
// import config from '../../assets/js/config.js'
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Warn = __webpack_require__(133);

var _Warn2 = _interopRequireDefault(_Warn);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Foot = __webpack_require__(81);

var _Foot2 = _interopRequireDefault(_Foot);

var _ErrorMsg = __webpack_require__(26);

var _index = __webpack_require__(19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      errorShow: false,
      errorMsg: '',
      account: '', // 输入的账号
      exist: false,
      isGenericVersion: _index2.default.isGenericVersion()
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Error: _Error2.default, Inputs: _Inputs2.default, Warn: _Warn2.default, Buttons: _Buttons2.default, Foot: _Foot2.default
  },
  props: ['isPc'],
  mounted: function mounted() {},

  methods: {
    getAccount: function getAccount(data) {
      this.account = data;
      this.exist = false;
    },
    accountExist: function accountExist() {
      this.errorShow = false;
      this.exist = true;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Account = __webpack_require__(80);

var _Account2 = _interopRequireDefault(_Account);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _GetCode = __webpack_require__(92);

var _GetCode2 = _interopRequireDefault(_GetCode);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Common = __webpack_require__(7);

var _CountryCode = __webpack_require__(107);

var _ErrorMsg = __webpack_require__(26);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      errorShow: false,
      errorMsg: '',
      type: 0,
      name: this.$route.query.account,
      newpassword: '',
      isEmail: (0, _Common.checkEmail)(this.$route.query.account),
      isPhone: (0, _Common.checkPhone)(this.$route.query.account),
      isAccount: (0, _Common.checkUsername)(this.$route.query.account)
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Error: _Error2.default, Account: _Account2.default, Inputs: _Inputs2.default, GetCode: _GetCode2.default, Buttons: _Buttons2.default
  },
  mounted: function mounted() {
    if (this.isEmail) {} else if (this.isPhone) {
      this.type = 1;
      (0, _CountryCode.getCountryCode)();
    } else if (this.isAccount) {
      this.type = 2;
    }
    // 埋点统计：注册页面输入并跳转到下一页面
    (0, _UploadWebEvent2.default)('SIGNUP_INPUT_NEXT', {
      type: this.type
    });
  },

  methods: {
    getName: function getName(data) {
      this.name = data;
    },
    getNewPassword: function getNewPassword(data) {
      this.newpassword = data;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Countrycode = __webpack_require__(251);

var _Countrycode2 = _interopRequireDefault(_Countrycode);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _GetCode = __webpack_require__(92);

var _GetCode2 = _interopRequireDefault(_GetCode);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Common = __webpack_require__(7);

var _ErrorMsg = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      loading: false,
      errorShow: false,
      data: {},
      phone: '',
      countryCode: ''
    };
  },

  components: {
    Icon: _Icon2.default, Error: _Error2.default, CountryCode: _Countrycode2.default, Inputs: _Inputs2.default, GetCode: _GetCode2.default, Buttons: _Buttons2.default
  },
  mounted: function mounted() {
    this.data = _Common.transferData.getData();
    this.data['capture'] = '';
    _Common.transferData.deleteData();
  },

  methods: {
    sendCountryCode: function sendCountryCode(data) {
      this.countryCode = data;
      this.data['countryCode'] = this.countryCode;
    },
    getAccount: function getAccount(data) {
      this.phone = data;
      this.data['account'] = data;
    },
    getCode: function getCode(data) {
      this.code = data;
      this.data['capture'] = this.code;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      this.closeErrorTip();
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    },

    // 稍后验证
    verifyLater: function verifyLater() {
      this.$refs.btn.clickBtn('verifyLater');
    }
  }
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Iconsuccess = __webpack_require__(132);

var _Iconsuccess2 = _interopRequireDefault(_Iconsuccess);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    Icon: _Icon2.default, Iconsuccess: _Iconsuccess2.default, Buttons: _Buttons2.default
  },
  created: function created() {},
  mounted: function mounted() {}
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(91);

var _message2 = _interopRequireDefault(_message);

var _axios = __webpack_require__(54);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(79);

var _qs2 = _interopRequireDefault(_qs);

var _Foot = __webpack_require__(81);

var _Foot2 = _interopRequireDefault(_Foot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import translate from '../common/Translate'
exports.default = {
  data: function data() {
    return {
      email: '',
      forgotPasswordTip: 'Forgot Password',
      nextTip: 'Next'
    };
  },

  components: {
    Foot: _Foot2.default
  },
  methods: {
    forgotClick: function forgotClick() {
      var _this = this;

      this.$emit('show');
      _axios2.default.post('/proxy-api/client/user/index/reset-password', _qs2.default.stringify({
        email: this.email
      })).then(function (result) {
        console.log(result);
        if (result.data.status === '0') {
          _this.$emit('hide');
          setTimeout(function () {
            location.href = './';
          }, 1000);
          (0, _message2.default)({
            message: 'Please check your email.',
            type: 'success'
          });
        } else {
          _this.$emit('hide');
          (0, _message2.default)({
            message: result.data.msg,
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$emit('hide');
        (0, _message2.default)({
          message: 'Warning!',
          type: 'warning'
        });
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      isPC: (0, _Common.checkDevice)(),
      text1: (0, _Translate2.default)('inviteErrorText1'),
      text2: (0, _Translate2.default)('inviteErrorText2'),
      text3: (0, _Translate2.default)('inviteErrorText3'),
      text4: (0, _Translate2.default)('inviteErrorText4'),
      text5: (0, _Translate2.default)('inviteErrorText5')
    };
  },

  components: {
    Icon: _Icon2.default, Buttons: _Buttons2.default
  },
  created: function created() {},
  mounted: function mounted() {
    if (!this.isPC) {
      // Icon margin top 50 need to calc.
      var inviteError = document.getElementById('invite-error');
      var topHeight = (window.screen.height - inviteError.offsetHeight + 50) / 3;
      // console.log(topHeight)
      inviteError.style.top = topHeight - 50 + 'px';
    }
  }
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Iconswitch = __webpack_require__(48);

var _Iconswitch2 = _interopRequireDefault(_Iconswitch);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Top = __webpack_require__(181);

var _Top2 = _interopRequireDefault(_Top);

var _Title = __webpack_require__(93);

var _Title2 = _interopRequireDefault(_Title);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Account = __webpack_require__(80);

var _Account2 = _interopRequireDefault(_Account);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _GetCode = __webpack_require__(92);

var _GetCode2 = _interopRequireDefault(_GetCode);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Common = __webpack_require__(7);

var _CountryCode = __webpack_require__(107);

var _ErrorMsg = __webpack_require__(26);

var _UploadWebEvent = __webpack_require__(27);

var _UploadWebEvent2 = _interopRequireDefault(_UploadWebEvent);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      isPC: (0, _Common.checkDevice)(),
      errorShow: false,
      errorMsg: '',
      type: 0,
      account: this.$route.query.account,
      password: '',
      isEmail: (0, _Common.checkEmail)(this.$route.query.account),
      isPhone: (0, _Common.checkPhone)(this.$route.query.account),
      isAccount: (0, _Common.checkUsername)(this.$route.query.account),
      footText: (0, _Translate2.default)('Not your account? '),
      footRouter: (0, _Translate2.default)('Switch')
    };
  },

  components: {
    IconSwitch: _Iconswitch2.default, Icon: _Icon2.default, Top: _Top2.default, Titles: _Title2.default, Error: _Error2.default, Account: _Account2.default, Inputs: _Inputs2.default, GetCode: _GetCode2.default, Buttons: _Buttons2.default
  },
  mounted: function mounted() {
    if (this.isEmail) {} else if (this.isPhone) {
      this.type = 1;
      (0, _CountryCode.getCountryCode)();
    } else if (this.isAccount) {
      this.type = 2;
    }
    if (!this.isPC) {
      var inviteNext = document.getElementById('invite-next');
      inviteNext.className = 'invite-next-mobile';
      // title margin top 80 need to calc
      var topHeight = (window.screen.height - inviteNext.offsetHeight - 50 + 80) / 3;
      inviteNext.style.top = topHeight + 50 - 80 + 'px';
    }
  },

  methods: {
    getName: function getName(data) {
      this.name = data;
    },
    getPassword: function getPassword(data) {
      this.password = data;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    },
    switchClick: function switchClick() {
      // 埋点统计：老用户点击切换账号
      (0, _UploadWebEvent2.default)('SWITCH');
      var route = {
        path: '/',
        query: {
          token: this.$route.query['token'],
          type: this.$route.query['type']
        }
      };
      this.$router.push(route);
      // 埋点统计：邀请注册页点击查看用户协议
      // uploadWebEvent('INVITENEXT_AGGREMENT', {
      //   type: this.type
      // })
    }
  }
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Top = __webpack_require__(181);

var _Top2 = _interopRequireDefault(_Top);

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Iconsuccess = __webpack_require__(132);

var _Iconsuccess2 = _interopRequireDefault(_Iconsuccess);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Translate = __webpack_require__(16);

var _Translate2 = _interopRequireDefault(_Translate);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      isPC: (0, _Common.checkDevice)(),
      name: (0, _Common.getInviteName)(),
      title1: (0, _Translate2.default)('newInviteTitle5', this.$route.query['invitename']),
      title2: (0, _Translate2.default)('newInviteTitle6', this.$route.query['invitegroup']),
      title3: (0, _Translate2.default)('Account registered. Welcome to Crait!'),
      title4: (0, _Translate2.default)('newInviteTitle8', this.$route.query['inviteTeam']),
      text: (0, _Translate2.default)('Login to Crait with this account to start messaging')
    };
  },

  components: {
    Top: _Top2.default, Icon: _Icon2.default, Iconsuccess: _Iconsuccess2.default, Buttons: _Buttons2.default
  },
  created: function created() {},
  mounted: function mounted() {
    if (!this.isPC) {
      var inviteSuccess = document.getElementById('invite-success');
      // icon margin top is 80px.
      var topHeight = (window.screen.height - inviteSuccess.offsetHeight - 50 + 80) / 3;
      // console.log(inviteSuccess.offsetHeight)
      inviteSuccess.style.top = topHeight + 50 - 80 + 'px';
    }
  }
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(13);

var _Icon2 = _interopRequireDefault(_Icon);

var _Shadow = __webpack_require__(733);

var _Shadow2 = _interopRequireDefault(_Shadow);

var _Top = __webpack_require__(181);

var _Top2 = _interopRequireDefault(_Top);

var _Error = __webpack_require__(31);

var _Error2 = _interopRequireDefault(_Error);

var _Title = __webpack_require__(93);

var _Title2 = _interopRequireDefault(_Title);

var _Inputs = __webpack_require__(24);

var _Inputs2 = _interopRequireDefault(_Inputs);

var _Buttons = __webpack_require__(15);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _ErrorMsg = __webpack_require__(26);

var _Common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isPC: (0, _Common.checkDevice)(),
      isWX: (0, _Common.checkWX)(),
      errorShow: false,
      errorMsg: '',
      account: '' // 输入的账号
    };
  },

  components: {
    Icon: _Icon2.default, Shadows: _Shadow2.default, Top: _Top2.default, Error: _Error2.default, Titles: _Title2.default, Inputs: _Inputs2.default, Buttons: _Buttons2.default
  },
  beforeCreate: function beforeCreate() {
    (0, _Common.inviteRedirect)(this);
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    next(function (vm) {
      if (from.query['source'] === 'website' && from.query['account'] && to.name === null) {
        setTimeout(function () {
          vm.$refs.btn.clickBtn();
        }, 0);
      }
    });
  },
  mounted: function mounted() {
    if (!this.isPC) {
      var start = document.getElementById('start');
      // icon margin top is 80px.
      var topHeight = (window.screen.height - start.offsetHeight - 50 + 80) / 3;
      start.style.top = topHeight + 50 - 80 + 'px';
      // setTimeout(() => {
      //   let parentHeight = document.getElementsByClassName('wrap-phone')[0].clientHeight
      //   let childrenHeight = this.$refs['start-mobile'].clientHeight
      //   this.marginTop = ((parentHeight - childrenHeight) / 2 - 50) + 'px'
      // }, 0)
    }
  },

  methods: {
    getAccount: function getAccount(data) {
      this.account = data;
      this.exist = false;
    },

    // 关闭错误提示
    closeErrorTip: function closeErrorTip() {
      _ErrorMsg.errorFn.closeErrorTip(this);
    },

    // 弹出错误提示
    openErrorTip: function openErrorTip(msg) {
      _ErrorMsg.errorFn.openErrorTip(msg, this);
    },

    // 输入框回车点击
    enterInput: function enterInput() {
      this.$refs.btn.clickBtn();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scan_help.35d691c.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg.fa333a1.jpg";

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scan_help.4ad3c64.png";

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK4AAACuCAMAAACY0sbcAAAAk1BMVEUAAACVl5mkpaeVmJqfoaOho6XIycrw8PChoqSgoqOjpaekpqiipKWgoqSmp6mnqaufoKKjpKadnqCcnqCmqKmnqKqjpafd3d3Ly8u+vr6kpKSXl5eLi4u3t7fExMTj4+ORkZGwsLCeoKHq6uqdnZ2QkJCqqqq9vb3KysrX19fQ0NC2traenp6xsbGjo6OjpKagoqTjz8jtAAAAMXRSTlMAgJf/kJP//5KOlpiUj52dj5iMi5ucmf//////////////i////////////////5WR01QfiwAAA4RJREFUeNrV2m1XUkEUhuEUa2tipVYIBwU7yltI/f9fFyda3WtlZ41LhoH7+cqXi3GzZ2aPb1Q5UmmPOybtScfEfdvpvHNpw6XVcE8brYZ70mg13LNGq+G+b7Qa7vFfbVi0Gu452giHVsPtNlri0oZidyCCc4KEi5YI6tbBvUBLXNo46PPt87i0oegJxKUNlzYU/ZYc6E3HwEWr4X5AK+B+RCvgnie04dKGooMRlzYO7F6m4X5CK+ByYhRw2csU3Eu0Ai49QcClJyi4V2gF3Gu0Au4ZWgEXrYDL7iDgcuc1cJmDvTwubSh2B3JQJ8Z0XNpwaUNRt0TRb4lLG3t78ddwu6/XhqISiGHnDeLShmJ3IHs4jRu4zGo03M9oBdzz7bXh0oZLGy5tlDzVZIhLGy5tuLTh0kYhrYb7Ba2Ai9bA/YpWwO1m1saeZjW9m/5gUA03qQaD27teJm5+7ei2Gj7P+H60V+63Fm1/2Jb7OsUtfousH4bteUiVRGltbLSPk+lsPp9v6ng+X0wnjxtvYn1La6cNqpr9R7X4XdDfE9yy0496vCYt6yCkfmq8owS36BzsrikEtP94m/V9SnBLamO1Bk1bMbOmUBLcktpI/Lmb31svwS2onSeWb7L+fJbgFtFSupMghL4xLcRF+2rOLPF1ouzdYQK3tVhWBbmXaNsaw/wguKztltxhCS5aAxetgUvdbseti3BZ2y25UYKL1sBFa+AyTzBwmY0buGgNXLQGLnVr4HJiNHDRGrhoNdyTl2oZ4dztj3uR0KJ4RXJymTEauGgNXLQGLjNGAxetgYvWwEVr4KI1cNFquKdot+YuV9XuuOy8mbjTiHq5Ky7aTNxlrNPbERdtLu6KT7Nz+ZVl447riJjtjnuGdjsur6o34x1x6QnZandRx2j6mJ/L/9/m4vLkN6pyc7mXZeQu4096mblM7XJyZzyxZOWizcqtecDKyWWylJfL54uMXOo2M3e0i9VFm5vLg2CVjYs2O3fc46k4ExdtNi6pemizcOkJOblk0r/pUwlpbgFtsdsE02YDl35r4KI1cKlbDbeLVsBlNm7gXqEVcJnfCrhoBVwqQcDlhi7gohVw6WAGLnMwAxftYcaljZYZo4HL1M7ARWvgMmM0cLk7GLhoNdwfaAVcdl4D9xqtgPvToA1FJRCXNriXhSEubXBiVIRTjSLMwRzcI5M2fgEmI3Higrf30gAAAABJRU5ErkJggg=="

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK4AAACuCAMAAACY0sbcAAAAUVBMVEUAAACVl5mkpaeVmJqfoaOho6XIycrw8PChoqSgoqOjpaekpqiipKWgoqSmp6mnqaufoKKjpKadnqCcnqCmqKmnqKqjpaeeoKFxcXGjpKagoqQEB3UDAAAAG3RSTlMAgJf/kJP//5KOlpiUj52dj5iMi5ucmYv/lZEzXCV0AAAC3ElEQVR4AdXZh7KUMBhHcS8b/Kh6e3v/97TrscRMxpB1z3/KVuAHk543qlyptMPJpE0nE3c8nd66tOHSarjTZ62Gmz5rNdz5m9bBXT5rNdzhhzYsWg13RRvh0Gq4G1q4Fm0IegcNd0QLV6QNQbl1cHe0RKA1cKesNlzaULQJxKUNlzYutb3VcBe0Ai5aA/cdWgH3PVoBd0Ur4KI1cDe0Ai5aAzehFXCv0Qq4E1oBd0Er4N6gFXA3tAJuQivg3qIVcO/QCrgzWgEXrYE7oRVwR7QC7o5WwEVr4Ca0Au41WgEXrYGL1sBNaAXcEa2Ai9bAHdAKuBtaAXdEK+DuaAVctAbuNVoBd0Ir4C5oBdx7tALu2q4NlzZc2nBp4xJHNYW4tOHShksbLm24tP25D2gFXLQG7iNaAXdDK+AmtAIuWgP3Ca2Ae91BGy5tuLTRc/VDwx07acOlDZc2XNroqn3OhR+i9Lf+XLQa7oBWwL1BK+AOaAVctIHj759/wQfpz0Wr4FJuM9znryly+Vt/Ls/WwEWr4KKt4AJ8/n/cR7QC7opWwEVr4Oa1pQaVH87a7lJuNdwxq60YMxT+1oWL1sBFq+GmkrbswHw27o5WwG1bY0RVn2atgYtWw71GK+DWaAE9V6TmHpq0Bi5aAxetgYtWw53Q1prh5Hi8JYdxd7QCLloBF62Ce422f5q5M1oBd0Ir4C6Hacuzn2O4I1oBd6jVwsilPxethrui7cLl63Yu5badm/kZLmngonVw0TbNxvpz0Wq4w79oK9aZM9I2LtoDueB6cB/RCrgrWgEXrYBLue3B5W8QM9J67oZWwE2HrjH25t6iFXCfGrU4ChXrV3vDriXaDlyU7VxKgoY7oxVw0Rq4Ce1lpbwOpuCiNXDRGrjXaAXcCa2Ai9bAXdAKuCtaARetgfuCVsBNaAXcO7QC7qtBG4qSQERauE8Sbbi0wYjRwp082mAdzMG9MmnjI6kLKzajoQfhAAAAAElFTkSuQmCC"

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA9BJREFUaAXtWEtrU1EQbl4gUqEFHyCC4EbxAbrRhStfCxfqQggu3JSkjYI/w9+gNi1tCbgpbsRt9Q+4KIJdiIKClaibZlFMBJP6TZo5TObcc++597ZpCgm0c86cme+bmfO6946NOX4Zra9Wqx3oLmTlwOzs7BZ+mVwu9894kJKM8vn8mVKp9KnrMTc391QqDQqsD5tO7AZzWVFlMpmVPjSyZGszEKik0cXFxQPGKk4DiAW2NxVhhZRE3QvyBpWwUqlkAh100FxWAutzCDNkZuMgjSUiGw6RpOrIcPrmWg5wm5aqzI/1lqzVakfZkCS3++jYi4ybzeYv7tOEcdsKSRuzIUvjSYogY4lONsbBx5gcTEgyZhrQyKSjn3HY7m7/dxlLmzHs7Xt9in3TMVVNGrGcDezm8zMzM2sSKzEBAbdarZcAvEXrWW4CSRQ4azIC3SZgWue0LAB6s7fm39JM49c9uek4Zz/vDGQp2FnLbDZ7anp6+qvURxL4AIcdYU6CtMCchUWwvLyc29jYMDVkQynDIpZ21M5rBcDfax334wAbH24IeUm0u80kwBpj1N/nFZifnz/pSiH2WaSBcNB9bLfb33AmmWtW2qQiAPgDHHjneoB0CFokiQko8omJidcAfyQitkgSERA4RY5d/2dycrKGY/qxJMGcmM1qHRXCMLDJ4DzYIzkISXfBC/zVy+XyKo/HItDgDMIkjUbjL264JdaTtE5TOSjbLnBhU8etdlz0u00vgqTgxBBJkAY8kiAteCjBToA7CXYKnAisjQbwVbH9yUb/AleLNuK+RQDwizwYIGOBk79FEADKqtjgFgGe4Y8xmpKJwC0ClOeKAqbuj0rADg2w81Mhi4eYaD7j/ZxGVqMK7OcKRF43g0iO3qXwvvoG2/wynk/oDe+Ofhl2xbGnCfQCf+e4G34jmetRiexJAgsLC0fGx8c3i8ViE2cePXY+QxKuWEITcTm5ZiyVXlccFV7Bs/Ndz0S+4xH4NNnKIAaSgA5cBkBtn0RobxQKhbNTU1Mt6b+rCUQFLgPRieA1iT4MPcfS+okvANfoi7627/oEKdPq4gau+eSM6DHdj/Vio511nwPHV7Y0DyN1fIl7ote65uL+jiwhDtxxHDJXlKyHLRWXc6oE9jJwTihRAsMQeKIEhinwWAkMY+DeCeCqv4/N+YodEshEm9OXx+cYLfqCKbtdDZy5fBK4zcaeciCBcyyhCeBb4VV8Yj3ExhFyoIFzLKEJ4EZc63Q669gDJ9gB1zy6W+uQnyG/QH7AE2UNN+cm24zkqAKjCgyuAv8BCoBEuDMQA4IAAAAASUVORK5CYII="

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAAXNSR0IArs4c6QAAAZlJREFUOBF9U71OwlAUpk1peQW76KImJi6+gU4aneQdSkjLpKsJDi6uxZDyDm66ipu7LBoddCG8gTQt1O+79N4cCnqTw/n7znfvOafUavIEQVBIX9g6RW2L+HrT6nQ6HlN5nm/1+/13O47jNMuybcdxvlRNu93epUEkxaJDds/zGkTT5yFwNpu9KQADRKdpOrVte38+n48Gg4HKmWfxUgLr9foHtX4MbXWFMsQPAbpBEV41rVardVsUxR7uPJNpVI8ty2qqGJwHigYwCQnpmy4E4ADxGzDe6QKjAfqBjEwAhmkTiTH8S8i3YFtgmYSoOxkhgEKbXSTo4rV6JwGYaqweCdAxwEeu617JfZBh3QnDcAeTv8DUrx0CUDjEniLuCsyPWGxzHVG54CE+jw2URb1eb2zGRKJy4fcwTyGGSBcipgplO0sEAKhTIZoi2IBEsnCBFGPWAeryy+LCeD4Xqnay9IWVwaUX/PXUyotMa+RQBJwqBvMMf6VHgvSpEvm+f64IoijyQbCZJMmLBv+nu92uO5lMDvHPevoFWybbDXp3IzQAAAAASUVORK5CYII="

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAAGtnFf2AAAAAXNSR0IArs4c6QAAAKpJREFUGBljPHPmDNdnYeF/DDsOnvnPAAIwBiOMwcLAyqgKkmFElgaxPexNwGIgNsOJE7f5wAwgwbjj0JmbDP8Z1EACQCU3mJgYGLrhsowMvWD2zkNnvoEwTAKFZtx//z7Hr0fvnv9n+C+AIgPkMDIwfmAT4ZAFW////3/GXYfO7gW63xGmECix383O2JmRkfE/0G6gDiDD3d7EiYmJqRjMZ2LIB/FB4iA+AFENOhO+o1bHAAAAAElFTkSuQmCC"

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAAEhyb7BAAAAAXNSR0IArs4c6QAAAYVJREFUOBGdlL1KA0EUhbNqqTbGRkEMIjYpjFaCCGqVJxCbQBDfwMZnEIKSQonWYuMLiBC0tRTRziKIJBELtbBbvzNxZmfMj7ALX+ace+5MdncmyWS44jj+1JgI4zqFRauVFpyRu4KvpPKrKF4oXfcT/LvxiBrcWnPgd3VrWsf8aiRDscpwBzfyKqxCsBZ+Al5sQ82IQR90Pw7KXUZj2xlPUN+HGVfCbMATtOHYBVZQfINR6zXiq7Bgaoi6H/qarPNQiIof9NQ05XsGXnEIndy9FwSSlVpBwTNkk1DQU+Rg18ucpG62ZSSKomfMNeiF7kATSpAlm2YMLxrnoA5NqEAR8rAM23AEH3AJuXA2jqIW0Esvd4V9CvTuwSvMmhbEJugOgp3rMz8oMycLLVjS3ehsFIOOFEb7NgWNFHODKVroHLQTqS6eZhi0jnnZ2tr/z+afr2LOGehGkovCCuh3dAjjSRIqMp3AE2jAvE3NP4c1dqRhDb0FGnXgvkF/Aw9wyiG8ZwyuHwNYMGArjUo4AAAAAElFTkSuQmCC"

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAAAwCAYAAABE+Xs2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAABBZSURBVHja7F17eFTVtf+tc+aRAIHwMAQVkgA+oPJWBJHKQ0QLM5METq0EEHwEtcXq/bA8Wm+nFQUUr1Juq6LlioFYO01CJopFaAm+EBRREFDDKwFNiEBCyGNeZ6/+cRXyODOZ10Hm+2Z93/wzZ+2z99rrt9dea+3HIURIfMd8c/WpuvkM5DDj6loYGj7hzoffEKkdGpgGIxokScdxzdVHOaNvX3Ts0AMSTjDBaZY7rHjnsdRqxClOIRBFUrhuXG6PxgbXVmYM0UCqWKGmvfs5dxwXUQsTEz/BHbdfKwxypzaNJ5wiyLdvW5y2O67KOAVtQ8O28Mrf5cZ690ZtwAOAkBbKR8ddQe4Pw26dLB3mKZMHaAEeAJjRQ0DdNPm5Y73iqoyT7qCvKt/0OIPHtMf3R/noTwzAiTCmIA/G3+JjydAx8OhDisvFrzIzxdUZJ91Af3LkPaOJxe+C8k7g6/JfcsVpAkRIM0m/vh+Kbt2vCY6Zbxu/4tjDcXXGSRfQfzfmniRmdT0z5GDLDKW6IcOp7t2grXxCwh5x/YhbQvO3eMW4Zyqui6s0TlEHvc/jW83MfUMt94h8YkwCiQNBQL5W3DoxFSG6K8wws8+Xf8ef2BxXa5yiBvrKkXMUMO4OKyaFMD4hH0kkUENA8A4fepA7JIYXmDIGNTUeWx5Xa5yiAvrTN953JVi8FEllV8CVYZOrP/XLkJz8PvfvNzqSOpjx6wnLjtwWV22cIgI9M5NX9b4GRtdIK/w5nRzbA96dbZwaSa4QE8cPiVgiZlKZXp341InucfXGKWzQV90wdwGDx0er0icNh/tL4JPnAU+k8tib6yDLSdGpgXup8L4SV2+cNKPG9hiqr793mArvRwBM0ax4ByfvXq32Hg4woXfvUjH6xnE6DOnc7Yv6vqxX5zEzZVuyRwnyTQGQwcAVYFxOAfqKibxGwrQCp3MvAGRlZaUIr68UQIew20HkJUYliA+BpSJTommzw+HwRCJbpsUyXwAPEcjYSuivOnXpfNeGDRvqQnqf1fobFvxQS/QRE3jpxpKSvwKAbaptLoj/G7qtuVBNT0odYwjYmaMfTazynt4QbcADwGiqHbFVSt7+pdy9mxh941hdRGR6btLTx0u3/KZ3WTTfm5mZmcyqutBmtc4A0AfcOp4OaGW+lczm5ot1vRgYEOHoAwP9wRgLiLkel/t4lsUyv6ikpDic1ymKcpnH5V4JZhO3laZffV3drwA8FaKBGM5AWut2gzD4Qt/wEMGcrp+F56MvOV9qCujeVPlOr0SkCglAi6WKgWLSuFOM4HP+IXZ0R4/q3TBuGxuiBnirdaZQxZfMWARGn1CbJBHmOByOM3pO38zcW2VstFlsT4ZT3ut2z2XmAIaO7rfb7RJii2ogS7OJiP02vHLk3VPAeEjPVpgleszQuduvieDWDwG4gXcc/UOkr8nNzTXaplodQnAemHuGZWkIzxc5nVsulpaZxRLrVOtjobpsQvB97fCk79mz5/bYil5pXnFx8XG/gWzVTQ+kEPNafaMJcqTs+r91Wxf13gemRTqHLosmPl0xNhLAn/y26g0GT49A3r190tMXX/SgjbA0Kyvr6mD5bTbbOABXtcuo8ryYCVxJetXpdDoCZ288TWuZkaJj+Hwi0dzhfKdtW5y+CkTv6GjzJNWn5t26/EyXcEpXVVatY3BWBA1oMIJnrF692n2xFc7MJtWrzg9aNQK5QepwSnZ29pXR1RI80YcafW1KMLWQv42vW3n93b9k8BT98E6CJZ6d/P4LNRdGIvHk547Ncbt4LzN66OPlcJqPa/8MYGYo5axW6y8g+K7AloQ+IYJTAGUyUCuIWkd/Bwq+n1pDnJJnEtGp9oFKEkMdDNBvmTlJI6K3AmgX+FlZWd1Vry8ryMEkq17v/QB+Hy0dmczm5R6P519+HsssxBNgDNcA1ZcgWkBEvhbdxywMZvMuh8NR7xf0p0bdN8Crep4JmH6IGPRYmbrztW2t/9/8aHrl+KeO3Q1iJzPrFNgiZ/zyI85ti/r+PRj+OXPmJNScPrMqQHd8I0t0X5HT+U892pvKqUVrnGsag2R/22azVULldRojvo+iKJ1aK78Nm6rOAWAOoT/vVRTljw6HQ42GvN8H+Jv9ul4WyxRGW9AT0+7iEudbQduS8wIodpNP9eaDkagj4vekZGQ87u/xtiXpm0iin4OoRq8mCEHTgg73T9fMZOYUP9b9K4PJeINegA8rVpOkj/098/l8HYIA8f1+ZD0MwKfx6AqPx2ONsSzOBUtfXX5kKTOG6gj4JqNsyiGHPaDftm1heuGUZeXbGkjcCcZQRuRbH5oFdY0GMvxPCEPkHj+yNBpMRktBQUHlpaRM4fPjmhAahwwZcqaoqCiQG/dTFqx1fqGuc3KXIWdrzy4E8+MaVuQBAEUxB/qqkXMnsFAX6GqFIC3o8dErB4PhfWtxWg2AF3/Mjpk1a1bHszW1N2hjSHq+oKCg7GK3KTc311hdVTVPCCS3ssQSmAcxs+YsRoxddrvd114Ay9qGYn1eXl6DzWZ7GQJLWruezJg0bdq0vgUFBUdiBvS1Nz/YtcndsA4RHhJvJ3h9q+fHr/4llqxBfW39MK1AHwAMJsOrP0abTlaetDPzEo2gMnD/S4EzY4qidHM3ubQHjCy/DADFxcXHbRbLJgCW1ixet3cegIWxolup0dO4mpkuY5Bbjx8IJ2BKvCfW/D6Q6s+XP/1jWHmbzTYW4NDXM4iOGs3m5wOxeF2u2QASNJIOuzZu3PhZs6DBz+zLcxVFMcWKag31dfVeQL/TRkTUEUbVFGuYV9HShWie5LrYbVEUpYunyZXHoZ90Y5LoQYfD0RSQCXS/5o4hklps1hs2bNg/9+z+9Bi33R9zmdvtzgbwt5iw9F27d3kYIN38MWbuCk/Tuli7rYD8ZJDY/2DQjTwu11/abNZqn3xE0szi4uLNgZiyrdYxzDxQQ/5zpgRTCxDb7XYB8Mt+FP1AzLg3l32w9hyRIYdAqm7AByYcHjh9AWKLTvpRboqiKKkXza2x2GYwY0aIA3anZJBHFZcU57c7o/ldgeV8rbx+B6K/EpFXQ8m3TLNMuzZmsjdXHXzjo7Jrs58AYNerIgEsPfoTZUvGfsdn7fFOWlFxuVeoswAMi2rKktEoyYZl/17Ye1e71kCSDqmqYI0An9xu950AVl0MBTGLZ4MA+QGA3yOickjS2y388AD0/1ukhaLl2cgwrtEq87rTedJqsW4EoLQZQOx9AMAjMQF6AOg/SF566At1MjNG66Q9k1eo+cdHKyN67/DvY45bdnSOV6j/y8wddZhxoKo+D4A72+MtKiqqtk21fMzASI3Bs2TGjBmv5efn1+ivIvoDwC8EdtxhdzpLHKEHLuos1liMJNDuwpJCv2eZZfCLqgboBXi2oiiL24shfnT35rygDodqMtBMAOf0M1sY4KpVV/oF/Iry6Qys1QPwFxQq5YXAXOwnTkmpP1f/j/nz5+t+3YjzTeeLRPhtwGYKfjErK+u60NVB2iuwEtYEKlfodG4j0Ncaj7p6Xa47cYlTi2xA2r6CIxJovp4VMuOhwwOUNhvaJqw8kgahvgI9A16iNaVL0t4Mlr1jUtILAGr8CDKh/Fh5aWZmZrreSiouKXkKRM8GmMG6qV7flszMzH7BvjPbYhnFzIM0XKV6AbzejjvFDLzkZyBd8gFtm8WX/l8WrCsbMG0KMyu6+fesrj00eNag/nvzqgHAziyVLj+6nhld9AM8vu7czfxoKEXy8/NrbBbbU8ziGT/AH8Wq+MpqseaB4JRluYyIalu4ArLMAL6LdFOWs8S5IHOqtasA+1vzSGVVbFUU5WaHw/FNu54N/Aawf3M6S87P9tnZ2b1kWW6TKvW63U1CaM6CN2ZlZQ0pKir6PCYs/Q9kMpjnURiXrobgW6cIb8P5Qyqly8sXM+NmHQHvJcmQUzLv8sZQi/bs1XMVCNv9z1xsAvO9EFysen0HfB7vt81/7iZXpdvlLrvLau0ZqRjGRHMuiAoDtCXd0+TacpflroDbsxVF6cJ+4pofAlhmJpvFuv17GU60/gnBflfYhape0tZeE/Rp+/JrSMZsAgnoh/wpZQOmPzRxWcUNYGHXV0z6fenCPp+EU3LNmjVec0JCNogOReDTZTSKyE+iORwONS09bQaBtgYwKAMaUL85Jyensz8ej8uTA257+wKBPissKfwYALJttluZ+adh6jZHUZROMQV6AOi/v3AbE57Vs3IB2NnbuJT97HGJkh//7vhF6SsiBNsZg9FwK4j2RjC7/SzTav1VpOKsXr3abUo0ZxHRzgCVDa8/e+5NRVEStcegyG0vgFUZD4Q/xjnJ4/LkxBzoAeAqSfodEe3Rq/JlpoFfcvGmPhDCow/ecdZI5ll2inzGKiwsLDcnmMcQoSDsQS74GZvNNjAKFr/elGD+GYj2+8c9j3W73IW5ubkt7q3JzMwcCWh8SIPQ2DEpacMPfjyYI9snfwmv0AYEPe13eIyyIYdAUc+7vmdM3VlOncZC9V0rvf/hh3oIx6AHty66vCJa73M4HPXFJSXTJZInh2kMElgV+dFIdTocjjMg3AaiowGAd3tVZdWG5td1sKpqpymBN364wMnn8d2LCGdfBg+12Ww3xhzoASD9izcOgiiqWwhqJdPJfDn9won7qpO30LeVUZ1RiLBh++KM1/XotI0lG9/Z6CweIcNwExGeJGAXgCqioLZyDK6oqBhxoZ1UC41TSUR0Fr3gDZjRcTq/lWRpEgFfBAC+8vnuz29q5mZpnTE9ZYDp6Qt184go+a8jmgl0SltPdCp4ndJ3fgZsSJsAg86Jfz0g+00wIj4wTgAvSLj+0zoYWnQsE1Ui05bIRkNy5HVQeWKnzoPffrh73cW0IHa7XSorKwsYwEmSpObl5TW0yqYkmkymFm5It27d3KHcnuAvcPV4PKL5Hhq73W7Yv39/623ETc1TqoqiyEDkx0ab18vMNHPmzDaH1kO9HlBLzvXr15+jtofxIwf9ocGzUtjTsI8R2dUgrxvTt5fKqZpfGaGkjjvUO+6IcBsECZKkW0oXpb2POMUpHPfmfDZnb161RHJEh0EqpKSvt8u9Rvmdic81jKaDByICKxEviwM+TlEBPQD0O+h4i4j+HE5FKmTX06aBxO0cWKF9B4agviG84JPwMUZl2ONqjVPUQA8ACcnSYyAcDLXcKtM1O72gq4JgTZK3/PssASEt2xNRg0k25pSOJ19crXGKKuh773A0GSV5BoiCzq3vli/75CupS9Cre+x1D8KOne+FaOYfifaV3HGKg/48Zex3fCYBQX1Htp5Mp18x9u0NhLZ7UjpxYixVV+8L0swXlS5Oj395JE76gR4A+h34x0oibAnsYoOXmq47LEAhb7ZiZll694Muks97th3W4wY23h9XZZx0Bz0RMTonTifQB5qBK0ne5abr3qsh08hw62Ch9sGbb5fD4znjF/Am+fZ/LbnydFyVcQo+3xEhsaLIh77guWDOYfDVZyVT02dy9yNO+crERsmQFo1GMqQzfM3V34i+aRnUKakrgG8YXGyk5D9tXdTtbFyNcQqF/jMAAhsLVqk+pdMAAAAASUVORK5CYII="

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAAAAXNSR0IArs4c6QAABKxJREFUWAnFWG+IVFUUP+e+cXPNbBdTaanWWZVIib4YxqrsrrD9lUihhaI07ENIhFYgjfQxdkKIkiDoQ0ESBAZGUQQuOLuVy34J+hBEWDu7KgoKuoGu0s682zn3zXne9969OzPLrD0Yznm/c+45590/55w7ALWnrzj5p/DITN/wpBaAqbI1RKDGCj0P8stoIS8YKOH6i2XDjh3uMSbhmeJ0J4ElRjHjQIa9NtBp2NjOC491GCARFyIejaySLG1LTLFnZK/XdPWKgBzrVxMz8GnpqkCgrkN4In4jRmK3sYR/WyB8IiYG+4rlL1Dr3aCC/aPvdH8ZKxrh8ORJooMCCsV27Bx9Mz+jBo5Mb3UpsKK+oU30KqxUf5GR7z67KrESjPcPT87FM8nAe99dZpJ4aKVzCaWE1HpJKMmiC430sFR3nnhZjKXV6/M5y3rMyo6JF1gkPCX2FwueoIjjY4U8T138xIZopzgnPdb0MBzp10NYnffbFElf2d4Be7Z2ZnaYbTdAtVsNFKeO2aDNh7Qgn/80Y0NOvqrDEyqE8DmntElQgYbXmxzjVI/mqFg+DVr3OjUaAM3RFb3+D8sdsuMFq0sR/6BtsJH14uW3B+0oTu0KdXicN7+NRzyWxg7nd6RxpyFW6n9/+iXQ4av0yZs1wgXyObEc1MEfCt23soxlLWOIUkXd+VK5YFvpUPdpy86tT1vAHI3QJD8uxsyBfP64DpqeaMphtWNlbBlDl/4qV8Ryk3SwlvdA8Qr5Bm/sugO+PfBAJt/Z+pIpcrzMtsDmP9nbZb96eS4jyr1XojFcMsbPzHoNiGAW9FEzRwIslNLB39ISQxTAvS0xhIC/tsQQoPqMDGHJNTcb1rSZZe/dsMyIuf689eRKlypw1Y3yUaqfcWr7wFpFMZ/GRd6nVw+XsmQMUdgHgZJUvUFpOfcHgsWTzZmumci4nnGTIYYy+YgFfcPlU9RqDIiSUFKuKFRDpwprvxFMqNOQCG3Kh7uq9RsIevt8x8oew4414M8B4scu57au8N6AONdd/nvqA631AVFuBeVlWLVu7dvcLrjsZQIymfsmjFPteMg1oGUYbTZcCr32urPteBPxC2Wxj0wFWOxg2Bn5YF/sk1/liWeokaIog9K0fQnCpvuWmgJ58Z85OH+lyYJktZEmIN9pSDu23ws774EnHr7Lhgyfvn9kFLxA1Jfw7ell0jnm1fMIlrUhLAmiCebrwqM9UQ5deEDG0Z4c7fp9dJI8bv3w7L88Jho35zwv/rE+CcdC3aze7FO47TjFoqK28La7djrkWOjY44RT+r+AOJHjhvk6VF9stBxwnGtW5GDvto445PXUHMizhTb33e2Bef3t7E04+fs1Ec1L6XhU7qRYcty9U50a4nvWvCMs4Yp2BU8/kj3yrNKzus38mK/QJa/RgLjYcixxYmzoHsxeFuGxbyFxQOyHCyr1/T8Sm/lTYxHiYJMj1Mc8ZRfaREDitHY14ivAYgU2Ql3ZULqwsn9nQBIYU7OU1fAI5asFX5aNPapXKlCH0hdE2xfzdQNKD6j9f7aTNuGgBn0//bpQg7k1cR6hpp9/5+iSNbIcg+99V960XXn/D+ClstE6xxhsAAAAAElFTkSuQmCC"

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAAAXNSR0IArs4c6QAAAaFJREFUOBGtlLFKA0EQhmfWmGCMLyARCy1sRFALixhRkCBCfAeLPIGVYCXY6AOIhQ8hggZFiEkZ09hY2IgHPoCaQrkbd+4Ysres7EFysOzkn///bvZyCcI/V6fzMtWP+gdEUR0A5xMbvSKqq6IqnlUqC5+uKLrEZutpixAugWjW1QfENyTYr22sPNh9ZQsMA4T7BIZtVFgvIkzz4lpP24572hN7LUBqQj7mV/T9nATwpLa+fISIkZkhItVs946155AnLanJRfP4qQn5mclkLhiD+Qbck0njjHHHFJCA9uKQglN7MiMTQ1F7WEu+tEE3BQSCOW5NEHUHFnc18MgbkPhSQD1hieVqdfXDjRmo4pGMdFJAEYfZsdnp7VAYXWhIeRiQzgY4php42+q+jwAmswR85GEnExjv5ZE/Qy8QAW8KhfEZXlyb47hqLzBfyDU215YCXly7IKbmBYa/mJeAWYtm735g9HMuodCoRbN3L5AAtiVk1qLZe84WXJ/vHru7rIea6LsyATXo2geSvvfIYsy6MzDIas7gCxT/oEcEjf8c/gBGz45ICm2kTwAAAABJRU5ErkJggg=="

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAAAXNSR0IArs4c6QAAAZtJREFUOBGtlL9KA0EQxmf2zhhBX0AUC219CcFChPgOhksMtlaClWCjrflzEh9ChDRiY2tnayMEfAALCXEzziS3ud1lw4nJwbJz3zfzu5lN7hBmXN1ud+17oM/YrgDQziQN33l/WFmObqrV6leoFENiq3W3p4nuCWgr5CPgR4R43Ggkz76vfGEMA3oawxBflIoqpQjWZUkMrImnOUdy/Xqnw2zMNylAhKvTk9oFIo7sIiJSt+30kgjOpVMef9ce3+lQzsx0FoIJWB4gnuk0O+fpMx0gIR2Jo1Bd+51NKzgQT3IyjX+0/HKASLAtVoz6NU8JR3mO+QdM8hwgAayKXK/XP8OYXDU5psY4DtCI8+zYbKYHGiEFoo15QHyw/YigphYCk064IWGpuTuzx2Lows+wGIjYKy+pTVl8Tj27oVBcCCzHWEuSpC9L4hDE1gqBw2FUMgV2bDR/LwSO8KdtiuzYaP5eCOSvy74psmOj+XvsC6H7ZqdzKLrWIdfV/gRk0KNbNvuucOTZpWFHyTsYtv6hMkvJC70QaPZx+AXaM5eTWkO2DgAAAABJRU5ErkJggg=="

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAnBJREFUSA21Vc1qFEEQrprdjdEoevAgiAt6MEFBoqyLrEvEn2hOBiR3wTyET+DFB/Cm72DwkEUk5Ocg67ARRQjkIHgSES8x0WzcKb+ans5O7/ass0IaZrq6ur6qrqqual5cDoVyjuLo2EkV/fN7+3tOCBVjQeY2kXzOAjFRWYQOp/eZ6RdO9iXNS9PAnAOmZAxA+cxUZSItkKYbK+Ea1tfTPNAtYOo9vP3l4kq4gcV4YsDwl5qfTu21d6tWiil6P12v4JQ4L/kj+XotLAsFkxZTGjnUvFm9+NWuHQOqPOpEL+0mB8E86BdQ7teOzUiCOxJFzy0GOmZBL9h1YImDmg/cgBMijXkSltghLvGq8Sw7B7HMXhxKg4GOdDQcAyahGvPekZ2Du9cub0JaP+9gLTS909hteSXARIYv4XfMKTSmLVytD1kY8K9o7cQeKAFG7z0fgMUWDMLwPzFFe6rB2szu7erED6XeNDfilpEH4+QgDyBL5kjn6E6tdkZDHY+l9fUTnfZooThM47In92F+8s5jaH6a6Kfdrc5bkm3TKvIm2YKHmU2S0RUHNS5tdnkS6jPs5EAbl/YWK6hFZO55f6Ex8zfcpFfCch5zXUiuNlZbjywW/em40o4B7YrpxkWmQlFEvkKTzXs3KvOqVCSqQ2KOJJqzBuzsGLDM/rnfAysTFKJ3IqwJ9o6cBnweGH3TtcpHUPp5h2NAH4ukn8fC2vwMKtsDq7WxHD4U4gfEhSczU5NNXIxn8Oy0YyB5ifYfCwv256C7qxQa2gWk6n4QmMcHt+4WuPbJ5LPJG+qiuqtylxyOMh6IjAA2ngXFaf57/AVTiObpZfWUaAAAAABJRU5ErkJggg=="

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAmhJREFUSA21VU9rE0EUn9kkxUVEDyKCUNCDFQ8igl7MqXi2IJJjJa10u7Q9+wm8eG2asAW70G+g9BvUQ6kgRS9CDkJPosWLpAlJzfP3dvelM3W6bgN9yTBv5v3bN++fXm1GpAqCvnjhKrNSp3dQUESVE0at+1rRt9OEiNQkaP4JeldrtX/izjzeglwlMcDKl8Pgjkk18dXW+gdF9Ni8U1p/Wg4XqtadcWi0oq84TqUeZIS1OL4+7A4eCd9EifaCINjXpPB3QxRFk/0/+r5QPb+yu1Svf5ezZSBVTu+EOBjqeeAbBBfxcwJ4niAqb4UIHTPA38vZE+S89nM3YD0Rv3n2LIlDZV3ZZiQvBsxzpAb8lAlUPNoTnHfLAAcUdxsmA+N5MVhcrLfBwssJOiu0LqedkwOXWql7RHTJLDSt9W/E/fNpMkjrB6D54oH/T54bkq4EYoNgsWvDkBG0LF8lF3n70uzsL6avbW4mLSOPV2jigZzH3q/5/mGtVuuKgjiOr3Q8r1Q+S+OSL3fJ/DzsvYLyN2Kg0+vvoBeNWkWhIIvwWfbkibgr5jWupNkVCKjLsBUDblxpb0lZuYg4z12Fho/6gQTeQvbdRpZV0Q8fNlrrcyMjRJcZtwykXfG4cWUV2nYVGhS2V8KF+UQpURVp+xz6eFlgGbAoxsHlgZDJo4/eUHGAnVDIgMsD0bYSBF+A83KCZYCHRdbPE2ZpXHkeiNZGM3qBdvOspLzXYfhyFxOtiRjdsAxkk2g0LEQ4z4NjHn0XAX96pIYyfKYRl7QOELCb2QwVfmsHIw/9sSD1gGgCqTY1lob/CP0FzrXy1IJLu0kAAAAASUVORK5CYII="

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAGZJREFUGBlj/FhQsJCJiWkTb1/fWgYk8LmoKPjfv39+QDmmTX///VsMEoDJg9ggMZAcI0gQJsDMxBQL4oMkQWyQqWAFyIpAbJgkiM0EIvABwlYg2w/zCbIYE8gryHaCrAMpBImB5ABwHVCoTngwmwAAAABJRU5ErkJggg=="

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rolling.079bdaf.gif";

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAAAAXNSR0IArs4c6QAAApRJREFUWAntWD1vEzEYtl0EqtQVRUokpGRsO+UDiYwgsWROfwELggFYs3TJCh1ALP0FZM6CRMYsSTbomETNlJlkKBKXvs/1fPh86dm5c6sbOOlkv34fP3789fp8nNFTq9U2SPFMJhPO1YKbYsYeINNsNqXNhsMh24rkgOgUvNFoHHme9zOovxKKgbIDEXjCxFygk4ZV1YzekOoL87G2Qo+SAWil2Fuzsve/yHuoIzjnZ+Px+P3WcdPAno0mYQNiIajf7/ut6CkKbTT9Y9LERsywuUipZhhBNFZf5GD+oMrPNQJrs1KpPELnts6INUsAhOzYtO5KAryx/7akMSJMLi2ysL7JlkCrBSDBSWlMURI4ySewX5IAtj6BTYd1QBU820oqDovRD42ysF6vf9psNq/IPpBlhvRCCHEyGo2wDhlvt9sPp9PplaFSkntAil5g1v4SKtOgk7JjEGQigVQK6t8yk4CInkNXRNm7dSPIwfjcSoRNqp6uJvtWokKhwDqdjvQzky2BOdz9UlrWNHfraOVEEcWk871SqfSYxudpljGiMPIMEfItolxKIi+Irsw/skGCADebzT5SlHxNppMuW4jzqBNfy+Xyh16v9wd4XxCF688k5I0FwZ1BMLr+KAdnx7s7a2kHYhJ1hq3/m+rYHmQ70KeC+tsjL2LQg/jdJFW/HFa6r91kLTl3gvz7apJ8nLA4HPEsl0vWarUi8Kz+CBkZe8Vi8VQvVO35fM6q1Spbr9es2+2yxWKhullWf4SMDGcnvk6c1s7dGvovyDSVGKELE+ge/bhjiRNqMNUtz7FQD1oEbnz0cbRP5APHDexCN4AGaAk/0GRt/JnDVZbel1T2hF7Xhy/+ml3Sp8Z3es/lFVi2fw2Ju+SAdwtfZwAAAABJRU5ErkJggg=="

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAb9JREFUKBVdUrtKA1EQ3d3sRhFTiv6DINaKz19QRAQ1EMgLQwqtBHENYqNdnhujYCVCYqWtoIUpLETQVNY2go3Cms0m8Zyb3Lg6cGfmnJk7OzN3FQUSiUQuqSoESjQaNYUjlRoOh3c1TSu12+0qzooIIG2yl0EHBS58Pl9IRhfoaFStVmuElqVnaZF6Taug8rFwuiqRSPQhOC2KeQNIfO3heDw+yEwSCKRkAP6VSsCEZrN5BtdFw7VisbgnktiAvCkIKNw6oa9jRCedTtdBvKuqugH8kM/nQ8A7Wi6Xu2cWSg3puv6ISb+JkTgqhiSg4LvrmUzmrYMUQ2NXXcBNfNA3TbM/EAisCd6bwK3GYrEZBsQodNg1xtiEe2BZVpWcFIw64bruNvo5RLO35NXu/Od+v3+RE5EEN47ellCobhhGOZvNvpDnOhzHKaOd5d+fgBEIvjyPExQACm9jAa9KTAuuosM2vGShULghTiaTw7Zt38ENgvvTOrgGV1fjDLB/BK0OoP25//NiOVNIfNYQSGEWA58veZ8Us3zisi2rcdXIOSXGnf3eVklwUXiTLRQaw3HJQQw8/RPOEV79q0Mpyg+2/86GYPb9OQAAAABJRU5ErkJggg=="

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAAXNSR0IArs4c6QAAAVlJREFUOBFjtG+/v5Xh/38vBnIAI+O2g5WK3qGr/jO/e/DYio1D9hSjfdu9/werlBjJMQ+kV11Yke3muwcrgY4KZGBkLGIixyBkPUiGvWdkZdhOtoFpM/+zgg2GuOw9MzOjy4ESxRtkGQgyDOwykImMjGDD9pUpnANxSTYQbhjIZUAAchnMMBCfBUTAgHPPQ62/v/5mAW3tOVCp+AAmDqNRDAO6DBgRgsiGgdShuPDv73++/xkYsv8z/D/o1v1AEWYQiEY3DOQyZHkYG8VABj7uqYyMDEcY/jPI/fzz7wDMUGyGobsMq4EHssW+MPDxeCIb6th5Tx05aaCHGcwgGI3qQqAouqH//jFchiZalNiEGYBOYxgIUoBmKCt60kA3BJmP1UBkQ0HZCZgDrHCFGbJhIDZKskGXBLuUgaEfXRwfH6cL8WnCJ8cC9NI2UKmBTxEuOWBq2IouBwBmoqnOa6C/uQAAAABJRU5ErkJggg=="

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAAXNSR0IArs4c6QAAAGNJREFUOBFjvHv37lYGBgYvBiDjP5DBwAhjgDgQgC7CBJOA0Vj0wKSIp9FtQdeJYSv1FRDyxzZ0K1H4IA/QwZF0sAKeGFD8RySHqGAgZBZBT44aQCgEGBhYgEq2EcpWeIzZCgC5+ym8f3vfhwAAAABJRU5ErkJggg=="

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAAXNSR0IArs4c6QAAAGlJREFUOBFjtG+/v5Xh/38vBvu2e/8ZgIARxgBxIABdhAkmAaOx6IFJEU+j24KuE8NW6ivA7w9Gxm3oVqLwQR6ggyPpYAU8MaD4j0gOUcFAyCyCnhw1gFAIMDCwMACTLKFshcsYRkaGrQD2USFGrgHooQAAAABJRU5ErkJggg=="

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAGZJREFUGBmFj0sKgDAMRCelB/BeghvXHk5cuxF6LnuCal8x0IVooGUyL+RjZ9Jq0jGM2tVFTpovaQrAUrRhOEfjweqT3AhBCzkQTddW0BehHTbN9xUR+DaiemJE7KFfAnwWl/2deQP6VD5ctWcARgAAAABJRU5ErkJggg=="

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAAEhyb7BAAAAAXNSR0IArs4c6QAAAYBJREFUOBHNVD1Pw0AMPV8TEAOIiY0NVmiaCKEAQUFU5O+AQP0PBYmZf5KqEqJQpQg1LWLuxsbCgBBDUw77opyuSYbyMZDlnOf3bMf2hbH8E3b6gjAuHZxXpwiQuRUKZOlosO+AFJMhaQBNRdcNaN3G50KIUwKBwTsXBrtSDBBpDRRcT6AIMxuFGvNKblSstFb0YK4BHpZOmvds0wdIFImcYbfvswm7BgBx5Nlptbrq17ZM1+rEr4KJ5Xw0THuJaU94uxtvlxFIgO09ppPXd+17APZBL4XHhHXC5BfM7dlLBQJjw8C1R4pEvWC5ueK8a5lQ9SLw7Ab1Rzoq7CAjlJ7h3WCz1PGvQDkU6vlkIno/qcwwuHu4U+vJJtFccPlvvh0INRSEdFq3HZ8DNGYNRtzAc/yMP7XeBLajR+tznDzg/IyMpJ8oSLhpbNXd6jCH66+pHUXPC2/jlyfc1TXdi1d/tGiubLjuamE9CxXpQvx/NHHBzwjDJbvA2yBtnfPn9hcX63OQJxgP9AAAAABJRU5ErkJggg=="

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rememberpw_off@2x.157b682.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rememberpw_on@2x.b0903e0.png";

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAglJREFUKBVVUj1oU1EUPufel6W+NCC4tJEm2kUcHBzczAst6iDdC6JDaXeLGM2gdnkxULsJYskiSge3bqIhqU7iIAo6aMlrIC4WpPlzae693u++PK1nOPee7/x/9xJZCcLoY6xgFcJoDaeTYhhdYCAepV4oOnzPxC/Hnr2n8MJgqCBs9Sdlegp3Klba53EKKEP6Kk6eq+4VlT/xwXSHn11OoRL92Lmbn4YXUqy25wQZ7YrFUKwRiFvw+Kcv0AWRDqhED5IKf8suVPfTPTV4a1vPGuKNnXL+vquDAZJMB1iVlPa0osVGeWbFAr88kpeF5IPXt09OY31hMhOryLC9jmsenTlMjfZhM5lVwd3hWRgQY/hU82b+ILZ4V2iirdj4pzHDpPQvxiSEUcvytGgyx75w9/eGkLRVL+UazokcTD1SpiaI39gGNQQCj9vykiYz70leQpLDsX9XDT4JKZYbpZk6wMLD1jJpXsPELPhes5SrAccoWunNjPTPiZ4evMMoSVJQ7WTZ8HdL4BRYNkrfCMK2e03EIBZEe3bt0ybju7FQtVnKduzRCSrRFfv+TySlLtXL2W/wQdLS/9pT/VkPzyPs0hZbcZ6xatzJvbLXPDObo3hfDR8hx5HjiNHmuRDiejLy0WDc3X5aP/MEX/uPVTjHRN2y1RbwWYBZXndty21LyPp26UQ/xoj+AGYs7FdkrMCTAAAAAElFTkSuQmCC"

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(667)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  "data-v-84452d62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  "data-v-5e62cdb2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(662)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  "data-v-7a656a44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  "data-v-35da31fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  "data-v-087ec91e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  "data-v-4c37fbcd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(665)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  "data-v-90f5dcf8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(763),
  /* scopeId */
  "data-v-1c819a19",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  "data-v-828fa6be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  "data-v-02be8515",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  "data-v-de208854",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  "data-v-3d66b829",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  "data-v-6f492b1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-6bc3e874",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  "data-v-5d6bb202",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  "data-v-26605828",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  "data-v-5ca9ce0d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  "data-v-71402483",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  "data-v-4ece1076",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  "data-v-07b191fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  "data-v-138fd8d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  "data-v-bca5810c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  "data-v-b3e5a52a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(660)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  "data-v-725559e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  "data-v-dfefc1b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  "data-v-2ec70eae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-exist"
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'accountexist'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Warn', {
    attrs: {
      "type": 'accountexist'
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'continue',
      "data": _vm.account
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-phone"
  }, [_c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('CountryCode', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "sendCountryCode": _vm.sendCountryCode
    }
  }), _vm._v(" "), _c('Inputs', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": 'phone'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('Inputs', {
    staticStyle: {
      "width": "180px",
      "margin-top": "0",
      "float": "left"
    },
    attrs: {
      "type": 'code'
    },
    on: {
      "inputText": _vm.getCode,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('GetCode', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": 0,
      "data": {
        countryCode: _vm.countryCode,
        phone: _vm.phone
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('Buttons', {
    staticStyle: {
      "width": "140px",
      "float": "left",
      "margin-top": "0"
    },
    attrs: {
      "type": 'back'
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "width": "140px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": 'done',
      "data": _vm.data
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.verifyLater()
      }
    }
  }, [_vm._v("Skip and verify later")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-error"
  }, [_c('Icon'), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.text1))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text2))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.text3))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text4))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text5))])]), _vm._v(" "), _c('Buttons', {
    staticStyle: {
      "width": "200px",
      "margin-top": "50px"
    },
    attrs: {
      "type": 'tosignup'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "input",
    staticClass: "inputs",
    style: ({
      'background': (_vm.bgWhite ? '' : '#f5f7fa')
    }),
    attrs: {
      "name": "",
      "placeholder": _vm.params[_vm.type].placeholder,
      "autocomplete": "new-password",
      "readonly": _vm.readonly
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "focus": function($event) {
        _vm.bgWhite = true
      },
      "blur": function($event) {
        _vm.bgWhite = false
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.enterInput.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), (this.type === 'password' || this.type === 'newpassword') ? _c('div', {
    staticClass: "password",
    attrs: {
      "id": "password"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === 'password' && _vm.$route.path !== '/invite/accountexist' && _vm.$route.path !== '/invite/invitenext'),
      expression: "this.type === 'password' && $route.path !== '/invite/accountexist' && $route.path !== '/invite/invitenext'"
    }],
    staticClass: "password-remember",
    on: {
      "click": _vm.rememberPassword
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rememberpw),
      expression: "rememberpw"
    }],
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "src": __webpack_require__(717)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rememberpw),
      expression: "!rememberpw"
    }],
    staticClass: "handle_hover",
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": __webpack_require__(719)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rememberpw),
      expression: "!rememberpw"
    }],
    staticClass: "handle_default",
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": __webpack_require__(718)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.rememberPasswordTip))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === 'newpassword'),
      expression: "this.type === 'newpassword'"
    }],
    staticClass: "password-level"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordLevel > 0),
      expression: "passwordLevel > 0"
    }],
    staticClass: "level",
    staticStyle: {
      "background": "#f06f6f"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordLevel > 1),
      expression: "passwordLevel > 1"
    }],
    staticClass: "level",
    staticStyle: {
      "background": "#ffbf62"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordLevel > 2),
      expression: "passwordLevel > 2"
    }],
    staticClass: "level",
    staticStyle: {
      "background": "#4db74d"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-success"
  }, [_c('Icon'), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Your account has been created!")]), _vm._v(" "), _c('Iconsuccess', {
    staticStyle: {
      "margin-top": "65px"
    }
  }), _vm._v(" "), _c('Buttons', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": 'open'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.cls
  })
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-success"
  }, [_c('Icon'), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('Iconsuccess', {
    staticStyle: {
      "margin-top": "65px"
    }
  }), _vm._v(" "), _c('Buttons', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": 'open'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warn"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.isGeneric ? _vm.params[_vm.type].text : _vm.params[_vm.type].text + _vm.params[_vm.type].text2))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGeneric),
      expression: "!isGeneric"
    }],
    staticStyle: {
      "color": "#3f86de",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.clickRouter
    }
  }, [_vm._v(_vm._s(_vm.params[_vm.type].router))])])])
},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPc ? 'scan' : ''
  }, [_c('img', {
    staticClass: "scan-help",
    style: ({
      marginRight: (_vm.scanHelpShow ? '0' : '-140px'),
      opacity: (_vm.scanHelpShow ? '1' : '0')
    }),
    attrs: {
      "src": _vm.scanHelpImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scan-content",
    style: ({
      marginLeft: (_vm.scanHelpShow ? '0' : '140px')
    })
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'account'
    }
  }), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "margin-top": "0"
    }
  }), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow && _vm.$route.query.showTip && !_vm.isGeneric) ? _c('Error', {
    attrs: {
      "type": 'tip',
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Qrcode'), _vm._v(" "), _c('Foot', {
    staticStyle: {
      "margin-bottom": "45px"
    },
    attrs: {
      "type": 'Scan the QR code to sign in'
    },
    on: {
      "scanHelp": _vm.scanHelp
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPC ? 'start' : 'start-mobile',
    attrs: {
      "id": "start"
    }
  }, [(_vm.isPC) ? _c('Icon') : _vm._e(), _vm._v(" "), _c('Shadows', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPC && _vm.isWX),
      expression: "!isPC && isWX"
    }]
  }), _vm._v(" "), (!_vm.isPC) ? _c('Top') : _vm._e(), _vm._v(" "), _c('Titles'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Inputs', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "type": 'inviteAccount'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    style: ({
      marginBottom: (_vm.isPC ? '100px' : '0px')
    }),
    attrs: {
      "type": 'StartSecureMessaging',
      "data": _vm.account
    },
    on: {
      "openErrorTip": _vm.openErrorTip
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [(_vm.params[_vm.type].text) ? _c('span', [_vm._v(_vm._s(_vm.params[_vm.type].text))]) : _vm._e(), _vm._v(" "), (_vm.type === 'Scan the QR code to sign in') ? _c('img', {
    staticClass: "cursor-help",
    attrs: {
      "src": __webpack_require__(725)
    },
    on: {
      "click": _vm.help
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.clickRouter
    }
  }, [_vm._v(_vm._s(_vm.params[_vm.type].router))])])
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(699)
    }
  })])])
}]}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-exist"
  }, [_c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('isError', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Titles'), _vm._v(" "), _c('Account', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "type": 3,
      "content": _vm.$route.query.account
    }
  }), _vm._v(" "), _c('Inputs', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "type": 'password'
    },
    on: {
      "inputText": _vm.getPassword,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "margin-top": "45px",
      "margin-bottom": "115px"
    },
    attrs: {
      "type": 'join',
      "data": {
        type: _vm.type,
        password: _vm.password,
        account: _vm.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(716)
    }
  })])
}]}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.query.account))]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('Inputs', {
    staticStyle: {
      "width": "180px",
      "margin-top": "0",
      "float": "left"
    },
    attrs: {
      "type": 'code'
    },
    on: {
      "inputText": _vm.getCode,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('GetCode', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": 1,
      "data": {
        'countryCode': _vm.$route.query.countryCode,
        'phone': _vm.$route.query.account
      }
    }
  })], 1), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'newpassword'
    },
    on: {
      "inputText": _vm.getPassword,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": 'reset',
      "data": {
        code: _vm.code,
        password: _vm.password
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  }), _vm._v(" "), _c('Foot', {
    staticStyle: {
      "margin-top": "25px",
      "margin-bottom": "45px"
    },
    attrs: {
      "type": 'or Sign in',
      "isEmail": _vm.isEmail ? true : false
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-next"
  }, [_c('Icon'), _vm._v(" "), _c('Titles'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Account', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "type": _vm.type,
      "content": _vm.$route.query.account
    }
  }), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'newpassword'
    },
    on: {
      "inputText": _vm.getNewPassword,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('Buttons', {
    staticStyle: {
      "width": "140px",
      "float": "left",
      "margin-top": "0"
    },
    attrs: {
      "type": 'back',
      "data": {
        type: _vm.type,
        username: _vm.name,
        password: _vm.newpassword,
        account: _vm.$route.query.account
      }
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "width": "140px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": _vm.isPhone ? 'done' : 'done',
      "data": {
        type: _vm.type,
        username: _vm.name,
        password: _vm.newpassword,
        account: _vm.$route.query.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('span', [_vm._v(_vm._s(_vm.footText))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.craitapp.com/useragreement.php",
      "target": "_blank"
    },
    on: {
      "click": _vm.uploadWebEvent
    }
  }, [_vm._v(_vm._s(_vm.footRouter))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-next"
  }, [_c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Account', {
    attrs: {
      "content": _vm.$route.query.account
    }
  }), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'newpassword'
    },
    on: {
      "inputText": _vm.getNewPassword,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('Buttons', {
    staticStyle: {
      "width": "140px",
      "float": "left",
      "margin-top": "0"
    },
    attrs: {
      "type": 'back',
      "data": {
        type: _vm.type,
        username: _vm.name,
        password: _vm.newpassword,
        account: _vm.$route.query.account
      }
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "width": "140px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": _vm.isPhone ? 'done' : 'done',
      "data": {
        type: _vm.type,
        username: _vm.name,
        password: _vm.newpassword,
        account: _vm.$route.query.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('span', [_vm._v("By registering, you agree to the ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.craitapp.com/useragreement.php",
      "target": "_blank"
    }
  }, [_vm._v("User agreement")])])
}]}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error",
    class: _vm.type === 'tip' ? 'yellow' : 'red',
    style: ({
      width: (_vm.type === 'tip') ? '260px' : '300px'
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [(_vm.type === 'tip') ? _c('img', {
    attrs: {
      "src": __webpack_require__(721)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(712)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPc ? 'signin' : ''
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('el-collapse-transition', [_c('Error', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1), _vm._v(" "), _c('Inputs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.passwordShow),
      expression: "!passwordShow"
    }],
    attrs: {
      "type": 'account',
      "data": _vm.account
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('el-collapse-transition', [(_vm.notExist) ? _c('Warn', {
    attrs: {
      "type": 'accountnotexist',
      "data": _vm.account
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Account', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordShow),
      expression: "passwordShow"
    }],
    staticStyle: {
      "margin-top": "38px"
    },
    attrs: {
      "content": _vm.account
    },
    on: {
      "showPassword": _vm.showPassword
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "password-input",
    style: ({
      marginTop: (!_vm.passwordShow ? '-70px' : '0'),
      opacity: (!_vm.passwordShow ? '0' : '1')
    })
  }, [_c('Inputs', {
    attrs: {
      "type": 'password',
      "remember": {
        password: _vm.password,
        rememberpw: _vm.rememberpw
      },
      "change": _vm.change
    },
    on: {
      "inputText": _vm.getPassword,
      "rememberpw": _vm.getRememberpw,
      "enterInput": _vm.enterInput
    }
  })], 1), _vm._v(" "), (!_vm.passwordShow) ? _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'signin',
      "data": _vm.account
    },
    on: {
      "accountNotExist": _vm.accountNotExist,
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip,
      "showPassword": _vm.showPassword
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordShow) ? _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "margin-top": "60px"
    },
    style: ({
      marginBottom: (!_vm.isEmail && !_vm.isPhone ? '80px' : '')
    }),
    attrs: {
      "type": 'login',
      "data": {
        type: _vm.type,
        password: _vm.password,
        account: _vm.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip,
      "loginSuccess": _vm.loginSuccess
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.passwordShow && !_vm.isGenericVersion) ? _c('Foot', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "type": 'No using crait'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordShow && (_vm.isEmail || _vm.isPhone)) ? _c('Foot', {
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "44px"
    },
    attrs: {
      "type": 'Forgot password',
      "isEmail": _vm.isEmail ? true : false,
      "account": _vm.account
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-success"
  }, [_c('Icon'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Your password has been reset")]), _vm._v(" "), _c('Iconsuccess', {
    staticStyle: {
      "margin-top": "65px"
    }
  }), _vm._v(" "), _c('Foot', {
    staticStyle: {
      "margin-top": "55px"
    },
    attrs: {
      "type": 'Going back to sign in page'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flash),
      expression: "flash"
    }],
    staticClass: "flash",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Click to update QR code")]), _vm._v(" "), _c('Qrcode', {
    attrs: {
      "size": _vm.size,
      "cls": "code",
      "value": _vm.qrcode
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrlogin"
  }, [_c('div', {
    staticClass: "qrcode"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flash),
      expression: "flash"
    }],
    staticClass: "flash",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Click to update QR code")]), _vm._v(" "), _c('Qrcode', {
    attrs: {
      "size": _vm.size,
      "cls": "code",
      "value": _vm.qrcode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("Scan QR Code to login Vanish")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('div', {
    staticClass: "change"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(697),
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(701)
    },
    on: {
      "click": _vm.clickIcon
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button"
  }, [_c('button', {
    ref: "buttonDOM",
    staticClass: "buttons",
    class: _vm.type === 'back' || _vm.type === 'tosignup' ? 'white' : '',
    style: ({
      cursor: (!_vm.loading ? 'pointer' : 'not-allowed')
    }),
    on: {
      "click": _vm.clickBtn
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._v(_vm._s(_vm.params[_vm.type].text))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.isGenericVersion),
      expression: "loading && !isGenericVersion"
    }],
    staticClass: "rolling",
    attrs: {
      "src": _vm.rolling
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && _vm.isGenericVersion),
      expression: "loading && isGenericVersion"
    }],
    staticClass: "load",
    attrs: {
      "src": _vm.loadingImgUrl
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password"
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Account', {
    attrs: {
      "content": _vm.account
    }
  }), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'password',
      "remember": {
        password: _vm.password,
        rememberpw: _vm.rememberpw
      }
    },
    on: {
      "inputText": _vm.getPassword,
      "rememberpw": _vm.getRememberpw,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "margin-top": "60px"
    },
    style: ({
      marginBottom: (!_vm.isEmail && !_vm.isPhone ? '80px' : '')
    }),
    attrs: {
      "type": 'login',
      "data": {
        type: _vm.type,
        password: _vm.password,
        account: _vm.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip,
      "loginSuccess": _vm.loginSuccess
    }
  }), _vm._v(" "), _c('Foot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmail || _vm.isPhone),
      expression: "isEmail || isPhone"
    }],
    staticStyle: {
      "margin-top": "50px",
      "margin-bottom": "35px"
    },
    attrs: {
      "type": 'Forgot password',
      "isEmail": _vm.isEmail ? true : false
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email input-view",
    attrs: {
      "type": "text",
      "list": "email-list",
      "placeholder": "Enter your Email or Phone Number"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password input-view",
    attrs: {
      "type": "password",
      "placeholder": "Enter your password",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rememberpw),
      expression: "!rememberpw"
    }],
    staticClass: "rememberpw",
    attrs: {
      "src": __webpack_require__(723),
      "title": "Remember your password"
    },
    on: {
      "click": function($event) {
        _vm.rememberpw = !_vm.rememberpw
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rememberpw),
      expression: "rememberpw"
    }],
    staticClass: "rememberpw",
    attrs: {
      "src": __webpack_require__(724),
      "title": "Don't remember your password"
    },
    on: {
      "click": function($event) {
        _vm.rememberpw = !_vm.rememberpw
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/forgot"
    }
  }, [_vm._v("Forgot Password")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/qrcode"
    }
  }, [_c('div', {
    staticClass: "change"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(698),
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title",
    style: ({
      marginTop: (_vm.isPC ? '30px' : '80px')
    })
  }, [_vm._v(_vm._s(_vm.title))])
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "identify-device"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeWindow
    }
  }, [_c('img', {
    staticClass: "closeimg",
    attrs: {
      "src": __webpack_require__(703),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.indentifyTitile))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "showDeviceInfo",
    style: (_vm.showAccountList ? 'borderColor: #58a6e7 ' : ''),
    on: {
      "click": _vm.openList
    }
  }, [_c('div', {
    staticClass: "useDevice"
  }, [_vm._v(_vm._s(_vm.useDeviceTip))]), _vm._v(" "), _c('div', {
    staticClass: "useDevice deviceAccount"
  }, [_vm._v(_vm._s(_vm.currentAccount))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showdropbutton),
      expression: "showdropbutton"
    }],
    staticClass: "dropbutton"
  }, [_c('img', {
    staticClass: "dropimg",
    attrs: {
      "src": __webpack_require__(704),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAccountList),
      expression: "showAccountList"
    }],
    staticClass: "devicelist"
  }, _vm._l((_vm.accountList), function(value, key) {
    return _c('div', {
      staticClass: "deviceitem",
      on: {
        "click": function($event) {
          return _vm.selectAccount(value, key)
        }
      }
    }, [_c('div', {
      staticClass: "useDevice"
    }, [_vm._v(_vm._s(_vm.getDeviceName(key)))]), _vm._v(" "), _c('div', {
      staticClass: "useDevice deviceAccount"
    }, [_vm._v(_vm._s(_vm.getDeviceValue(key)))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "getVerifyCode"
  }, [_c('input', {
    staticClass: "inputcode",
    attrs: {
      "type": "text",
      "placeholder": "input your code"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showGetCode),
      expression: "!showGetCode"
    }],
    staticClass: "timer"
  }, [_vm._v(" " + _vm._s(_vm.showTimerTip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGetCode),
      expression: "showGetCode"
    }],
    staticClass: "getcodebutton",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.getCodeButtonTip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showGetCode),
      expression: "!showGetCode"
    }],
    staticClass: "regetcodeTip"
  }, [_vm._v(_vm._s(_vm.regetCodeTip))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGenericVersion),
      expression: "!isGenericVersion"
    }],
    staticClass: "needhelp",
    on: {
      "click": _vm.openHelpWindow
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(715),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "helptip"
  }, [_vm._v(_vm._s(_vm.needHelpTip))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.verifyLoading),
      expression: "verifyLoading"
    }],
    staticClass: "verifybutton",
    on: {
      "click": _vm.sendVerifyCode
    }
  }, [_vm._v(_vm._s(_vm.verifyButton))])])
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPc ? 'signup' : ''
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'account'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('el-collapse-transition', [(_vm.exist) ? _c('Warn', {
    attrs: {
      "type": 'accountexist',
      "data": _vm.account
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'continue',
      "data": _vm.account
    },
    on: {
      "accountExist": _vm.accountExist,
      "openErrorTip": _vm.openErrorTip
    }
  }), _vm._v(" "), (!_vm.isGenericVersion) ? _c('Foot', {
    staticStyle: {
      "margin-bottom": "44px"
    },
    attrs: {
      "type": 'Already using crait'
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPC ? 'invite-next' : 'invite-next-mobile',
    attrs: {
      "id": "invite-next"
    }
  }, [(_vm.isPC) ? _c('Icon') : _vm._e(), _vm._v(" "), (!_vm.isPC) ? _c('Top') : _vm._e(), _vm._v(" "), _c('Titles'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'password'
    },
    on: {
      "inputText": _vm.getPassword,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'Accept',
      "data": {
        type: _vm.type,
        password: _vm.password,
        account: _vm.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('span', [_vm._v(_vm._s(_vm.footText))]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.switchClick
    }
  }, [_vm._v(_vm._s(_vm.footRouter))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get-code",
    style: ({
      cursor: (_vm.code === 'Send Code' || _vm.code === '获取验证码' ? 'pointer' : 'not-allowed')
    }),
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v("\n  " + _vm._s(_vm.code) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shadow"
  }, [_c('img', {
    staticClass: "arrow",
    attrs: {
      "src": __webpack_require__(702)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "h20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(707)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text1))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(714)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text2))])]), _vm._v(" "), _c('div', {
    staticClass: "h20 mt10"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(720)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text3))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(700)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text4))])])])])
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start"
  }, [_c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Titles'), _vm._v(" "), _c('Inputs', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "type": 'account'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "type": 'continue',
      "data": _vm.account
    },
    on: {
      "openErrorTip": _vm.openErrorTip
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    class: _vm.isPc ? 'wrap-web' : 'wrap-phone',
    style: ({
      background: _vm.isPc ? 'url(' + _vm.bgImg + ') center center no-repeat' : '',
      'background-size': 'cover'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "isPc": _vm.isPc
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-phone"
  }, [_c('Icon'), _vm._v(" "), _c('Titles'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('CountryCode', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "sendCountryCode": _vm.sendCountryCode
    }
  }), _vm._v(" "), _c('Inputs', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": 'phone'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('Inputs', {
    staticStyle: {
      "width": "180px",
      "margin-top": "0",
      "float": "left"
    },
    attrs: {
      "type": 'code'
    },
    on: {
      "inputText": _vm.getCode,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('GetCode', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": 0,
      "data": {
        countryCode: _vm.countryCode,
        phone: _vm.phone
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('Buttons', {
    staticStyle: {
      "width": "140px",
      "float": "left",
      "margin-top": "0"
    },
    attrs: {
      "type": 'back'
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "width": "140px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": 'done',
      "data": _vm.data
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.verifyLater()
      }
    }
  }, [_vm._v(_vm._s(_vm.footText))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.clickOutside),
      expression: "clickOutside"
    }],
    staticClass: "country-code",
    on: {
      "click": _vm.switchMenuShow
    }
  }, [_c('div', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "country flag-icon",
    class: 'flag-icon-' + _vm.alphaCode
  }), _vm._v(" "), _c('span', {
    staticClass: "code"
  }, [_vm._v("+" + _vm._s(_vm.code))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "9px",
      "height": "9px",
      "margin-right": "-5px"
    },
    attrs: {
      "src": __webpack_require__(722)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuShow),
      expression: "menuShow"
    }],
    staticClass: "el-dropdown-menu"
  }, _vm._l((_vm.countryCode), function(country) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.selectCountry(country)
        }
      }
    }, [_vm._v("\n      " + _vm._s(country.country + ' (+' + country.code + ')') + "\n    ")])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('div', {
    staticClass: "back"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(250),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Forgot Password")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email input-view",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.forgotClick.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn_forgot",
    on: {
      "click": _vm.forgotClick
    }
  }, [_vm._v("Next")])], 1)
},staticRenderFns: []}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPC ? 'invite-error' : 'invite-error-mobile',
    attrs: {
      "id": "invite-error"
    }
  }, [_c('Icon'), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.text1))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text2))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.text3))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text4))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text5))])]), _vm._v(" "), _c('Buttons', {
    staticStyle: {
      "width": "200px",
      "margin-top": "50px"
    },
    attrs: {
      "type": 'tosignup'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    style: (_vm.imgSize),
    attrs: {
      "src": _vm.logo
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.forgotPasswordTip))]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email input-view",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.forgotClick.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn_forgot",
    on: {
      "click": _vm.forgotClick
    }
  }, [_vm._v(_vm._s(_vm.nextTip))]), _vm._v(" "), _c('Foot', {
    staticStyle: {
      "margin-top": "25px",
      "margin-bottom": "45px"
    },
    attrs: {
      "type": 'or Sign in',
      "isEmail": false
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('div', {
    staticClass: "back"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(250),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Sign up")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "username input-view",
    attrs: {
      "type": "text",
      "placeholder": "Enter your username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.signup.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email input-view",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.signup.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password input-view",
    attrs: {
      "type": "password",
      "placeholder": "Enter your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.signup.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "confirm input-view",
    attrs: {
      "type": "password",
      "placeholder": "Confirm your password"
    },
    domProps: {
      "value": (_vm.confirm)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.signup.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn_signup",
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("Sign up")]), _vm._v(" "), _c('div', {
    staticClass: "user-argreement"
  }, [_vm._v("I have read and accepted the  \"User Agreement\"")])], 1)
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Wrap')], 1)
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-switch",
    on: {
      "click": _vm.clickIcon,
      "mouseover": _vm.mouseoverIcon,
      "mouseleave": _vm.mouseleaveIcon
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-not-exist"
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'accountnotexist'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Warn', {
    attrs: {
      "type": 'accountnotexist'
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'signin',
      "data": _vm.account
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPC ? 'invite-success' : 'invite-success-mobile',
    attrs: {
      "id": "invite-success"
    }
  }, [(_vm.isPC) ? _c('Icon') : _vm._e(), _vm._v(" "), (!_vm.isPC) ? _c('Top') : _vm._e(), _vm._v(" "), _c('Iconsuccess', {
    style: ({
      marginTop: (_vm.isPC ? '30px' : '80px')
    })
  }), _vm._v(" "), (!_vm.$route.query.invitename && !_vm.$route.query.invitegroup) ? _c('p', [_vm._v(_vm._s(_vm.title3))]) : (+_vm.$route.query.invitetype === 1) ? _c('p', [_vm._v(_vm._s(_vm.title1))]) : (+_vm.$route.query.invitetype === 3) ? _c('p', [_vm._v(_vm._s(_vm.title4))]) : _c('p', [_vm._v(_vm._s(_vm.title2))]), _vm._v(" "), _c('Buttons', {
    attrs: {
      "type": 'open'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)
},staticRenderFns: []}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(706)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openAppShow),
      expression: "openAppShow"
    }],
    staticClass: "open-app",
    on: {
      "click": _vm.showApp
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./crait/scan_help.png": 693,
	"./vanish/scan_help.png": 696
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[281]);


// WEBPACK FOOTER //
// static/js/app.05fc1b6d6afc0ba205d4.js